/* ================================================================
   VCP — Vector Color Popup  (Phase 1 – Realistic Container Rig SVG)
   Full-screen popup for coloring every container zone using the
   actual Vector container rig illustration.
   Exposes: window.VectorColorPopup = { open, close, renderSummary,
            colorById, ALL_ZONE_IDS }
   ================================================================ */
(function () {
  'use strict';

  /* ================================================================
     CORDURA COLOR DATA
     ================================================================ */
  var UPT = 'https://cdn.shopify.com/s/files/1/0758/1191/4071/files/vcp-config-tool-';
  var CORDURA = [
    { id: 'black',        name: 'Black',        sc: 'BLK',   hex: '#1a1a1a', img: UPT + 'Black2-705x705.jpg' },
    { id: 'white',        name: 'White',        sc: 'WHT',   hex: '#f0f0f0', light: true, img: UPT + 'White2-705x705.jpg' },
    { id: 'smoke',        name: 'Smoke',        sc: 'SMK',   hex: '#6b6b6b', img: UPT + 'Smoke2-705x705.jpg' },
    { id: 'silver',       name: 'Silver',       sc: 'SIL',   hex: '#b0b0b0', img: UPT + 'Silver2-705x705.jpg' },
    { id: 'neon-yellow',  name: 'Neon Yellow',  sc: 'NEYL',  hex: '#e8f520', img: UPT + 'Neon-Yellow2-705x705.jpg' },
    { id: 'yellow',       name: 'Yellow',       sc: 'YEL',   hex: '#f0c808', img: UPT + 'Yellow2-705x705.jpg' },
    { id: 'gold',         name: 'Gold',         sc: 'GLD',   hex: '#c8a415', img: UPT + 'Gold2-705x705.jpg' },
    { id: 'neon-orange',  name: 'Neon Orange',  sc: 'NEOR',  hex: '#ff6b1a', img: UPT + 'Neon-Orange2-705x705.jpg' },
    { id: 'orange',       name: 'Orange',       sc: 'ORG',   hex: '#e0601a', img: UPT + 'Orange2-705x705.jpg' },
    { id: 'red',          name: 'Red',          sc: 'RED',   hex: '#cc0000', img: UPT + 'red2-705x705.jpg' },
    { id: 'neon-pink',    name: 'Neon Pink',    sc: 'NEPK',  hex: '#ff3399', img: UPT + 'Neon-Pink2-705x705.jpg' },
    { id: 'burgundy',     name: 'Burgundy',     sc: 'BUR',   hex: '#6d1a2d', img: UPT + 'Burgundy2-705x705.jpg' },
    { id: 'purple',       name: 'Purple',       sc: 'PUR',   hex: '#6a1b9a', img: UPT + 'Purple2-705x705.jpg' },
    { id: 'light-blue',   name: 'Light Blue',   sc: 'LTBL',  hex: '#63b3ed', img: UPT + 'Light-Blue2-705x705.jpg' },
    { id: 'neon-blue',    name: 'Neon Blue',    sc: 'NEBL',  hex: '#1a8cff', img: UPT + 'Neon-Blue2-705x705.jpg' },
    { id: 'royal-blue',   name: 'Royal Blue',   sc: 'RBL',   hex: '#0044cc', img: UPT + 'Royal-Blue2-705x705.jpg' },
    { id: 'navy-blue',    name: 'Navy Blue',    sc: 'NBL',   hex: '#0a1744', img: UPT + 'Navy-Blue2-705x705.jpg' },
    { id: 'teal',         name: 'Teal',         sc: 'TEL',   hex: '#178582', img: UPT + 'Teal2-705x705.jpg' },
    { id: 'neon-green',   name: 'Neon Green',   sc: 'NEGR',  hex: '#39e639', img: UPT + 'Neon-Green2-705x705.jpg' },
    { id: 'kelly-green',  name: 'Kelly Green',  sc: 'KGR',   hex: '#2a9d2a', img: UPT + 'Kelly-Green2-705x705.jpg' },
    { id: 'forest-green', name: 'Forest Green', sc: 'FGR',   hex: '#1a5c1a', img: UPT + 'Forest-Green2-705x705.jpg' },
    { id: 'olive-drab',   name: 'Olive Drab',   sc: 'OD',    hex: '#556b2f', img: UPT + 'Olive-Drab2-705x705.jpg' },
    { id: 'brown',        name: 'Brown',        sc: 'BRN',   hex: '#6b3a1f', img: UPT + 'Brown2-705x705.jpg' },
    { id: 'beige',        name: 'Beige',        sc: 'BGE',   hex: '#d4c5a9', light: true, img: UPT + 'Beige.jpg' },
    { id: 'tan',          name: 'Tan',          sc: 'TAN',   hex: '#c2a770', img: UPT + 'Tan2-705x705.jpg' },
    { id: 'coyote',       name: 'Coyote',       sc: 'COY',   hex: '#8b7355', img: UPT + 'Coyote2-705x705.jpg' }
  ];

  var SPECIALTY = [
    { id: 'woodland-camo',     name: 'Woodland Camo',        sc: 'WDL',  hex: '#4a5d23', img: UPT + 'Woodland-Camo2-705x705.jpg' },
    { id: 'desert-camo',       name: 'Desert Camo',          sc: 'DSC',  hex: '#c2a97e', img: UPT + 'Desert-Camo2-705x705.jpg' },
    { id: 'desert-digi-camo',  name: 'Desert Digi Camo',     sc: 'DDC',  hex: '#b8a88a', img: UPT + 'Desert-Digi-Camo2-705x705.jpg' },
    { id: 'marpat-desert',     name: 'MARPAT Desert',        sc: 'MPD',  hex: '#a89570', img: UPT + 'Marpat-Deser-Digi-Camo2-705x705.jpg' },
    { id: 'marpat-woodland',   name: 'MARPAT Woodland',      sc: 'MPW',  hex: '#4b5320', img: UPT + 'Marpat-Woodland-Digi2-705x705.jpg' },
    { id: 'multi-cam',         name: 'MultiCam',             sc: 'MTC',  hex: '#7c7a4e' },
    { id: 'black-multicam',    name: 'Black MultiCam',       sc: 'BMC',  hex: '#2a2a28', img: UPT + 'Black-Multicam-705x705.jpg' },
    { id: 'camo-multi',        name: 'Camo Multi',           sc: 'CMT',  hex: '#5e6b4e', img: UPT + 'camo-multi-swatch-scaled.jpg' },
    { id: 'galaxy-print',      name: 'Galaxy Print',         sc: 'GAL',  hex: '#1a0a3e', img: UPT + 'galaxy-swatch.png' },
    { id: 'kryptek-mandrake',  name: 'Kryptek Mandrake',     sc: 'KRM',  hex: '#3d5c3a', img: UPT + 'Mandrake2-705x705.jpg' },
    { id: 'kryptek-highlander',name: 'Kryptek Highlander',   sc: 'KRH',  hex: '#8a7d5a', img: UPT + 'Highlander2-705x705.jpg' },
    { id: 'kryptek-typhon',    name: 'Kryptek Typhon',       sc: 'KRT',  hex: '#2a2a2a', img: UPT + 'Typhon2-705x705.jpg' },
    { id: 'kryptek-raid',      name: 'Kryptek Raid',         sc: 'KRR',  hex: '#5a5a5a', img: UPT + 'Raid-705x705.jpg' }
  ];

  var ALL_COLORS = CORDURA.concat(SPECIALTY);

  /* ================================================================
     HARNESS WEBBING COLORS (14 colors)
     Subset of cordura solids used for harness webbing
     ================================================================ */
  var WEB = UPT;
  var HARNESS_COLORS = [
    { id: 'hw-white',       name: 'White',       hex: '#f0f0f0', light: true, img: WEB + 'webwhite-705x705.jpg' },
    { id: 'hw-black',       name: 'Black',       hex: '#1a1a1a', img: WEB + 'webblack-705x705.jpg' },
    { id: 'hw-smoke',       name: 'Smoke',       hex: '#6b6b6b', img: WEB + 'webcharc-705x705.jpg' },
    { id: 'hw-silver',      name: 'Silver',      hex: '#b0b0b0', img: WEB + 'websilver-705x705.jpg' },
    { id: 'hw-yellow',      name: 'Yellow',      hex: '#f0c808', img: WEB + 'webyellow-705x705.jpg' },
    { id: 'hw-gold',        name: 'Gold',        hex: '#c8a415', img: WEB + 'webgold-705x705.jpg' },
    { id: 'hw-orange',      name: 'Orange',      hex: '#e0601a', img: WEB + 'weborange-705x705.jpg' },
    { id: 'hw-red',         name: 'Red',         hex: '#cc0000', img: WEB + 'webred-705x705.jpg' },
    { id: 'hw-purple',      name: 'Purple',      hex: '#6a1b9a', img: WEB + 'webpurple-705x705.jpg' },
    { id: 'hw-royal-blue',  name: 'Royal Blue',  hex: '#0044cc', img: WEB + 'webroyal-705x705.jpg' },
    { id: 'hw-navy-blue',   name: 'Navy Blue',   hex: '#0a1744', img: WEB + 'webnavy-705x705.jpg' },
    { id: 'hw-olive-drab',  name: 'Olive Drab',  hex: '#556b2f', img: WEB + 'webolive-705x705.jpg' },
    { id: 'hw-tan',         name: 'Tan',         hex: '#c2a770', img: UPT + 'Tan2-705x705.jpg' },
    { id: 'hw-coyote',      name: 'Coyote',      hex: '#8b7355', img: WEB + 'webcayote-705x705.jpg' }
  ];

  /* ================================================================
     TRIM TAPE COLORS (Lavender removed from trim/piping selections)
     All cordura solids + additional trim-specific colors
     ================================================================ */
  var TRIM_COLORS = [
    { id: 'tt-black',        name: 'Black',        hex: '#1a1a1a' },
    { id: 'tt-white',        name: 'White',        hex: '#f0f0f0', light: true },
    { id: 'tt-smoke',        name: 'Smoke',        hex: '#6b6b6b' },
    { id: 'tt-silver',       name: 'Silver',       hex: '#b0b0b0' },
    { id: 'tt-neon-yellow',  name: 'Neon Yellow',  hex: '#e8f520' },
    { id: 'tt-yellow',       name: 'Yellow',       hex: '#f0c808' },
    { id: 'tt-gold',         name: 'Gold',         hex: '#c8a415' },
    { id: 'tt-neon-orange',  name: 'Neon Orange',  hex: '#ff6b1a' },
    { id: 'tt-orange',       name: 'Orange',       hex: '#e0601a' },
    { id: 'tt-red',          name: 'Red',          hex: '#cc0000' },
    { id: 'tt-neon-pink',    name: 'Neon Pink',    hex: '#ff3399' },
    { id: 'tt-fuchsia',      name: 'Fuchsia',      hex: '#ff00ff' },
    { id: 'tt-pink',         name: 'Pink',         hex: '#ffb6c1', light: true },
    { id: 'tt-burgundy',     name: 'Burgundy',     hex: '#6d1a2d' },
    { id: 'tt-purple',       name: 'Purple',       hex: '#6a1b9a' },
    { id: 'tt-sky-blue',     name: 'Sky Blue',     hex: '#87ceeb', light: true },
    { id: 'tt-light-blue',   name: 'Light Blue',   hex: '#63b3ed' },
    { id: 'tt-neon-blue',    name: 'Neon Blue',    hex: '#1a8cff' },
    { id: 'tt-royal-blue',   name: 'Royal Blue',   hex: '#0044cc' },
    { id: 'tt-navy-blue',    name: 'Navy Blue',    hex: '#0a1744' },
    { id: 'tt-teal',         name: 'Teal',         hex: '#178582' },
    { id: 'tt-neon-green',   name: 'Neon Green',   hex: '#39e639' },
    { id: 'tt-kelly-green',  name: 'Kelly Green',  hex: '#2a9d2a' },
    { id: 'tt-forest-green', name: 'Forest Green', hex: '#1a5c1a' },
    { id: 'tt-olive-drab',   name: 'Olive Drab',   hex: '#556b2f' },
    { id: 'tt-brown',        name: 'Brown',        hex: '#6b3a1f' },
    { id: 'tt-tan',          name: 'Tan',          hex: '#c2a770' },
    { id: 'tt-coyote',       name: 'Coyote',       hex: '#8b7355' }
  ];

  /* ================================================================
     EMBROIDERY THREAD COLORS (28 colors)
     All solid colors for custom name/logo embroidery (no camo)
     ================================================================ */
  var EMBROIDERY_COLORS = [
    { id: 'em-black',        name: 'Black',        hex: '#1a1a1a' },
    { id: 'em-white',        name: 'White',        hex: '#f0f0f0', light: true },
    { id: 'em-smoke',        name: 'Smoke',        hex: '#6b6b6b' },
    { id: 'em-silver',       name: 'Silver',       hex: '#b0b0b0' },
    { id: 'em-neon-yellow',  name: 'Neon Yellow',  hex: '#e8f520' },
    { id: 'em-yellow',       name: 'Yellow',       hex: '#f0c808' },
    { id: 'em-gold',         name: 'Gold',         hex: '#c8a415' },
    { id: 'em-neon-orange',  name: 'Neon Orange',  hex: '#ff6b1a' },
    { id: 'em-orange',       name: 'Orange',       hex: '#e0601a' },
    { id: 'em-red',          name: 'Red',          hex: '#cc0000' },
    { id: 'em-neon-pink',    name: 'Neon Pink',    hex: '#ff3399' },
    { id: 'em-fuchsia',      name: 'Fuchsia',      hex: '#ff00ff' },
    { id: 'em-pink',         name: 'Pink',         hex: '#ffb6c1', light: true },
    { id: 'em-burgundy',     name: 'Burgundy',     hex: '#6d1a2d' },
    { id: 'em-purple',       name: 'Purple',       hex: '#6a1b9a' },
    { id: 'em-lavender',     name: 'Lavender',     hex: '#b57edc' },
    { id: 'em-sky-blue',     name: 'Sky Blue',     hex: '#87ceeb', light: true },
    { id: 'em-light-blue',   name: 'Light Blue',   hex: '#63b3ed' },
    { id: 'em-neon-blue',    name: 'Neon Blue',    hex: '#1a8cff' },
    { id: 'em-royal-blue',   name: 'Royal Blue',   hex: '#0044cc' },
    { id: 'em-navy-blue',    name: 'Navy Blue',    hex: '#0a1744' },
    { id: 'em-teal',         name: 'Teal',         hex: '#178582' },
    { id: 'em-neon-green',   name: 'Neon Green',   hex: '#39e639' },
    { id: 'em-kelly-green',  name: 'Kelly Green',  hex: '#2a9d2a' },
    { id: 'em-forest-green', name: 'Forest Green', hex: '#1a5c1a' },
    { id: 'em-olive-drab',   name: 'Olive Drab',   hex: '#556b2f' },
    { id: 'em-brown',        name: 'Brown',        hex: '#6b3a1f' },
    { id: 'em-tan',          name: 'Tan',          hex: '#c2a770' },
    { id: 'em-coyote',       name: 'Coyote',       hex: '#8b7355' }
  ];

  /* Active material type (for tab switching) */
  var activeMaterial = 'cordura';

  /* All color arrays combined for lookup */
  var MASTER_COLORS = ALL_COLORS.concat(HARNESS_COLORS, TRIM_COLORS, EMBROIDERY_COLORS);

  function colorById(id) {
    for (var i = 0; i < MASTER_COLORS.length; i++) {
      if (MASTER_COLORS[i].id === id) return MASTER_COLORS[i];
    }
    return ALL_COLORS[0];
  }

  /* ── Trim auto-match: find closest TRIM_COLOR for a given cordura color ── */
  var _trimById = {};
  TRIM_COLORS.forEach(function(c) { _trimById[c.id] = c; });

  function hexToRgb(hex) {
    var h = hex.replace('#', '');
    return [parseInt(h.substring(0,2),16), parseInt(h.substring(2,4),16), parseInt(h.substring(4,6),16)];
  }

  function findClosestTrimColor(corduraColorId) {
    // 1. Direct name match (covers ~24 of 27 trim colors)
    var directId = 'tt-' + corduraColorId;
    if (_trimById[directId]) return _trimById[directId].id;
    // 2. Hex-distance fallback for specialty/camo colors
    var src = colorById(corduraColorId);
    if (!src) return 'tt-black';
    var srcRgb = hexToRgb(src.hex);
    var bestId = 'tt-black';
    var bestDist = Infinity;
    for (var i = 0; i < TRIM_COLORS.length; i++) {
      var t = TRIM_COLORS[i];
      var tRgb = hexToRgb(t.hex);
      var dr = srcRgb[0] - tRgb[0], dg = srcRgb[1] - tRgb[1], db = srcRgb[2] - tRgb[2];
      var dist = dr*dr + dg*dg + db*db;
      if (dist < bestDist) { bestDist = dist; bestId = t.id; }
    }
    return bestId;
  }

  var TRIM_PARENT_FALLBACK = { 'c2b': 'c2', 'c4b': 'c4' };

  function syncTrimToParentZones() {
    if (!state || !state.colorMap) return; // Not initialised yet
    TRIM_ZONES.forEach(function(tid) {
      var parent = TRIM_PARENT_MAP[tid];
      var corduraColor = parent ? state.colorMap[parent] : undefined;
      if (!corduraColor && parent && TRIM_PARENT_FALLBACK[parent]) {
        corduraColor = state.colorMap[TRIM_PARENT_FALLBACK[parent]];
      }
      if (!corduraColor) corduraColor = 'black';
      state.colorMap['trim:' + tid] = findClosestTrimColor(corduraColor);
      if (typeof updateZoneFill === 'function') updateZoneFill(tid);
    });
  }

  /* ================================================================
     ZONE DEFINITIONS — IDs matching the container rig SVG paths
     Grouped by material type for future phase support.
     ================================================================ */

  // Cordura (main container fabric) zones
  var CORDURA_ZONES = [
    'backp',                           // back pad
    'c1a', 'c1b', 'c1c',              // main body panels
    'c2',                              // yoke panel
    'c3a', 'c3b',                      // upper sidewall panels
    'c4',                              // belly band
    'c5a', 'c5b',                      // lower sidewall panels
    'c6a', 'c6b',                      // lateral panels
    'c7a', 'c7b', 'c7c',              // reserve container panels
    'c8a', 'c8b',                      // reserve container lower
    'c1astab', 'c1bstab',             // stabilizers
    'lpad', 'rpad',                    // leg pads
    'hcut', 'hres'                     // cutaway + reserve handles
  ];

  // Center flap zones (visible with certain patterns)
  var FLAP_ZONES = ['cfa', 'cfb', 'cfc', 'cfd', 'cfe', 'cff', 'cfg'];

  // Trim tape zones (Phase 4)
  var TRIM_ZONES = [
    't1a', 't1b', 't2a', 't2b', 't3a', 't3b', 't4a', 't4b',
    't6a', 't6b', 't7',
    't8atop', 't8abot', 't8aside1', 't8aside2',
    't8btop', 't8bbot', 't8bside1', 't8bside2',
    'tstab', 'tlegr', 'tlegl'
  ];

  // Trim → parent cordura panel mapping (for dynamic trim grouping)
  var TRIM_PARENT_MAP = {
    't1a':'c1a', 't1b':'c1b', 't2a':'c2', 't2b':'c2b',
    't3a':'c3a', 't3b':'c3b', 't4a':'c4', 't4b':'c4b',
    't6a':'c6a', 't6b':'c6b', 't7':'c7c',
    't8atop':'c8a', 't8abot':'c8a', 't8aside1':'c8a', 't8aside2':'c8a',
    't8btop':'c8b', 't8bbot':'c8b', 't8bside1':'c8b', 't8bside2':'c8b',
    'tstab':'c1astab', 'tlegr':'rpad', 'tlegl':'lpad'
  };

  // Harness zone (Phase 4)
  var HARNESS_ZONES = ['harness'];

  // Piping zones (center flap piping)
  var PIPING_ZONES = ['pb', 'pc', 'pd', 'pe', 'pf', 'pg'];
  var PIPING_ZONE_NAMES = {
    pb: 'Pip B', pc: 'Pip C', pd: 'Pip D', pe: 'Pip E', pf: 'Pip F', pg: 'Pip G'
  };

  // JC (Joint Cover) stitching — panels that get crosshatch overlay
  var JC_STITCH_ZONES = [
    'c1a', 'c1b', 'c3a', 'c3b', 'c6a', 'c6b',
    'cfa', 'cfb', 'cfc', 'cfe', 'cff', 'cfg'
  ];

  /* ================================================================
     EMBROIDERY POSITIONS (Phase 5)
     Positions where custom name/logo embroidery can be placed
     ================================================================ */
  // Embroidery positions - IDs match VOS SVG group IDs
  // Each position has a viewBox for cropping the full SVG to show just that area
  var EMBROIDERY_POSITIONS = [
    { id: 'yoke', svgId: 'yoke', label: 'Yoke', shortLabel: 'YOKE', desc: 'Upper yoke panel behind neck', viewBox: '50 15 620 385' },
    { id: 'rcovers', svgId: 'rcovers', label: 'Ring Covers', shortLabel: 'RING COVERS', desc: 'Left and right riser covers', viewBox: '50 15 620 385' },
    { id: 'swalls', svgId: 'swalls', label: 'Side Walls', shortLabel: 'SIDE WALLS', desc: 'Left and right side panels', viewBox: '50 15 620 385' },
    { id: 'handles', svgId: 'handles', label: 'Handles', shortLabel: 'HANDLES', desc: 'Cutaway and reserve handles', viewBox: '50 15 620 385' },
    { id: 'backpad', svgId: 'backpad', label: 'Backpad', shortLabel: 'BACKPAD', desc: 'Main backpad area', viewBox: '50 15 620 385' },
    { id: 'reserveflap', svgId: 'reserveflap', label: 'Reserve Flap', shortLabel: 'RESERVE FLAP', desc: 'Reserve container flap', viewBox: '50 15 620 385' }
  ];

  // Simplified SVG icons for embroidery positions (used as fallback or quick preview)
  var EMBROIDERY_ICONS = {
    yoke: '<svg viewBox="0 0 100 80" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="10" width="80" height="60" rx="8" fill="#f0f0f0" stroke="#333" stroke-width="2"/><path d="M20 25 Q50 10 80 25 L75 35 Q50 22 25 35 Z" fill="#0891b2" opacity="0.7"/><text x="50" y="55" text-anchor="middle" font-size="10" fill="#333" font-weight="bold">YOKE</text></svg>',
    rcovers: '<svg viewBox="0 0 100 80" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="10" width="80" height="60" rx="8" fill="#f0f0f0" stroke="#333" stroke-width="2"/><rect x="15" y="20" width="15" height="40" rx="3" fill="#0891b2" opacity="0.7"/><rect x="70" y="20" width="15" height="40" rx="3" fill="#0891b2" opacity="0.7"/><text x="50" y="55" text-anchor="middle" font-size="8" fill="#333" font-weight="bold">RING COVERS</text></svg>',
    swalls: '<svg viewBox="0 0 100 80" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="10" width="80" height="60" rx="8" fill="#f0f0f0" stroke="#333" stroke-width="2"/><rect x="12" y="25" width="18" height="30" fill="#0891b2" opacity="0.7"/><rect x="70" y="25" width="18" height="30" fill="#0891b2" opacity="0.7"/><text x="50" y="55" text-anchor="middle" font-size="8" fill="#333" font-weight="bold">SIDE WALLS</text></svg>',
    handles: '<svg viewBox="0 0 100 80" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="10" width="80" height="60" rx="8" fill="#f0f0f0" stroke="#333" stroke-width="2"/><rect x="20" y="25" width="12" height="25" rx="2" fill="#ff6b6b" opacity="0.8"/><rect x="68" y="25" width="12" height="25" rx="2" fill="#ffd93d" opacity="0.8"/><text x="50" y="62" text-anchor="middle" font-size="8" fill="#333" font-weight="bold">HANDLES</text></svg>',
    backpad: '<svg viewBox="0 0 100 80" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="10" width="80" height="60" rx="8" fill="#f0f0f0" stroke="#333" stroke-width="2"/><rect x="25" y="18" width="50" height="40" rx="5" fill="#0891b2" opacity="0.7"/><text x="50" y="68" text-anchor="middle" font-size="8" fill="#333" font-weight="bold">BACKPAD</text></svg>',
    reserveflap: '<svg viewBox="0 0 100 80" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="10" width="80" height="60" rx="8" fill="#f0f0f0" stroke="#333" stroke-width="2"/><path d="M25 15 L75 15 L70 50 L30 50 Z" fill="#0891b2" opacity="0.7"/><text x="50" y="65" text-anchor="middle" font-size="7" fill="#333" font-weight="bold">RESERVE FLAP</text></svg>'
  };

  // VOS embroidery SVG URL
  var EMBROIDERY_SVG_URL = null; // Will be set from Shopify asset URL

  // Track currently selected embroidery position
  var selectedEmbroideryPosition = 'yoke';

  // Embroidery SVG element reference
  var embroiderySvgDoc = null;

  /* ================================================================
     EMBROIDERY LOGO OPTIONS
     Based on UPT VOS system - Vector V3HD logos, Micron logos, custom options
     ================================================================ */
  var EMBROIDERY_LOGOS = [
    // Vector V3HD Logos
    { id: 'v3hd', name: 'Vector V3HD', category: 'vector', colors: 2, symbols: ['v3hd_c1', 'v3hd_c2'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'msv3', name: 'MS Vector 3', category: 'vector', colors: 2, symbols: ['msv3_c1', 'msv3_c2'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'v3hd_r', name: 'Vector V3HD Round', category: 'vector', colors: 2, symbols: ['v3hd_r_c1', 'v3hd_r_c2'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'v3hd2_r', name: 'Vector V3HD2 Round', category: 'vector', colors: 1, symbols: ['v3hd2_r_c1'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'v3hd_large', name: 'Vector V3HD Large', category: 'vector', colors: 3, symbols: ['v3hd_large_c1', 'v3hd_large_c2', 'vrhd_large_c3'], positions: ['backpad', 'reserveflap'] },
    { id: 'v3hd_outline_s', name: 'Vector Outline Straight', category: 'vector', colors: 4, symbols: ['v3hd_outline_s_c1', 'v3hd_outline_s_c2', 'v3hd_outline_s_c3', 'v3hd_outline_s_c4'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'v3hd_outline_r', name: 'Vector Outline Round', category: 'vector', colors: 3, symbols: ['v3hd_outline_r_c1', 'v3hd_outline_r_c2', 'v3hd_outline_r_c3'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },

    // Micron Logos
    { id: 'mia', name: 'Micron', category: 'micron', colors: 1, symbols: ['mia_c1'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'mi', name: 'Micron (2 Color)', category: 'micron', colors: 2, symbols: ['mi_c1', 'mi_c2'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'mi_outline', name: 'Micron Outline', category: 'micron', colors: 3, symbols: ['mi_outline_c1', 'mi_outline_c2', 'mi_outline_c3'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },

    // WonderHog Logos
    { id: 'who', name: 'WonderHog', category: 'wonderhog', colors: 1, symbols: ['who_c1'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'who2', name: 'WonderHog 2', category: 'wonderhog', colors: 2, symbols: ['who2_c1', 'who2_c2'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'whc', name: 'WonderHog Classic', category: 'wonderhog', colors: 6, symbols: ['whc_c1', 'whc_c2', 'whc_c3', 'whc_c4', 'whc_c5', 'whc_c6'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },

    // Other Logos
    { id: '3r', name: '3 Ring', category: 'other', colors: 1, symbols: ['3r_c1'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'se_s', name: 'SE Straight', category: 'other', colors: 1, symbols: ['se_s_c1'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'se_r', name: 'SE Round', category: 'other', colors: 1, symbols: ['se_r_c1'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'sg_s', name: 'SG Straight', category: 'other', colors: 2, symbols: ['sg_s_c1', 'sg_s_c2'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'msg_s', name: 'MSG Straight', category: 'other', colors: 3, symbols: ['msg_s_c1', 'msg_s_c2', 'msg_s_c3'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },

    // D-Handle Logos (handles only)
    { id: 'Dhand', name: 'D-Handle', category: 'handle', colors: 1, symbols: ['Dhand'], positions: ['handles'] },
    { id: 'Dhand2', name: 'D-Handle 2', category: 'handle', colors: 1, symbols: ['Dhand2'], positions: ['handles'] },
    { id: 'Dhandle', name: 'D-Handle Full', category: 'handle', colors: 1, symbols: ['Dhandle'], positions: ['handles'] },
    { id: 'miniD', name: 'Mini D-Handle', category: 'handle', colors: 1, symbols: ['miniD'], positions: ['handles'] },
    { id: 'miniD2', name: 'Mini D-Handle 2', category: 'handle', colors: 1, symbols: ['miniD2'], positions: ['handles'] },
    { id: 'miniDh', name: 'Mini D-Handle Full', category: 'handle', colors: 1, symbols: ['miniDh'], positions: ['handles'] },
    { id: 'd3spacer', name: 'D3 Spacer', category: 'handle', colors: 1, symbols: ['d3spacer'], positions: ['handles'] },

    // Custom Logo Placeholders
    { id: 'custom_s', name: 'Custom Logo (Straight)', category: 'custom', colors: 1, symbols: ['custom_logo_s_c1'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'custom_r', name: 'Custom Logo (Round)', category: 'custom', colors: 1, symbols: ['custom_logo_r_c1'], positions: ['yoke', 'rcovers', 'swalls', 'backpad', 'reserveflap'] },
    { id: 'custom_h', name: 'Custom Logo (Handle)', category: 'custom', colors: 1, symbols: ['custom_logo_h_c1'], positions: ['handles'] },

    // Custom Name (text-based, no symbols)
    { id: 'custom-name', name: 'Custom Name', category: 'text', colors: 1, symbols: [], positions: ['yoke', 'rcovers', 'swalls', 'handles', 'backpad', 'reserveflap'] }
  ];

  // Logo SVG element ID patterns for each position
  // format: col{N}_{posPrefix} where N=1-15 for color layers
  var LOGO_POSITION_PREFIXES = {
    'yoke': 'yk',
    'rcovers': 'rc',         // also 'rcr' for right side
    'swalls': 'sw',          // also 'swr' for right side, 'sw45'/'swr45' for 45° angle
    'handles': 'hres',       // also 'hcut' for cutaway handle
    'backpad': 'bp',
    'reserveflap': 'rf'
  };

  // Logo groups in the embroidery SVG
  var LOGO_GROUP_IDS = {
    'yoke': 'logoyk',
    'rcovers': 'logorc',
    'swalls': 'logosw',
    'handles': 'logoHandles',
    'backpad': 'bplogos',
    'reserveflap': 'logorf'     // Note: it's inside maskrf clip path
  };

  // Default embroidery option for a position (legacy - kept for backward compat)
  function defaultEmbroideryOption() {
    return {
      type: 'none',
      logoId: '',
      text: '',
      textLine2: '',
      textLine3: '',
      font: 'block',
      color: 'em-black',
      color2: 'em-white',
      color3: 'em-gold',
      color4: 'em-red',
      color5: 'em-navy',
      color6: 'em-silver',
      customLogoFile: null,
      angle45: false
    };
  }

  /* ================================================================
     EMBROIDERY V2 — Per-side logo definitions (from test-embroidery-v2)
     Each position-side has its own array of available logos.
     ================================================================ */
  var EMB_LOGOS = {
    yk: [
      { name: 'mi_yh', colors: 2, symbol: 'mi' },
      { name: 'v3hd_yh', colors: 2, symbol: 'v3hd' }
    ],
    sw: [
      { name: 'none', colors: 0, symbol: '' },
      { name: 'custom_name_s', colors: 1, symbol: '', isCustomName: true },
      { name: 'custom_logo_s', colors: 0, symbol: '', isCustomLogo: true },
      { name: 'mi_outline_s', colors: 3, symbol: 'mi_outline' },
      { name: 'mi_s', colors: 2, symbol: 'mi' },
      { name: 'msv3_s', colors: 2, symbol: 'msv3' },
      { name: 'v3hd_outline_s', colors: 4, symbol: 'v3hd_outline_s' },
      { name: 'v3hd_s', colors: 2, symbol: 'v3hd' }
    ],
    swr: [
      { name: 'none', colors: 0, symbol: '' },
      { name: 'custom_name_s', colors: 1, symbol: '', isCustomName: true },
      { name: 'custom_logo_s', colors: 0, symbol: '', isCustomLogo: true },
      { name: 'mi_outline_s', colors: 3, symbol: 'mi_outline' },
      { name: 'mi_s', colors: 2, symbol: 'mi' },
      { name: 'msv3_s', colors: 2, symbol: 'msv3' },
      { name: 'v3hd_outline_s', colors: 4, symbol: 'v3hd_outline_s' },
      { name: 'v3hd_s', colors: 2, symbol: 'v3hd' }
    ],
    rc: [
      { name: 'custom_name_r', colors: 1, symbol: '', isCustomName: true },
      { name: 'none', colors: 0, symbol: '' },
      { name: 'custom_logo_r', colors: 0, symbol: '', isCustomLogo: true },
      { name: 'whcl_r', colors: 6, symbol: 'whc' },
      { name: 'whcr_r', colors: 6, symbol: 'whc' },
      { name: 'whol2_r', colors: 2, symbol: 'who2' },
      { name: 'whor2_r', colors: 2, symbol: 'who2' },
      { name: 'whol_r', colors: 1, symbol: 'who' },
      { name: 'whor_r', colors: 1, symbol: 'who' },
      { name: 'mia_r', colors: 1, symbol: 'mia' },
      { name: 'v3hd2_r', colors: 1, symbol: 'v3hd2_r' },
      { name: 'v3hd_outline_r', colors: 3, symbol: 'v3hd_outline_r' },
      { name: 'v3hd_r', colors: 2, symbol: 'v3hd_r' },
      { name: '3r_r', colors: 1, symbol: '3r' }
    ],
    rcr: [
      { name: 'custom_name_r', colors: 1, symbol: '', isCustomName: true },
      { name: 'none', colors: 0, symbol: '' },
      { name: 'custom_logo_r', colors: 0, symbol: '', isCustomLogo: true },
      { name: 'whcl_r', colors: 6, symbol: 'whc' },
      { name: 'whcr_r', colors: 6, symbol: 'whc' },
      { name: 'whol2_r', colors: 2, symbol: 'who2' },
      { name: 'whor2_r', colors: 2, symbol: 'who2' },
      { name: 'whol_r', colors: 1, symbol: 'who' },
      { name: 'whor_r', colors: 1, symbol: 'who' },
      { name: 'mia_r', colors: 1, symbol: 'mia' },
      { name: 'v3hd2_r', colors: 1, symbol: 'v3hd2_r' },
      { name: 'v3hd_outline_r', colors: 3, symbol: 'v3hd_outline_r' },
      { name: 'v3hd_r', colors: 2, symbol: 'v3hd_r' },
      { name: '3r_r', colors: 1, symbol: '3r' }
    ],
    hcut: [
      { name: 'none', colors: 0, symbol: '' },
      { name: '3r_r', colors: 1, symbol: '3r' },
      { name: 'v3hd_yh', colors: 2, symbol: 'v3hd' },
      { name: 'mi_yh', colors: 2, symbol: 'mi' },
      { name: 'mia_r', colors: 1, symbol: 'mia' },
      { name: 'custom_logo_yh', colors: 0, symbol: '', isCustomLogo: true },
      { name: 'custom_name_yh', colors: 1, symbol: '', isCustomName: true }
    ],
    hres: [
      { name: 'none', colors: 0, symbol: '' },
      { name: '3r_r', colors: 1, symbol: '3r' },
      { name: 'v3hd_yh', colors: 2, symbol: 'v3hd' },
      { name: 'mi_yh', colors: 2, symbol: 'mi' },
      { name: 'mia_r', colors: 1, symbol: 'mia' },
      { name: 'custom_logo_yh', colors: 0, symbol: '', isCustomLogo: true },
      { name: 'custom_name_yh', colors: 1, symbol: '', isCustomName: true }
    ],
    bp: [
      { name: 'none', colors: 0, symbol: '' },
      { name: '3r_r', colors: 1, symbol: '3r' },
      { name: 'v3hd_r', colors: 2, symbol: 'v3hd_r' },
      { name: 'v3hd_outline_r', colors: 3, symbol: 'v3hd_outline_r' },
      { name: 'v3hd2_r', colors: 1, symbol: 'v3hd2_r' },
      { name: 'mia_r', colors: 1, symbol: 'mia' },
      { name: 'whor_r', colors: 1, symbol: 'who' },
      { name: 'whol_r', colors: 1, symbol: 'who' },
      { name: 'whor2_r', colors: 2, symbol: 'who2' },
      { name: 'whol2_r', colors: 2, symbol: 'who2' },
      { name: 'whcr_r', colors: 6, symbol: 'whc' },
      { name: 'whcl_r', colors: 6, symbol: 'whc' },
      { name: 'custom_logo_r', colors: 0, symbol: '', isCustomLogo: true },
      { name: 'custom_name_r', colors: 1, symbol: '', isCustomName: true }
    ],
    rf: [
      { name: 'none', colors: 0, symbol: '' },
      { name: 'v3hd_large', colors: 2, symbol: 'v3hd_large', specialSymbols: ['v3hd_large_c1', 'v3hd_large_c2'] },
      { name: 'whor_large', colors: 1, symbol: 'who' },
      { name: 'whor2_large', colors: 2, symbol: 'who2' },
      { name: 'custom_logo_r', colors: 0, symbol: '', isCustomLogo: true },
      { name: 'custom_name_r', colors: 1, symbol: '', isCustomName: true }
    ]
  };

  /* Custom position transforms for text and custom logos */
  var EMB_CUSTOM_TRANSFORMS = {
    custom_name: {
      sw:   { x: 420, y: 350, x45: 344, y45: 301, angle: -35, hasAngleOption: true },
      swr:  { x: 230, y: 162, x45: 290, y45: 121, angle: 35, hasAngleOption: true },
      rc:   { x: 548, y: 180, lines: 3, lineHeight: 22 },
      rcr:  { x: 183, y: 180, lines: 3, lineHeight: 22 },
      bp:   { x: 312, y: 200, angle: 0, lines: 3 },
      rf:   { x: 363, y: 230, angle: 0, lines: 3 },
      hcut: { x: 190, y: 200, angle: -75 },
      hres: { x: 552, y: 200, angle: -105 }
    },
    custom_logo: {
      sw:   { width: 200, height: 54, x: 298, y: 277, x45: 253, y45: 273, angle: -35, hasAngleOption: true },
      swr:  { width: 200, height: 54, x: 94, y: 101, x45: 153, y45: 72, angle: 27, hasAngleOption: true },
      rc:   { width: 100, height: 100, x: 493, y: 145, angle: 0 },
      rcr:  { width: 100, height: 100, x: 134, y: 145, angle: 0 },
      bp:   { width: 150, height: 150, x: 237, y: 125, angle: 0 },
      rf:   { width: 100, height: 100, x: 313, y: 180, angle: 0 },
      hcut: { width: 200, height: 70, x: 90, y: 165, angle: -75 },
      hres: { width: 200, height: 70, x: 452, y: 165, angle: -105 }
    }
  };

  /* Font sizes and max chars per position (for custom name auto-sizing) */
  var EMB_FONT_SIZES = { sw: 38, swr: 38, rc: 40, rcr: 40, bp: 60, rf: 40, hcut: 45, hres: 45 };
  var EMB_MAX_CHARS  = { sw: 10, swr: 10, rc: 6, rcr: 6, bp: 8, rf: 7, hcut: 10, hres: 10 };

  /* Position sides mapping (which sides belong to each embroidery position) */
  var POSITION_SIDES = {
    yoke: ['yk'],
    swalls: ['swr', 'sw'],
    rcovers: ['rc', 'rcr'],
    handles: ['hcut', 'hres'],
    backpad: ['bp'],
    reserveflap: ['rf']
  };

  /* Human-readable labels for each side */
  var SIDE_LABELS = {
    yk: 'Yoke Logo',
    sw: 'Left Side Wall', swr: 'Right Side Wall',
    rc: 'Left Ring Cover', rcr: 'Right Ring Cover',
    hcut: 'Cutaway Handle', hres: 'Reserve Handle',
    bp: 'Back Pad',
    rf: 'Reserve Cover Flap'
  };

  /* Price info per side (EUR) */
  var SIDE_PRICES = {
    sw: '+\u20AC39,00', swr: '+\u20AC39,00',
    rc: '+\u20AC24,00', rcr: '+\u20AC24,00',
    hcut: '+\u20AC24,00', hres: '+\u20AC24,00',
    bp: '+\u20AC24,00',
    rf: '+\u20AC39,00'
  };

  /* Panel color buttons per position — maps to container SVG zone IDs */
  /* Logo transforms (loaded from logo-transforms.json) */
  var LOGO_TRANSFORMS = null;

  /* Side wall 45° angle configuration (fixed rotation centers) */
  var ANGLE45_CONFIG = {
    sw:  { center: { x: 350, y: 300 }, offset: { dx: -50, dy: 0 } },
    swr: { center: { x: 180, y: 80  }, offset: { dx: 44, dy: -70 } }
  };

  /* Rig embroidery VArray transforms — from the original UPT VOS tool.
     These are direct SVG matrix transforms for positioning logos on the rig SVG (960x400).
     Each layer's transform encodes position, scale, AND rotation — no bounding box calc needed. */
  var RIG_VARRAY_TRANSFORMS = {
    yk: [
      { name: 'v3hd_yh', sym: 'v3hd', layers: [
        { w: 485.54, h: 88.578, x: -242.77, y: -44.289, t: '0.082 0 0 -0.082 120.0552 49.7856' },
        { w: 312.556, h: 55.099, x: -156.278, y: -27.55, t: '0.082 0 0 -0.0819 115.1743 48.71' }
      ]},
      { name: 'mi_yh', sym: 'mi', layers: [
        { w: 267.306, h: 28.526, x: -133.653, y: -14.263, t: '0.1488 0 0 -0.1488 119.8003 48.9961' },
        { w: 35.291, h: 21.085, x: -17.645, y: -10.542, t: '0.1488 0 0 -0.1488 129.2056 48.9932' }
      ]}
    ],
    sw: [
      { name: 'v3hd_s', sym: 'v3hd', layers: [
        { w: 485.54, h: 88.578, x: -242.77, y: -44.289, t: '-1.083118e-08 0.2478 0.2478 1.083118e-08 879.5029 224.5791' },
        { w: 312.556, h: 55.099, x: -156.278, y: -27.55, t: '-1.083302e-08 0.2478 0.2477 1.082612e-08 882.7539 209.8262' }
      ]},
      { name: 'v3hd_outline_s', sym: 'v3hd_outline_s', layers: [
        { w: 485.541, h: 88.58, x: 0.45, y: -91.8, t: '-1.079652e-08 0.247 0.247 1.079652e-08 889.876 164.9014' },
        { w: 265.347, h: 50.74, x: 0, y: -50.75, t: '-2.000567e-08 0.4577 0.4577 2.000567e-08 889.6484 163.9863' },
        { w: 51.5, h: 55.1, x: 27.5, y: -62.05, t: '-1.079499e-08 0.247 0.2469 1.079286e-08 889.8994 164.8789' },
        { w: 56.85, h: 42.95, x: -9.887, y: -36.76, t: '-1.086368e-08 0.2485 0.2485 1.086368e-08 882.8506 239.709' }
      ]},
      { name: 'msv3_s', sym: 'msv3', layers: [
        { w: 709.95, h: 87.82, x: 2.05, y: -55.95, t: '-7.451258e-09 0.1705 0.1705 7.451258e-09 883.4111 163.8398' },
        { w: 45.95, h: 50.3, x: 66.15, y: -66, t: '-7.451258e-09 0.1705 0.1705 7.451258e-09 887.8379 156.915' }
      ]},
      { name: 'mi_s', sym: 'mi', layers: [
        { w: 267.306, h: 28.526, x: -133.653, y: -14.263, t: '-1.986414e-08 0.4544 0.4544 1.986414e-08 880.21 224.3936' },
        { w: 35.292, h: 21.086, x: -17.646, y: -10.543, t: '-1.986327e-08 0.4544 0.4544 1.986327e-08 880.2188 253.1143' }
      ]},
      { name: 'mi_outline_s', sym: 'mi_outline', layers: [
        { w: 281.8, h: 28.502, x: 0, y: -28.5, t: '-1.877362e-08 0.4295 0.4295 1.877362e-08 886.4717 164.1099' },
        { w: 35.29, h: 21.086, x: 0, y: -21.062, t: '-1.877362e-08 0.4295 0.4295 1.877362e-08 884.8613 246.0137' },
        { w: 285.051, h: 31.752, x: -1.625, y: -30.125, t: '-1.877362e-08 0.4295 0.4295 1.877362e-08 886.4717 164.1099' }
      ]}
    ],
    swr: [
      { name: 'v3hd_s', sym: 'v3hd', layers: [
        { w: 485.54, h: 88.578, x: -242.77, y: -44.289, t: '-1.083218e-08 -0.2478 -0.2478 1.083218e-08 588 224.5801' },
        { w: 312.556, h: 55.099, x: -156.278, y: -27.55, t: '-1.083036e-08 -0.2478 -0.2477 1.082852e-08 584.749 239.333' }
      ]},
      { name: 'v3hd_outline_s', sym: 'v3hd_outline_s', layers: [
        { w: 485.541, h: 88.58, x: 0.45, y: -91.8, t: '3.238956e-08 -0.247 -0.247 -3.238956e-08 576.1709 283.9434' },
        { w: 265.347, h: 50.74, x: 0, y: -50.75, t: '6.001702e-08 -0.4577 -0.4577 -6.001702e-08 576.3984 284.8584' },
        { w: 51.5, h: 55.1, x: 27.5, y: -62.05, t: '3.238498e-08 -0.247 -0.2469 -3.237857e-08 576.1475 283.9658' },
        { w: 56.85, h: 42.95, x: -9.887, y: -36.76, t: '3.259103e-08 -0.2485 -0.2485 -3.259103e-08 583.1963 209.1357' }
      ]},
      { name: 'msv3_s', sym: 'msv3', layers: [
        { w: 709.95, h: 87.82, x: 2.05, y: -55.95, t: '2.235378e-08 -0.1705 -0.1705 -2.235378e-08 582.0703 284.9551' },
        { w: 45.95, h: 50.3, x: 66.15, y: -66, t: '2.235378e-08 -0.1705 -0.1705 -2.235378e-08 577.6436 291.8799' }
      ]},
      { name: 'mi_s', sym: 'mi', layers: [
        { w: 267.306, h: 28.526, x: -133.653, y: -14.263, t: '5.959241e-08 -0.4544 -0.4544 -5.959241e-08 586.21 223.3926' },
        { w: 35.292, h: 21.086, x: -17.646, y: -10.543, t: '5.958982e-08 -0.4544 -0.4544 -5.958982e-08 586.2012 194.6719' }
      ]},
      { name: 'mi_outline_s', sym: 'mi_outline', layers: [
        { w: 281.8, h: 28.502, x: 0, y: -28.5, t: '-1.877362e-08 -0.4295 -0.4295 1.877362e-08 579.7979 284.1387' },
        { w: 35.29, h: 21.086, x: 0, y: -21.062, t: '-1.877362e-08 -0.4295 -0.4295 1.877362e-08 581.4082 202.2354' },
        { w: 285.051, h: 31.752, x: -1.625, y: -30.125, t: '-1.877362e-08 -0.4295 -0.4295 1.877362e-08 579.7979 284.1387' }
      ]}
    ],
    rc: [
      { name: '3r_r', sym: '3r', layers: [
        { w: 107.886, h: 187.625, x: 0.017, y: -187.605, t: '0.1751 0 0 -0.1751 404.9521 107.9731' }
      ]},
      { name: 'v3hd_r', sym: 'v3hd_r', layers: [
        { w: 148.595, h: 87.77, x: 0, y: -87.7, t: '0.2417 0 0 -0.2417 393.5977 113.0532' },
        { w: 45.913, h: 50.325, x: -0.017, y: -50.326, t: '0.2417 0 0 -0.2417 399.2529 118.2495' }
      ]},
      { name: 'v3hd_outline_r', sym: 'v3hd_outline_r', layers: [
        { w: 148.617, h: 87.753, x: -0.016, y: -87.689, t: '0.2385 0 0 -0.2385 394.2627 113.3008' },
        { w: 151.936, h: 91.056, x: 0.025, y: -91.05, t: '0.2385 0 0 -0.2385 393.8462 112.9072' },
        { w: 45.911, h: 50.323, x: -0.021, y: -50.32, t: '0.2385 0 0 -0.2385 399.8433 118.4282' }
      ]},
      { name: 'v3hd2_r', sym: 'v3hd2_r', layers: [
        { w: 148.789, h: 87.82, x: 0, y: -87.7, t: '0.2371 0 0 -0.2371 393.8794 113.1929' }
      ]},
      { name: 'mia_r', sym: 'mia', layers: [
        { w: 35.292, h: 21.086, x: -17.646, y: -10.543, t: '0.6977 0 0 -0.6977 413.1597 124.8477' }
      ]},
      { name: 'whor_r', sym: 'who', layers: [
        { w: 142.956, h: 175.221, x: -0.161, y: -175.006, t: '0.1843 0 0 -0.1843 399.1475 108.5786' }
      ]},
      { name: 'whol_r', sym: 'who', layers: [
        { w: 142.956, h: 175.221, x: -0.161, y: -175.006, t: '-0.1843 0 0 -0.1843 427.4805 108.5786' }
      ]},
      { name: 'whor2_r', sym: 'who2', layers: [
        { w: 80.323, h: 34.358, x: -0.021, y: -34.345, t: '0.2166 0 0 -0.2166 406.2109 118.8369' },
        { w: 142.956, h: 175.221, x: -0.161, y: -175.006, t: '0.1843 0 0 -0.1843 399.1475 108.5786' }
      ]},
      { name: 'whol2_r', sym: 'who2', layers: [
        { w: 80.323, h: 34.358, x: -0.021, y: -34.345, t: '-0.2166 0 0 -0.2166 420.4082 118.8369' },
        { w: 142.956, h: 175.221, x: -0.161, y: -175.006, t: '-0.1843 0 0 -0.1843 427.4805 108.5786' }
      ]},
      { name: 'whcr_r', sym: 'whc', layers: [
        { w: 61.449, h: 56.745, x: 0.001, y: -56.726, t: '0.2229 0 0 -0.2229 404.665 125.7114' },
        { w: 118.92, h: 146.203, x: 0.012, y: -146.203, t: '0.2229 0 0 -0.2229 399.3164 109.0181' },
        { w: 96.65, h: 56.6, x: 0, y: -56.6, t: '0.2229 0 0 -0.2229 400.8433 110.9341' },
        { w: 80.323, h: 34.357, x: -0.021, y: -34.345, t: '0.2229 0 0 -0.2229 406.2476 119.2261' },
        { w: 102.273, h: 34.1, x: 0.006, y: -34.1, t: '0.2229 0 0 -0.2229 400.5322 116.9077' },
        { w: 121.749, h: 149.175, x: -0.162, y: -148.96, t: '0.2229 0 0 -0.2229 398.9712 108.6836' }
      ]},
      { name: 'whcl_r', sym: 'whc', layers: [
        { w: 61.449, h: 56.745, x: 0.001, y: -56.726, t: '-0.2229 0 0 -0.2229 421.4561 125.7114' },
        { w: 118.92, h: 146.203, x: 0.012, y: -146.203, t: '-0.2229 0 0 -0.2229 426.8047 109.0181' },
        { w: 96.65, h: 56.6, x: 0, y: -56.6, t: '-0.2229 0 0 -0.2229 425.2783 110.9341' },
        { w: 80.323, h: 34.357, x: -0.021, y: -34.345, t: '-0.2229 0 0 -0.2229 419.8716 119.2261' },
        { w: 102.273, h: 34.1, x: 0.006, y: -34.1, t: '-0.2229 0 0 -0.2229 425.5894 116.9077' },
        { w: 121.749, h: 149.175, x: -0.162, y: -148.96, t: '-0.2229 0 0 -0.2229 427.1504 108.6836' }
      ]}
    ],
    rcr: [
      { name: '3r_r', sym: '3r', layers: [
        { w: 107.886, h: 187.625, x: 0.017, y: -187.605, t: '0.1751 0 0 -0.1751 311.4097 107.9731' }
      ]},
      { name: 'v3hd_r', sym: 'v3hd_r', layers: [
        { w: 148.595, h: 87.77, x: 0, y: -87.7, t: '0.2417 0 0 -0.2417 303.958 113.0537' },
        { w: 45.913, h: 50.325, x: -0.017, y: -50.326, t: '0.2417 0 0 -0.2417 309.6123 118.25' }
      ]},
      { name: 'v3hd_outline_r', sym: 'v3hd_outline_r', layers: [
        { w: 148.617, h: 87.753, x: -0.016, y: -87.689, t: '0.2385 0 0 -0.2385 303.9746 113.3008' },
        { w: 151.936, h: 91.056, x: 0.025, y: -91.05, t: '0.2385 0 0 -0.2385 303.5581 112.9072' },
        { w: 45.911, h: 50.323, x: -0.021, y: -50.32, t: '0.2385 0 0 -0.2385 309.5552 118.4282' }
      ]},
      { name: 'v3hd2_r', sym: 'v3hd2_r', layers: [
        { w: 148.789, h: 87.82, x: 0, y: -87.7, t: '0.2371 0 0 -0.2371 304.1494 113.1929' }
      ]},
      { name: 'mia_r', sym: 'mia', layers: [
        { w: 35.292, h: 21.086, x: -17.646, y: -10.543, t: '0.6977 0 0 -0.6977 320.8262 124.8477' }
      ]},
      { name: 'whor_r', sym: 'who', layers: [
        { w: 142.956, h: 175.221, x: -0.161, y: -175.006, t: '0.1843 0 0 -0.1843 307.481 108.5786' }
      ]},
      { name: 'whol_r', sym: 'who', layers: [
        { w: 142.956, h: 175.221, x: -0.161, y: -175.006, t: '-0.1843 0 0 -0.1843 334.813 108.5786' }
      ]},
      { name: 'whor2_r', sym: 'who2', layers: [
        { w: 80.323, h: 34.358, x: -0.021, y: -34.345, t: '0.2166 0 0 -0.2166 314.5547 118.8369' },
        { w: 142.956, h: 175.221, x: -0.161, y: -175.006, t: '0.1843 0 0 -0.1843 307.481 108.5786' }
      ]},
      { name: 'whol2_r', sym: 'who2', layers: [
        { w: 80.323, h: 34.358, x: -0.021, y: -34.345, t: '-0.2166 0 0 -0.2166 327.752 118.8369' },
        { w: 142.956, h: 175.221, x: -0.161, y: -175.006, t: '-0.1843 0 0 -0.1843 334.813 108.5786' }
      ]},
      { name: 'whcr_r', sym: 'whc', layers: [
        { w: 61.449, h: 56.745, x: 0.001, y: -56.726, t: '0.2229 0 0 -0.2229 313.0674 125.5449' },
        { w: 118.92, h: 146.203, x: 0.012, y: -146.203, t: '0.2229 0 0 -0.2229 307.7192 108.8516' },
        { w: 96.65, h: 56.6, x: 0, y: -56.6, t: '0.2229 0 0 -0.2229 309.2451 110.7676' },
        { w: 80.323, h: 34.357, x: -0.021, y: -34.345, t: '0.2229 0 0 -0.2229 314.6499 119.0596' },
        { w: 102.273, h: 34.1, x: 0.006, y: -34.1, t: '0.2229 0 0 -0.2229 308.9321 116.7412' },
        { w: 121.749, h: 149.175, x: -0.162, y: -148.96, t: '0.2229 0 0 -0.2229 307.3735 108.5171' }
      ]},
      { name: 'whcl_r', sym: 'whc', layers: [
        { w: 61.449, h: 56.745, x: 0.001, y: -56.726, t: '-0.2229 0 0 -0.2229 329.8564 125.5449' },
        { w: 118.92, h: 146.203, x: 0.012, y: -146.203, t: '-0.2229 0 0 -0.2229 335.2051 108.8516' },
        { w: 96.65, h: 56.6, x: 0, y: -56.6, t: '-0.2229 0 0 -0.2229 333.6787 110.7676' },
        { w: 80.323, h: 34.357, x: -0.021, y: -34.345, t: '-0.2229 0 0 -0.2229 328.2739 119.0596' },
        { w: 102.273, h: 34.1, x: 0.006, y: -34.1, t: '-0.2229 0 0 -0.2229 333.9917 116.7412' },
        { w: 121.749, h: 149.175, x: -0.162, y: -148.96, t: '-0.2229 0 0 -0.2229 335.5508 108.5171' }
      ]}
    ],
    hres: [
      { name: '3r_r', sym: '3r', layers: [
        { w: 107.886, h: 187.628, x: -53.943, y: -93.814, t: '0.122 -0.0308 -0.0308 -0.122 407.5396 203' }
      ]},
      { name: 'v3hd_yh', sym: 'v3hd', layers: [
        { w: 485.54, h: 88.578, x: -242.77, y: -44.289, t: '-0.016 -0.0688 -0.0688 0.016 407.7793 202.2139' },
        { w: 312.556, h: 55.099, x: -156.278, y: -27.55, t: '-0.016 -0.0688 -0.0688 0.016 407.8271 206.5195' }
      ]},
      { name: 'mi_yh', sym: 'mi', layers: [
        { w: 267.306, h: 28.526, x: -133.653, y: -14.263, t: '-0.0315 -0.1264 -0.1264 0.0315 406.1475 202.3018' },
        { w: 35.292, h: 21.088, x: -17.646, y: -10.544, t: '-0.0315 -0.1264 -0.1264 0.0315 404.1509 194.3125' }
      ]},
      { name: 'mia_r', sym: 'mia', layers: [
        { w: 35.292, h: 21.088, x: -17.646, y: -10.544, t: '0.4227 -0.1128 -0.1128 -0.4227 407.6118 201.5996' }
      ]}
    ],
    hcut: [
      { name: '3r_r', sym: '3r', layers: [
        { w: 107.886, h: 187.628, x: -53.943, y: -93.814, t: '0.1226 0.0282 0.0282 -0.1226 326 202' }
      ]},
      { name: 'v3hd_yh', sym: 'v3hd', layers: [
        { w: 485.54, h: 88.578, x: -242.77, y: -44.289, t: '0.0139 -0.0693 -0.0693 -0.0139 326.9395 202.5439' },
        { w: 312.556, h: 55.099, x: -156.278, y: -27.55, t: '0.0139 -0.0693 -0.0692 -0.0139 325.2056 206.4854' }
      ]},
      { name: 'mi_yh', sym: 'mi', layers: [
        { w: 267.306, h: 28.526, x: -133.653, y: -14.263, t: '0.0278 -0.1273 -0.1273 -0.0278 327.4136 202.1123' },
        { w: 35.292, h: 21.088, x: -17.646, y: -10.544, t: '0.0278 -0.1273 -0.1273 -0.0278 329.1704 194.0674' }
      ]},
      { name: 'mia_r', sym: 'mia', layers: [
        { w: 35.292, h: 21.088, x: -17.646, y: -10.544, t: '0.4304 0.0787 0.0787 -0.4304 325.0801 201.5996' }
      ]}
    ],
    bp: [
      { name: '3r_r', sym: '3r', layers: [
        { w: 107.886, h: 187.626, x: -53.943, y: -93.813, t: '0.1751 0 0 -0.1751 367.8848 145.9297' }
      ]},
      { name: 'v3hd_r', sym: 'v3hd_r', layers: [
        { w: 148.595, h: 87.77, x: -74.298, y: -43.885, t: '0.2417 0 0 -0.2417 365.04 145.1763' },
        { w: 45.911, h: 50.319, x: -22.956, y: -25.16, t: '0.2417 0 0 -0.2417 358.2812 145.8647' }
      ]},
      { name: 'v3hd_outline_r', sym: 'v3hd_outline_r', layers: [
        { w: 148.617, h: 87.753, x: -0.016, y: -87.689, t: '0.2385 0 0 -0.2385 348.0713 134.6211' },
        { w: 151.936, h: 91.056, x: 0.025, y: -91.05, t: '0.2385 0 0 -0.2385 347.6548 134.2275' },
        { w: 45.911, h: 50.323, x: -0.021, y: -50.32, t: '0.2385 0 0 -0.2385 353.6519 139.7485' }
      ]},
      { name: 'v3hd2_r', sym: 'v3hd2_r', layers: [
        { w: 148.789, h: 87.82, x: -74.395, y: -43.91, t: '0.2371 0 0 -0.2371 365.0029 145.1089' }
      ]},
      { name: 'mia_r', sym: 'mia', layers: [
        { w: 35.292, h: 21.086, x: -17.646, y: -10.543, t: '0.6977 0 0 -0.6977 366.6436 146.3809' }
      ]},
      { name: 'whor_r', sym: 'who', layers: [
        { w: 142.955, h: 175.222, x: -71.478, y: -87.611, t: '0.1843 0 0 -0.1843 365.7754 146.2188' }
      ]},
      { name: 'whol_r', sym: 'who', layers: [
        { w: 142.955, h: 175.222, x: -71.478, y: -87.611, t: '-0.1843 0 0 -0.1843 367.8213 146.2188' }
      ]},
      { name: 'whor2_r', sym: 'who2', layers: [
        { w: 80.323, h: 34.358, x: -40.162, y: -17.179, t: '0.2166 0 0 -0.2166 368.3896 144.0884' },
        { w: 142.955, h: 175.222, x: -71.478, y: -87.611, t: '0.1843 0 0 -0.1843 365.7754 146.2188' }
      ]},
      { name: 'whol2_r', sym: 'who2', layers: [
        { w: 80.323, h: 34.358, x: -40.162, y: -17.179, t: '-0.2166 0 0 -0.2166 365.1982 144.0884' },
        { w: 142.955, h: 175.222, x: -71.478, y: -87.611, t: '-0.1843 0 0 -0.1843 367.8213 146.2188' }
      ]},
      { name: 'whcr_r', sym: 'whc', layers: [
        { w: 61.449, h: 56.744, x: -30.724, y: -28.372, t: '0.2229 0 0 -0.2229 364.998 153.5645' },
        { w: 118.92, h: 146.204, x: -59.46, y: -73.102, t: '0.2229 0 0 -0.2229 366.0566 146.8457' },
        { w: 96.65, h: 56.601, x: -48.325, y: -28.301, t: '0.2229 0 0 -0.2229 365.0996 138.7754' },
        { w: 80.323, h: 34.358, x: -40.162, y: -17.179, t: '0.2229 0 0 -0.2229 368.6797 144.5854' },
        { w: 102.274, h: 34.1, x: -51.137, y: -17.05, t: '0.2229 0 0 -0.2229 365.416 142.2412' },
        { w: 121.749, h: 149.172, x: -60.874, y: -74.586, t: '0.2229 0 0 -0.2229 365.9883 146.7944' }
      ]},
      { name: 'whcl_r', sym: 'whc', layers: [
        { w: 61.449, h: 56.744, x: -30.724, y: -28.372, t: '-0.2229 0 0 -0.2229 368.0918 153.5645' },
        { w: 118.92, h: 146.204, x: -59.46, y: -73.102, t: '-0.2229 0 0 -0.2229 367.0332 146.8457' },
        { w: 96.65, h: 56.601, x: -48.325, y: -28.301, t: '-0.2229 0 0 -0.2229 367.9912 138.7754' },
        { w: 80.323, h: 34.358, x: -40.162, y: -17.179, t: '-0.2229 0 0 -0.2229 364.4082 144.5854' },
        { w: 102.274, h: 34.1, x: -51.137, y: -17.05, t: '-0.2229 0 0 -0.2229 367.6738 142.2412' },
        { w: 121.749, h: 149.172, x: -60.874, y: -74.586, t: '-0.2229 0 0 -0.2229 367.1016 146.7944' }
      ]}
    ],
    rf: [
      { name: 'v3hd_large', sym: 'v3hd_large', layers: [
        { w: 92.6, h: 68, x: -46.3, y: -30.5, t: '0.8751 -0.3319 -0.3319 -0.8751 119.9136 113.8037' },
        { w: 72, h: 55.6, x: -36, y: -27.8, t: '0.8746 -0.3317 -0.3317 -0.8746 126.6732 97.0056' }
      ]},
      { name: 'whor_large', sym: 'who', layers: [
        { w: 142.8, h: 175.4, x: -71.4, y: -87.7, t: '0.4323 0 0 -0.4953 116.8819 104.1345' }
      ]},
      { name: 'whor2_large', sym: 'who2', layers: [
        { w: 80.3, h: 34.5, x: -40.2, y: -17.3, t: '0.5059 0 0 -0.5797 122.9938 98.4312' },
        { w: 142.8, h: 175.4, x: -71.4, y: -87.7, t: '0.4323 0 0 -0.4953 116.8819 104.1345' }
      ]}
    ],
    sw45: [
      { name: 'v3hd_s', sym: 'v3hd', layers: [
        { w: 485.54, h: 88.578, x: -242.77, y: -44.289, t: '0.0955 0.2287 0.2287 -0.0955 896.9727 218.2217' },
        { w: 312.556, h: 55.099, x: -156.278, y: -27.55, t: '0.0955 0.2287 0.2286 -0.0954 894.2891 203.3555' }
      ]},
      { name: 'v3hd_outline_s', sym: 'v3hd_outline_s', layers: [
        { w: 485.541, h: 88.58, x: 0.45, y: -91.8, t: '0.0897 0.2301 0.2301 -0.0897 885.2432 155.2046' },
        { w: 265.347, h: 50.74, x: 0, y: -50.75, t: '0.1662 0.4264 0.4264 -0.1662 884.6992 154.4346' },
        { w: 51.5, h: 55.1, x: 27.5, y: -62.05, t: '0.0897 0.2301 0.2301 -0.0897 885.2568 155.1753' },
        { w: 56.85, h: 42.95, x: -9.887, y: -36.76, t: '0.0903 0.2316 0.2316 -0.0903 905.8623 227.457' }
      ]},
      { name: 'msv3_s', sym: 'msv3', layers: [
        { w: 709.958, h: 87.838, x: -354.979, y: -43.919, t: '0.0685 0.1561 0.1561 -0.0685 901.2441 216.6885' },
        { w: 45.95, h: 50.345, x: -22.975, y: -25.172, t: '0.0685 0.1561 0.1561 -0.0685 879.6611 168.7168' }
      ]},
      { name: 'mi_s', sym: 'mi', layers: [
        { w: 267.306, h: 28.526, x: -133.653, y: -14.263, t: '0.1779 0.4181 0.4181 -0.1779 898.876 212.499' },
        { w: 35.292, h: 21.086, x: -17.646, y: -10.543, t: '0.1779 0.4181 0.4181 -0.1779 910.127 238.9238' }
      ]},
      { name: 'mi_outline_s', sym: 'mi_outline', layers: [
        { w: 281.8, h: 28.502, x: 0, y: -28.5, t: '0.1692 0.3947 0.3947 -0.1692 881.2432 154.3154' },
        { w: 35.29, h: 21.086, x: 0, y: -21.062, t: '0.1692 0.3947 0.3947 -0.1692 912.0381 230.2266' },
        { w: 285.051, h: 31.752, x: -1.625, y: -30.125, t: '0.1692 0.3947 0.3947 -0.1692 881.2432 154.3154' }
      ]}
    ],
    swr45: [
      { name: 'v3hd_s', sym: 'v3hd', layers: [
        { w: 485.54, h: 88.578, x: -242.77, y: -44.289, t: '0.0973 -0.2279 -0.2279 -0.0973 568.0732 219.7793' },
        { w: 312.556, h: 55.099, x: -156.278, y: -27.55, t: '0.0973 -0.2279 -0.2278 -0.0972 559.291 232.0713' }
      ]},
      { name: 'v3hd_outline_s', sym: 'v3hd_outline_s', layers: [
        { w: 485.541, h: 88.58, x: 0.45, y: -91.8, t: '0.0941 -0.2284 -0.2284 -0.0941 531.6855 267.9404' },
        { w: 265.347, h: 50.74, x: 0, y: -50.75, t: '0.1743 -0.4232 -0.4232 -0.1743 531.5479 268.873' },
        { w: 51.5, h: 55.1, x: 27.5, y: -62.05, t: '0.094 -0.2284 -0.2283 -0.094 531.6553 267.9521' },
        { w: 56.85, h: 42.95, x: -9.887, y: -36.76, t: '0.0946 -0.2298 -0.2298 -0.0946 566.6699 201.4453' }
      ]},
      { name: 'msv3_s', sym: 'msv3', layers: [
        { w: 709.958, h: 87.838, x: -354.979, y: -43.919, t: '0.0676 -0.1565 -0.1565 -0.0676 564.1309 213.8203' },
        { w: 45.95, h: 50.345, x: -22.975, y: -25.172, t: '0.0676 -0.1565 -0.1565 -0.0676 543.7236 262.3047' }
      ]},
      { name: 'mi_s', sym: 'mi', layers: [
        { w: 267.306, h: 28.526, x: -133.653, y: -14.263, t: '0.1954 -0.4103 -0.4103 -0.1954 567.4326 212.459' },
        { w: 35.292, h: 21.086, x: -17.646, y: -10.543, t: '0.1954 -0.4103 -0.4103 -0.1954 579.7725 186.5244' }
      ]},
      { name: 'mi_outline_s', sym: 'mi_outline', layers: [
        { w: 281.8, h: 28.502, x: 0, y: -28.5, t: '0.1841 -0.388 -0.388 -0.1841 536.0195 265.417' },
        { w: 35.29, h: 21.086, x: 0, y: -21.062, t: '0.1841 -0.388 -0.388 -0.1841 572.5762 192.1074' },
        { w: 285.051, h: 31.752, x: -1.625, y: -30.125, t: '0.1841 -0.388 -0.388 -0.1841 536.0195 265.417' }
      ]}
    ],
    hres_left: [
      { name: '3r_r', sym: '3r', layers: [
        { w: 107.886, h: 187.628, x: -53.943, y: -93.814, t: '0.144 -0.008 -0.008 -0.144 791 203.3311' }
      ]},
      { name: 'v3hd_yh', sym: 'v3hd', layers: [
        { w: 485.54, h: 88.578, x: -242.77, y: -44.289, t: '-0.0039 -0.0794 -0.0794 0.0039 791.5059 205.5127' },
        { w: 312.556, h: 55.099, x: -156.278, y: -27.55, t: '-0.0039 -0.0794 -0.0794 0.0039 790.6982 210.292' }
      ]},
      { name: 'mi_yh', sym: 'mi', layers: [
        { w: 267.306, h: 28.526, x: -133.653, y: -14.263, t: '-0.0079 -0.1491 -0.1491 0.0079 790.1562 204.999' },
        { w: 35.292, h: 21.088, x: -17.646, y: -10.544, t: '-0.0078 -0.1491 -0.1491 0.0078 789.6602 195.5713' }
      ]},
      { name: 'mia_r', sym: 'mia', layers: [
        { w: 35.292, h: 21.088, x: -17.646, y: -10.544, t: '0.5003 -0.0345 -0.0345 -0.5003 791.96 204.5273' }
      ]}
    ],
    hcut_right: [
      { name: '3r_r', sym: '3r', layers: [
        { w: 107.886, h: 187.628, x: -53.943, y: -93.814, t: '0.1447 0.0074 0.0074 -0.1446 674.4834 203.5391' }
      ]},
      { name: 'v3hd_yh', sym: 'v3hd', layers: [
        { w: 485.54, h: 88.578, x: -242.77, y: -44.289, t: '0.0036 -0.0794 -0.0794 -0.0036 676.1729 205.5127' },
        { w: 312.556, h: 55.099, x: -156.278, y: -27.55, t: '0.0036 -0.0794 -0.0794 -0.0036 674.918 210.1943' }
      ]},
      { name: 'mi_yh', sym: 'mi', layers: [
        { w: 267.306, h: 28.526, x: -133.653, y: -14.263, t: '0.0061 -0.1498 -0.1498 -0.0061 675.6572 205.4707' },
        { w: 35.292, h: 21.088, x: -17.646, y: -10.544, t: '0.0061 -0.1498 -0.1498 -0.0061 676.0371 195.998' }
      ]},
      { name: 'mia_r', sym: 'mia', layers: [
        { w: 35.292, h: 21.088, x: -17.646, y: -10.544, t: '0.5036 0.0032 0.0032 -0.5036 672.9053 205.3555' }
      ]}
    ],
    // BACK view left sidewall (from VOS swxLogosVArray45 — dedicated transforms, NOT offsets)
    sw_back: [
      { name: 'v3hd_s', sym: 'v3hd', layers: [
        { w: 485.54, h: 88.578, x: -242.77, y: -44.289, t: '0.0953 0.2287 0.2287 -0.0953 41.4155 221.248' },
        { w: 312.556, h: 55.099, x: -156.278, y: -27.55, t: '0.0953 0.2287 0.2286 -0.0953 38.7412 206.3799' }
      ]},
      { name: 'v3hd_outline_s', sym: 'v3hd_outline_s', layers: [
        { w: 485.541, h: 88.58, x: 0.45, y: -91.8, t: '0.0897 0.2301 0.2301 -0.0897 32.5869 162.6934' },
        { w: 265.347, h: 50.74, x: 0, y: -50.75, t: '0.1662 0.4264 0.4264 -0.1662 32.043 161.9229' },
        { w: 51.5, h: 55.1, x: 27.5, y: -62.05, t: '0.0897 0.2301 0.2301 -0.0897 32.6006 162.6641' },
        { w: 56.85, h: 42.95, x: -9.887, y: -36.76, t: '0.0903 0.2316 0.2316 -0.0903 53.2061 234.9453' }
      ]},
      { name: 'msv3_s', sym: 'msv3', layers: [
        { w: 709.958, h: 87.838, x: -354.979, y: -43.919, t: '0.0685 0.1561 0.1561 -0.0685 43.6475 216.6885' },
        { w: 45.95, h: 50.345, x: -22.975, y: -25.172, t: '0.0685 0.1561 0.1561 -0.0685 22.0645 168.7168' }
      ]},
      { name: 'mi_s', sym: 'mi', layers: [
        { w: 267.306, h: 28.526, x: -133.653, y: -14.263, t: '0.1779 0.4181 0.4181 -0.1779 41.8921 216.8594' },
        { w: 35.292, h: 21.086, x: -17.646, y: -10.543, t: '0.1779 0.4181 0.4181 -0.1779 53.1431 243.2842' }
      ]},
      { name: 'mi_outline_s', sym: 'mi_outline', layers: [
        { w: 281.8, h: 28.502, x: 0, y: -28.5, t: '0.1692 0.3947 0.3947 -0.1692 23.2817 158.2246' },
        { w: 35.29, h: 21.086, x: 0, y: -21.062, t: '0.1692 0.3947 0.3947 -0.1692 54.0767 234.1357' },
        { w: 285.051, h: 31.752, x: -1.625, y: -30.125, t: '0.1692 0.3947 0.3947 -0.1692 23.2817 158.2246' }
      ]}
    ],
    // BACK view right sidewall (from VOS swxLogosRVArray45 — dedicated transforms, NOT offsets)
    swr_back: [
      { name: 'v3hd_s', sym: 'v3hd', layers: [
        { w: 485.54, h: 88.578, x: -242.77, y: -44.289, t: '0.099 -0.2272 -0.2272 -0.099 199.0596 220.7441' },
        { w: 312.556, h: 55.099, x: -156.278, y: -27.55, t: '0.099 -0.2272 -0.2271 -0.099 190.1836 232.9688' }
      ]},
      { name: 'v3hd_outline_s', sym: 'v3hd_outline_s', layers: [
        { w: 485.541, h: 88.58, x: 0.45, y: -91.8, t: '0.0941 -0.2284 -0.2284 -0.0941 163.2793 271.8398' },
        { w: 265.347, h: 50.74, x: 0, y: -50.75, t: '0.1743 -0.4232 -0.4232 -0.1743 163.1416 272.7725' },
        { w: 51.5, h: 55.1, x: 27.5, y: -62.05, t: '0.094 -0.2284 -0.2283 -0.094 163.249 271.8516' },
        { w: 56.85, h: 42.95, x: -9.887, y: -36.76, t: '0.0946 -0.2298 -0.2298 -0.0946 198.2637 205.3447' }
      ]},
      { name: 'msv3_s', sym: 'msv3', layers: [
        { w: 709.958, h: 87.838, x: -354.979, y: -43.919, t: '0.0676 -0.1565 -0.1565 -0.0676 198.0967 213.8203' },
        { w: 45.95, h: 50.345, x: -22.975, y: -25.172, t: '0.0676 -0.1565 -0.1565 -0.0676 177.6895 262.3047' }
      ]},
      { name: 'mi_s', sym: 'mi', layers: [
        { w: 267.306, h: 28.526, x: -133.653, y: -14.263, t: '0.1954 -0.4103 -0.4103 -0.1954 198.1865 216.8438' },
        { w: 35.292, h: 21.086, x: -17.646, y: -10.543, t: '0.1954 -0.4103 -0.4103 -0.1954 210.5264 190.9092' }
      ]},
      { name: 'mi_outline_s', sym: 'mi_outline', layers: [
        { w: 281.8, h: 28.502, x: 0, y: -28.5, t: '0.1841 -0.388 -0.388 -0.1841 166.7734 268.4521' },
        { w: 35.29, h: 21.086, x: 0, y: -21.062, t: '0.1841 -0.388 -0.388 -0.1841 203.3301 195.1426' },
        { w: 285.051, h: 31.752, x: -1.625, y: -30.125, t: '0.1841 -0.388 -0.388 -0.1841 166.7734 268.4521' }
      ]}
    ]
  };

  /* Rig-specific custom text/image transforms — positioned on rig SVG (960x400) */
  var RIG_CUSTOM_TRANSFORMS = {
    custom_name: {
      sw:       { x: 880, y: 200, angle: 90, angle45: 60, fontSize: 14, x45: 875, y45: 195, fontSize45: 21 },
      swr:      { x: 585, y: 200, angle: -90, angle45: -60, fontSize: 14, x45: 590, y45: 195, fontSize45: 21 },
      sw_back:  { x: 42, y: 216, angle: 68, fontSize: 20 },
      swr_back: { x: 199, y: 215, angle: -65, fontSize: 20 },
      rc:   { x: 413, y: 128, angle: 0, fontSize: 7, lines: 3, lineHeight: 9 },
      rcr:  { x: 321, y: 128, angle: 0, fontSize: 7, lines: 3, lineHeight: 9 },
      bp:   { x: 367, y: 136, angle: 0, fontSize: 7, lines: 3, lineHeight: 9 },
      rf:   { x: 120, y: 104, angle: 0, fontSize: 7, lines: 3, lineHeight: 9 },
      hcut: { x: 327, y: 202, angle: -75, fontSize: 5 },
      hres: { x: 408, y: 203, angle: -105, fontSize: 5 },
      hres_left:  { x: 791, y: 203, angle: -90, fontSize: 5 },
      hcut_right: { x: 675, y: 203, angle: -90, fontSize: 5 }
    },
    custom_logo: {
      sw:       { x: 851.5, y: 77.5, w: 55, h: 275, angle: 90, angle45: 55 },
      swr:      { x: 556.5, y: 77.5, w: 55, h: 275, angle: -90, angle45: -55 },
      sw_back:  { x: 19.5, y: 115, w: 45, h: 200, angle: 68 },
      swr_back: { x: 174.5, y: 115, w: 45, h: 200, angle: -65 },
      rc:   { x: 395, y: 105, w: 35, h: 40, angle: 0 },
      rcr:  { x: 303, y: 105, w: 35, h: 40, angle: 0 },
      bp:   { x: 350, y: 115, w: 35, h: 40, angle: 0 },
      rf:   { x: 102, y: 82, w: 35, h: 40, angle: -21 },
      hcut: { x: 316, y: 188, w: 22, h: 28, angle: -75 },
      hres: { x: 397, y: 188, w: 22, h: 28, angle: -105 },
      hres_left:  { x: 780, y: 189, w: 22, h: 28, angle: -90 },
      hcut_right: { x: 664, y: 189, w: 22, h: 28, angle: -90 }
    }
  };

  /* Embroidery thread colors mapped for SVG (same hex as EMBROIDERY_COLORS but indexed by simple name) */
  var EMB_THREAD_COLORS = [
    { id: 'white', name: 'White', hex: '#ffffff' },
    { id: 'black', name: 'Black', hex: '#000000' },
    { id: 'smoke', name: 'Smoke', hex: '#5B635D' },
    { id: 'silver', name: 'Silver', hex: '#B7B7B7' },
    { id: 'neonyellow', name: 'Neon Yellow', hex: '#D8FF00' },
    { id: 'yellow', name: 'Yellow', hex: '#FFFF00' },
    { id: 'gold', name: 'Gold', hex: '#FFC200' },
    { id: 'neonorange', name: 'Neon Orange', hex: '#FF8541' },
    { id: 'orange', name: 'Orange', hex: '#EA4200' },
    { id: 'neonpink', name: 'Neon Pink', hex: '#FF489B' },
    { id: 'pink', name: 'Pink', hex: '#FFA4BC' },
    { id: 'red', name: 'Red', hex: '#C40000' },
    { id: 'burgundy', name: 'Burgundy', hex: '#7F0021' },
    { id: 'purple', name: 'Purple', hex: '#4000A5' },
    { id: 'lavender', name: 'Lavender', hex: '#815ABF' },
    { id: 'fuchsia', name: 'Fuchsia', hex: '#B5008F' },
    { id: 'lightblue', name: 'Light Blue', hex: '#62E2E8' },
    { id: 'neonblue', name: 'Neon Blue', hex: '#00A6D3' },
    { id: 'royalblue', name: 'Royal Blue', hex: '#002FD8' },
    { id: 'navyblue', name: 'Navy Blue', hex: '#001654' },
    { id: 'teal', name: 'Teal', hex: '#007C79' },
    { id: 'neongreen', name: 'Neon Green', hex: '#7CFC00' },
    { id: 'kellygreen', name: 'Kelly Green', hex: '#317C00' },
    { id: 'forestgreen', name: 'Forest Green', hex: '#00593B' },
    { id: 'olivedrab', name: 'Olive Drab', hex: '#3C4200' },
    { id: 'brown', name: 'Brown', hex: '#352300' },
    { id: 'tan', name: 'Tan', hex: '#C4AD74' },
    { id: 'coyote', name: 'Coyote', hex: '#B99772' }
  ];

  function embThreadColor(id) {
    if (!id) return EMB_THREAD_COLORS[1];
    // Normalize em-prefixed IDs from AI (e.g. "em-neon-yellow" → "neonyellow")
    var lookupId = id.indexOf('em-') === 0 ? id.substring(3).replace(/-/g, '') : id;
    for (var i = 0; i < EMB_THREAD_COLORS.length; i++) {
      if (EMB_THREAD_COLORS[i].id === lookupId) return EMB_THREAD_COLORS[i];
    }
    return EMB_THREAD_COLORS[1]; // fallback to black
  }

  /* Initialize V2 embroidery state defaults for all sides */
  function initEmbroideryV2State() {
    state.embCurrentLogoIndex = { yk: 0, sw: 0, swr: 0, rc: 1, rcr: 1, hres: 0, hcut: 0, bp: 0, rf: 0 };
    state.embLogoColors = {};
    state.embCustomNames = {};
    state.embCustomFontStyle = {};
    state.embCustomLogos = {};
    state.embAngle45 = {};
    state.embDstFilenames = {};
    state.embNotes = '';
    state.designName = '';
    state.embSelectedSide = null;
    state.embSelectedColorSlot = 1;
    Object.keys(EMB_LOGOS).forEach(function(side) {
      state.embLogoColors[side] = {
        1: 'lavender', 2: 'neonpink', 3: 'yellow',
        4: 'teal', 5: 'red', 6: 'black'
      };
      if (side === 'rc' || side === 'rcr' || side === 'bp' || side === 'rf') {
        state.embCustomNames[side] = { line1: '', line2: '', line3: '' };
      } else {
        state.embCustomNames[side] = '';
      }
      state.embCustomFontStyle[side] = 'script';
      state.embCustomLogos[side] = { dataUrl: null, rotation: 0 };
      state.embAngle45[side] = false;
    });
  }

  /* Load logo transforms JSON */
  function loadLogoTransforms(callback) {
    if (LOGO_TRANSFORMS) {
      if (callback) callback();
      return;
    }

    var transformsUrl = window.VCP_LOGO_TRANSFORMS_URL;
    if (!transformsUrl) {
      // Derive from embroidery SVG URL (same Shopify CDN path)
      var embUrl = window.VCP_EMBROIDERY_SVG_URL || EMBROIDERY_SVG_URL;
      if (embUrl) {
        // Replace filename but keep the full CDN path including /assets/
        var baseUrl = embUrl.substring(0, embUrl.lastIndexOf('/') + 1);
        transformsUrl = baseUrl + 'logo-transforms.json';
      }
    }

    if (!transformsUrl) {
      console.warn('VCP: No logo transforms URL available');
      if (callback) callback();
      return;
    }

    console.log('VCP: Loading logo transforms from', transformsUrl);

    var xhr = new XMLHttpRequest();
    xhr.open('GET', transformsUrl, true);
    xhr.timeout = 10000;
    xhr.onreadystatechange = function() {
      if (xhr.readyState !== 4) return;
      if (xhr.status === 200 && xhr.responseText) {
        try {
          LOGO_TRANSFORMS = JSON.parse(xhr.responseText);
          console.log('VCP: Logo transforms loaded successfully');
        } catch (e) {
          console.warn('VCP: Failed to parse logo transforms JSON');
        }
      } else {
        console.warn('VCP: Failed to load logo transforms (status ' + xhr.status + ')');
      }
      if (callback) callback();
    };
    xhr.onerror = function() {
      console.warn('VCP: Network error loading logo transforms');
      if (callback) callback();
    };
    xhr.ontimeout = function() {
      console.warn('VCP: Timeout loading logo transforms');
      if (callback) callback();
    };
    xhr.send();
  }

  /* Calculate font size for custom text (auto-shrink for long text) */
  function calculateEmbFontSize(text, maxChars, baseSize, minSize) {
    var shrinkThreshold = Math.floor(maxChars * 0.85);
    if (text.length > shrinkThreshold) {
      var scale = shrinkThreshold / text.length;
      scale = 1 - ((1 - scale) * 0.5);
      return Math.max(minSize || baseSize * 0.5, baseSize * scale);
    }
    return baseSize;
  }

  // Base colorable zone IDs (cordura + flap — present in every pattern)
  var BASE_ZONE_IDS = CORDURA_ZONES.concat(FLAP_ZONES);

  // Extra cordura zones per pattern (split zones added by SOLO groups)
  var PATTERN_EXTRA_ZONES = {
    'standard':         [],
    'half-and-half':    ['c1d', 'c2b', 'c4b', 'c7d', 'cfdb'],
    'diagonal':         ['c1d', 'c2b'],
    'v-split':          ['c9a', 'c9b', 'c9c'],
    'tri-v-split':      ['c9a', 'c9b', 'c9c'],
    'triple-v-split':   ['c9a', 'c9b', 'c9c', 'c1d', 'c4b'],
    'lightning':        ['c9a', 'c9b', 'c4b', 'c2b', 'c1d'],
    'triple-lightning': ['c9a', 'c9b', 'c4b', 'c2b', 'c1d'],
    'zigzag':           ['c9a', 'c9b', 'c4b', 'c2b', 'c1d'],
    'full-custom':      ['c1d', 'c2b', 'c4b', 'c7d', 'c9a', 'c9b', 'c9c', 'cfdb']
  };

  // Active zone IDs — rebuilt when pattern changes
  var ALL_ZONE_IDS = BASE_ZONE_IDS.slice();
  var currentPattern = 'standard';

  // Zone group locking — maps each zone ID to its group (null = no locking, i.e. full-custom)
  var zoneToGroup = null;

  function buildZoneToGroup(pattern) {
    if (pattern === 'full-custom') { zoneToGroup = null; } else {
      var map = window.VCP_PATTERN_ZONE_MAP;
      var meta = window.VCP_PATTERNS;
      if (!map || !map[pattern] || !meta || !meta[pattern]) { zoneToGroup = null; } else {
        var groups = map[pattern];
        var names = meta[pattern].zones;
        zoneToGroup = {};
        groups.forEach(function (g, i) {
          var groupName = names[i] || ('Group ' + (i + 1));
          g.ids.forEach(function (id) {
            zoneToGroup[id] = { name: groupName, ids: g.ids };
          });
        });
      }
    }
    // Dynamic trim tape grouping
    var trimBuckets = buildTrimGroups(pattern);
    if (!zoneToGroup) zoneToGroup = {};
    if (trimBuckets) {
      var tmeta = window.VCP_PATTERNS;
      var zoneNames = (tmeta && tmeta[pattern]) ? tmeta[pattern].zones : [];
      Object.keys(trimBuckets).forEach(function(gIdx) {
        var bucket = trimBuckets[gIdx];
        var groupName = 'Trim (' + (zoneNames[parseInt(gIdx,10)] || ('Group '+(parseInt(gIdx,10)+1))) + ')';
        bucket.forEach(function(tid) {
          zoneToGroup[tid] = { name: groupName, ids: bucket };
        });
      });
    } else {
      // All trims in one group (standard, full-custom, single-zone patterns)
      TRIM_ZONES.forEach(function(id) {
        zoneToGroup[id] = { name: 'Binding / Trim Tape', ids: TRIM_ZONES };
      });
    }
  }

  function buildTrimGroups(pattern) {
    // Standard and full-custom: all trims in one group
    if (pattern === 'full-custom' || pattern === 'standard') return null;

    var map = window.VCP_PATTERN_ZONE_MAP;
    if (!map || !map[pattern]) return null;
    var groups = map[pattern];
    if (groups.length <= 1) return null; // single zone = all trims linked

    // Build cordura zone → group index lookup
    var corduraGroupOf = {};
    for (var gi = 0; gi < groups.length; gi++) {
      for (var zi = 0; zi < groups[gi].ids.length; zi++) {
        corduraGroupOf[groups[gi].ids[zi]] = gi;
      }
    }

    // Bucket each trim by its parent's group index
    // When a split parent (c2b, c4b) doesn't exist in the pattern, fall back to
    // the unsplit parent (c2, c4) so trim follows the same group as the base panel
    var TRIM_PARENT_FALLBACK = { 'c2b': 'c2', 'c4b': 'c4' };
    var buckets = {};
    TRIM_ZONES.forEach(function(tid) {
      var parent = TRIM_PARENT_MAP[tid];
      var gIdx;
      if (parent !== undefined && corduraGroupOf[parent] !== undefined) {
        gIdx = corduraGroupOf[parent];
      } else if (parent !== undefined && TRIM_PARENT_FALLBACK[parent] !== undefined
                 && corduraGroupOf[TRIM_PARENT_FALLBACK[parent]] !== undefined) {
        gIdx = corduraGroupOf[TRIM_PARENT_FALLBACK[parent]];
      } else {
        gIdx = 0;
      }
      if (!buckets[gIdx]) buckets[gIdx] = [];
      buckets[gIdx].push(tid);
    });

    // If all trims ended up in one bucket, return null (single group)
    var keys = Object.keys(buckets);
    if (keys.length <= 1) return null;

    return buckets;
  }

  function rebuildZoneIds(pattern) {
    var extras = PATTERN_EXTRA_ZONES[pattern] || [];
    ALL_ZONE_IDS = BASE_ZONE_IDS.concat(extras);
    buildZoneToGroup(pattern);
    // Update public API reference
    if (window.VectorColorPopup) window.VectorColorPopup.ALL_ZONE_IDS = ALL_ZONE_IDS;
    // Re-sync trim tape to body panels (split patterns only, only if DOM is ready)
    if (els && els.overlay && pattern !== 'standard' && pattern !== 'full-custom') syncTrimToParentZones();
  }

  /* ================================================================
     EMBROIDERY SVG — PATTERN VARIANT VISIBILITY & ZONE MAPPINGS
     The embroidery preview SVG contains variant elements for each
     pattern type (bhh=half-and-half, bdi=diagonal, bzz=zigzag).
     These must be shown/hidden and colored per active pattern.
     ================================================================ */

  // Maps pattern → c2 variant suffix (null = standard, no c2 split)
  var PATTERN_C2_VARIANT = {
    'standard': null,
    'half-and-half': 'bhh',
    'diagonal': 'bdi',
    'v-split': null,
    'tri-v-split': null,
    'triple-v-split': null,
    'lightning': 'bzz',
    'triple-lightning': 'bzz',
    'zigzag': 'bzz'
  };

  // All variant group IDs in the embroidery SVG
  var EMB_VARIANT_GROUPS_ALL = [
    'rfpartshh', 'rfpartsdi', 'rfpartszz',
    'rf2bdi_grp', 'rf2bzz_grp', 'rf2bhh_grp',
    'partshh', 'partsdi', 'partszz',
    'yk2bdi_grp', 'yk2bzz_grp', 'yk2bhh_grp', 'yk7dhh_grp'
  ];

  // Which variant groups to show for each c2 suffix (includes parent wrappers)
  var EMB_VARIANT_GROUPS_BY_SUFFIX = {
    'bhh': ['rfpartshh', 'rf2bhh_grp', 'partshh', 'yk2bhh_grp', 'yk7dhh_grp'],
    'bdi': ['rfpartsdi', 'rf2bdi_grp', 'partsdi', 'yk2bdi_grp'],
    'bzz': ['rfpartszz', 'rf2bzz_grp', 'partszz', 'yk2bzz_grp']
  };

  // Show/hide pattern variant elements on the embroidery SVG
  function applyPatternVariantsToEmbroiderySvg(svg, pattern) {
    if (!svg) return;
    var suffix = PATTERN_C2_VARIANT[pattern] || null;

    // Hide all variant groups first
    EMB_VARIANT_GROUPS_ALL.forEach(function(grpId) {
      var grp = svg.getElementById(grpId);
      if (grp) { grp.style.display = 'none'; grp.setAttribute('display', 'none'); }
    });

    // Show the correct variant groups for this pattern
    if (suffix && EMB_VARIANT_GROUPS_BY_SUFFIX[suffix]) {
      EMB_VARIANT_GROUPS_BY_SUFFIX[suffix].forEach(function(grpId) {
        var grp = svg.getElementById(grpId);
        if (grp) { grp.style.display = 'inline'; grp.setAttribute('display', 'inline'); }
      });
    }
  }

  // Build pattern-aware position → zone mappings for the embroidery SVG.
  // This replaces the static positionZoneMappings in color/texture functions.
  function getPositionZoneMappings(positionId) {
    var pattern = currentPattern || 'standard';
    var c2Suffix = PATTERN_C2_VARIANT[pattern] || null;
    var extraZones = PATTERN_EXTRA_ZONES[pattern] || [];
    var hasC9 = extraZones.indexOf('c9a') !== -1;
    var hasC2b = extraZones.indexOf('c2b') !== -1;
    var hasC7d = extraZones.indexOf('c7d') !== -1;

    var mappings = {
      'reserveflap': {
        'c1a': ['rf1a'], 'c1b': ['rf1b'],
        'c2': ['rf2'],
        'c3a': ['rf3a'], 'c3b': ['rf3b'],
        'c5a': ['rf5a'], 'c5b': ['rf5b'],
        'c6a': ['rf6a'], 'c6b': ['rf6b'],
        'trim:t1a': ['rft1a'], 'trim:t1b': ['rft1b'],
        'trim:t2a': ['rft2a'], 'trim:t2b': ['rft2b'],
        'trim:t6a': ['rft6a'], 'trim:t6b': ['rft6b'],
        'trim:t7': ['rft7']
      },
      'yoke': {
        'c2': ['yk2'],
        'c3a': ['yk3a'], 'c3b': ['yk3b'],
        'c6a': ['yk6a'], 'c6b': ['yk6b'],
        'c7c': ['yk7c'],
        'trim:t2a': ['ykt2a'], 'trim:t2b': ['ykt2b'],
        'trim:t6a': ['ykt6a'], 'trim:t6b': ['ykt6b'],
        'trim:t7': ['ykt7']
      },
      'backpad': {
        'backp': ['bpbackp']
      },
      'handles': {
        'hcut': ['hhcut'], 'hres': ['hhres'], 'backp': ['hbackp'],
        'harness:harness': ['hharness'],
        'trim:t8aside1': ['ht8aside'], 'trim:t8bside1': ['ht8bside']
      },
      'rcovers': {
        'c7a': ['rc7a'], 'c7b': ['rc7b'], 'c8a': ['rc8a'], 'c8b': ['rc8b'],
        'backp': ['rcbackp'],
        'harness:harness': ['rcharness'],
        'trim:t8atop': ['rct8atop'], 'trim:t8btop': ['rct8btop'],
        'trim:t8abot': ['rct8abot'], 'trim:t8bbot': ['rct8bbot'],
        'trim:t8aside1': ['rct8aside'], 'trim:t8bside1': ['rct8bside']
      },
      'swalls': {
        'c1a': ['sw1a'], 'c1b': ['sw1b'],
        'c3a': ['sw3a'], 'c3b': ['sw3b'],
        'c5a': ['sw5a'], 'c5b': ['sw5b'],
        'c6a': ['sw6a'], 'c6b': ['sw6b'],
        'trim:t1a': ['swt1a'], 'trim:t1b': ['swt1b'],
        'trim:t2a': ['swt2a'], 'trim:t2b': ['swt2b'],
        'trim:t4a': ['swt4a'], 'trim:t4b': ['swt4b'],
        'trim:t6a': ['swt6a'], 'trim:t6b': ['swt6b'],
        'cfb': ['cfb'], 'cfc': ['cfc'],
        'cfd': ['cfd'],
        'cfe': ['cfe'], 'cff': ['cff']
      }
    };

    // Sidewalls: pattern-aware sw9 / flap mapping
    if (positionId === 'swalls') {
      if (hasC9) {
        // V-split type patterns: c9a/b/c color the sw9 elements
        mappings.swalls['cfa'] = ['cfa'];
        mappings.swalls['cfg'] = ['cfg'];
        mappings.swalls['c9a'] = ['sw9a'];
        mappings.swalls['c9b'] = ['sw9b'];
        if (extraZones.indexOf('c9c') !== -1) {
          mappings.swalls['c9c'] = ['sw9c'];
        }
      } else {
        // Non-v-split: flap zones also color sw9 elements
        mappings.swalls['cfa'] = ['cfa', 'sw9a', 'sw9b'];
        mappings.swalls['cfg'] = ['cfg', 'sw9c'];
      }
    }

    // Reserve flap: c2b → variant overlay element
    if (positionId === 'reserveflap' && hasC2b && c2Suffix) {
      mappings.reserveflap['c2b'] = ['rf2' + c2Suffix];
    }

    // Yoke: c2b variant and c7d
    if (positionId === 'yoke') {
      if (hasC2b && c2Suffix) {
        mappings.yoke['c2b'] = ['yk2' + c2Suffix];
      }
      if (hasC7d) {
        mappings.yoke['c7d'] = ['yk7dhh'];
      }
    }

    return mappings[positionId] || {};
  }

  // Human-readable labels for zone IDs
  var ZONE_LABELS = {
    // Container zones
    'backp': 'Back Pad', 'c1a': '1A', 'c1b': '1B', 'c1c': '1C',
    'c2': '2', 'c3a': '3A', 'c3b': '3B', 'c4': '4',
    'c5a': '5A', 'c5b': '5B', 'c6a': '6A', 'c6b': '6B',
    'c7a': '7A', 'c7b': '7B', 'c7c': '7C',
    'c8a': '8A', 'c8b': '8B',
    'c1astab': 'Stab 1A', 'c1bstab': 'Stab 1B',
    'lpad': 'Leg Pad L', 'rpad': 'Leg Pad R',
    'hcut': 'Cutaway Handle', 'hres': 'Reserve Handle',
    'cfa': 'Flap A', 'cfb': 'Flap B', 'cfc': 'Flap C',
    'cfd': 'Flap D', 'cfe': 'Flap E', 'cff': 'Flap F', 'cfg': 'Flap G',
    'c1d': '1D', 'c2b': '2B', 'c4b': '4B', 'c7d': '7D', 'cfdb': 'Flap D-B',
    'c9a': '9A', 'c9b': '9B', 'c9c': '9C',
    // Trim tape zones
    't1a': 'Trim 1A', 't1b': 'Trim 1B',
    't2a': 'Trim 2A', 't2b': 'Trim 2B',
    't3a': 'Trim 3A', 't3b': 'Trim 3B',
    't4a': 'Trim 4A', 't4b': 'Trim 4B',
    't6a': 'Trim 6A', 't6b': 'Trim 6B',
    't7': 'Trim 7',
    't8atop': 'Trim 8A Top', 't8abot': 'Trim 8A Bot',
    't8aside1': 'Trim 8A Side 1', 't8aside2': 'Trim 8A Side 2',
    't8btop': 'Trim 8B Top', 't8bbot': 'Trim 8B Bot',
    't8bside1': 'Trim 8B Side 1', 't8bside2': 'Trim 8B Side 2',
    'tstab': 'Trim Stab', 'tlegr': 'Trim Leg R', 'tlegl': 'Trim Leg L',
    // Harness zones
    'harness': 'Harness Webbing'
  };

  /* ================================================================
     POPUP STATE
     ================================================================ */
  var state = {
    isOpen: false,
    colorMap: {},          // { zoneId: colorId }
    selectedZones: [],     // currently highlighted zone IDs
    recentColors: [],      // last 6 color IDs used
    embroidery: {},        // { positionId: { type, text, font, color } } (legacy)
    /* V2 embroidery state (per-side) */
    embCurrentLogoIndex: {},   // { side: index }
    embLogoColors: {},         // { side: { 1: colorId, 2: colorId, ... } }
    embCustomNames: {},        // { side: text | { line1, line2, line3 } }
    embCustomFontStyle: {},    // { side: 'block' | 'script' }
    embCustomLogos: {},        // { side: { dataUrl, rotation } }
    embAngle45: {},            // { side: boolean }
    embSelectedSide: null,     // currently focused side (for color slot)
    embSelectedColorSlot: 1,   // currently selected color slot
    // Contrast stitching option
    contrastStitch: false,         // contrast stitching enabled
    stitchColor: 'em-black',       // stitching color
    // JC stitching option
    jcStitching: false,            // JC stitching enabled
    jcColor: 'em-black',           // JC stitching color
    // Center flap piping
    pipingEnabled: false,          // piping toggle
    paintBrush: false,             // paint brush mode (pick color, then click zones)
    paintBrushColor: null,         // selected brush color ID
    onSave: null           // callback(colorMap, embroidery) when user saves
  };

  var els = {};            // cached DOM references
  var tooltipEl = null;    // floating color name tooltip
  var rigSvgCache = {};    // { pattern: svgMarkup } — avoids re-fetching

  /* ================================================================
     UNDO / REDO STACK
     ================================================================ */
  var undoStack = [];
  var redoStack = [];
  var _lastSnapshot = null;
  var _applyingUndoRedo = false;
  var MAX_UNDO = 50;

  function getStateSnapshot() {
    return JSON.parse(JSON.stringify({
      colorMap: state.colorMap,
      recentColors: state.recentColors,
      contrastStitch: state.contrastStitch,
      stitchColor: state.stitchColor,
      jcStitching: state.jcStitching,
      jcColor: state.jcColor,
      pipingEnabled: state.pipingEnabled,
      embCurrentLogoIndex: state.embCurrentLogoIndex,
      embLogoColors: state.embLogoColors,
      embCustomNames: state.embCustomNames,
      embCustomFontStyle: state.embCustomFontStyle,
      embAngle45: state.embAngle45,
      embNotes: state.embNotes
    }));
  }

  function applySnapshot(snap) {
    state.colorMap = snap.colorMap || {};
    state.recentColors = snap.recentColors || [];
    state.contrastStitch = !!snap.contrastStitch;
    state.stitchColor = snap.stitchColor || 'em-black';
    state.jcStitching = !!snap.jcStitching;
    state.jcColor = snap.jcColor || 'em-black';
    state.pipingEnabled = !!snap.pipingEnabled;
    state.embCurrentLogoIndex = snap.embCurrentLogoIndex || {};
    state.embLogoColors = snap.embLogoColors || {};
    state.embCustomNames = snap.embCustomNames || {};
    state.embCustomFontStyle = snap.embCustomFontStyle || {};
    state.embAngle45 = snap.embAngle45 || {};
    state.embNotes = snap.embNotes || '';
  }

  function refreshAfterUndoRedo() {
    refreshAllZoneFills();
    refreshZoneHighlights();
    updateSelectionInfo();
    updateZoneVisibility();
    renderStitchPicker();
    renderJCPicker();
    renderPipingToggle();
    if (activeMode === 'embroidery') {
      renderEmbroideryUI();
      refreshAllEmbroideryLogos();
    } else {
      renderFullPalette();
    }
    refreshRigEmbroideryLogos();
  }

  function undoAction() {
    if (!undoStack.length) return;
    redoStack.push(getStateSnapshot());
    var snap = undoStack.pop();
    _applyingUndoRedo = true;
    applySnapshot(snap);
    _lastSnapshot = getStateSnapshot();
    refreshAfterUndoRedo();
    _applyingUndoRedo = false;
    updateUndoRedoBtns();
  }

  function redoAction() {
    if (!redoStack.length) return;
    undoStack.push(getStateSnapshot());
    var snap = redoStack.pop();
    _applyingUndoRedo = true;
    applySnapshot(snap);
    _lastSnapshot = getStateSnapshot();
    refreshAfterUndoRedo();
    _applyingUndoRedo = false;
    updateUndoRedoBtns();
  }

  function updateUndoRedoBtns() {
    if (els.undoBtn) els.undoBtn.disabled = !undoStack.length;
    if (els.redoBtn) els.redoBtn.disabled = !redoStack.length;
  }

  /* ================================================================
     MOBILE HELPERS — Rig Carousel + Mini Color Picker
     ================================================================ */
  var RIG_VIEWS = [
    { label: 'BACK',  vb: '5 0 230 325' },
    { label: 'FRONT', vb: '245 0 230 325' },
    { label: 'RIGHT', vb: '485 0 230 325' },
    { label: 'LEFT',  vb: '725 0 230 325' }
  ];
  var RIG_ORIGINAL_VB = '20 0 920 325';
  var mobileViewIndex = 1; // Start on FRONT
  var mobilePickerEl = null;
  var sidebarMode = 'color'; // 'color' | 'embroidery' | 'contrastStitch' | 'jcStitch'
  var isMobileView = false;

  function isMobile() {
    return window.innerWidth <= 768;
  }

  /* ---- Part B: Rig View Carousel ---- */
  function initRigCarousel() {
    if (!els.rigWrap) return;
    // Remove any previous nav
    var old = els.rigWrap.parentNode.querySelector('.vcp-rig-nav');
    if (old) old.parentNode.removeChild(old);

    if (!isMobile()) {
      isMobileView = false;
      if (els.rigSvg) els.rigSvg.setAttribute('viewBox', RIG_ORIGINAL_VB);
      return;
    }
    isMobileView = true;
    if (els.rigSvg) els.rigSvg.setAttribute('viewBox', RIG_VIEWS[mobileViewIndex].vb);

    // Create nav bar
    var nav = el('div', 'vcp-rig-nav');
    var btnLeft = el('button', 'vcp-rig-nav-btn vcp-rig-nav-prev');
    btnLeft.innerHTML = '&#9664;';
    btnLeft.setAttribute('aria-label', 'Previous view');
    var btnRight = el('button', 'vcp-rig-nav-btn vcp-rig-nav-next');
    btnRight.innerHTML = '&#9654;';
    btnRight.setAttribute('aria-label', 'Next view');
    var label = el('span', 'vcp-rig-nav-label');
    label.textContent = RIG_VIEWS[mobileViewIndex].label;

    // Dots
    var dots = el('div', 'vcp-rig-nav-dots');
    for (var i = 0; i < RIG_VIEWS.length; i++) {
      var dot = el('span', 'vcp-rig-nav-dot' + (i === mobileViewIndex ? ' vcp-active' : ''));
      dot.dataset.idx = i;
      dots.appendChild(dot);
    }

    nav.appendChild(btnLeft);
    nav.appendChild(dots);
    nav.appendChild(label);
    nav.appendChild(btnRight);

    btnLeft.addEventListener('click', function () { changeRigView(-1); });
    btnRight.addEventListener('click', function () { changeRigView(1); });
    // Tap dots
    dots.addEventListener('click', function (e) {
      var d = e.target.closest('.vcp-rig-nav-dot');
      if (d) { mobileViewIndex = parseInt(d.dataset.idx, 10); updateRigView(); }
    });

    els.rigWrap.parentNode.insertBefore(nav, els.rigWrap.nextSibling);
  }

  function changeRigView(dir) {
    mobileViewIndex = (mobileViewIndex + dir + RIG_VIEWS.length) % RIG_VIEWS.length;
    updateRigView();
  }

  function updateRigView() {
    if (!els.rigSvg) return;
    els.rigSvg.setAttribute('viewBox', RIG_VIEWS[mobileViewIndex].vb);
    var nav = els.rigWrap.parentNode.querySelector('.vcp-rig-nav');
    if (nav) {
      nav.querySelector('.vcp-rig-nav-label').textContent = RIG_VIEWS[mobileViewIndex].label;
      var allDots = nav.querySelectorAll('.vcp-rig-nav-dot');
      for (var i = 0; i < allDots.length; i++) {
        allDots[i].classList.toggle('vcp-active', i === mobileViewIndex);
      }
    }
  }

  /* ---- Part A: Color Sidebar Picker ---- */
  /* Always-visible vertical sidebar — supports Color, Embroidery, Contrast Stitch, JC Stitch */
  function showMobileColorPicker(mode) {
    // Ensure picker is visible (close() hides it)
    if (mobilePickerEl) mobilePickerEl.style.display = '';

    // Determine sidebar mode
    if (mode === 'contrastStitch' || mode === 'jcStitch') {
      sidebarMode = mode;
    } else if (mode === true || mode === 'embroidery' || (mode !== 'color' && activeMode === 'embroidery')) {
      sidebarMode = 'embroidery';
    } else {
      sidebarMode = 'color';
    }

    var isEmb = sidebarMode === 'embroidery';
    var isStitch = sidebarMode === 'contrastStitch' || sidebarMode === 'jcStitch';

    var colors, zoneName, currentColorId, activeColor;

    if (isStitch) {
      colors = EMBROIDERY_COLORS;
      if (sidebarMode === 'contrastStitch') {
        zoneName = 'Contrast Stitching';
        currentColorId = state.stitchColor;
      } else {
        zoneName = 'JC Stitching';
        currentColorId = state.jcColor;
      }
      activeColor = currentColorId ? colorById(currentColorId) : null;
    } else if (isEmb) {
      colors = EMB_THREAD_COLORS;
      var side = state.embSelectedSide;
      var slot = state.embSelectedColorSlot || 1;
      zoneName = side ? side.toUpperCase() : '';
      currentColorId = (side && state.embLogoColors[side]) ? state.embLogoColors[side][slot] : 'black';
      activeColor = embThreadColor(currentColorId);
    } else {
      colors = getColorsForMaterial();
      zoneName = '';
      if (state.selectedZones.length === 1) {
        zoneName = zoneLabel(state.selectedZones[0]);
      } else if (state.selectedZones.length > 1) {
        zoneName = state.selectedZones.length + ' zones';
      }
      currentColorId = null;
      if (state.selectedZones.length > 0) {
        var ck = getMaterialColorKey(state.selectedZones[0]);
        currentColorId = state.colorMap[ck] || null;
      }
      activeColor = currentColorId ? colorById(currentColorId) : null;
    }

    // Preview of selected color (collapsible on mobile, open by default)
    var previewCollapsed = mobilePickerEl.dataset.previewCollapsed === '1';
    var html = '';
    if (activeColor) {
      var prevBg = activeColor.img
        ? 'background:url(' + activeColor.img + ') center/cover no-repeat,' + activeColor.hex
        : 'background:' + activeColor.hex;
      html += '<div class="vcp-mp-preview-wrap">' +
        '<div class="vcp-mp-preview' + (previewCollapsed ? ' vcp-mp-preview-collapsed' : '') + '">' +
        '<div class="vcp-mp-preview-swatch" style="' + prevBg + '"></div>' +
        '<div class="vcp-mp-preview-name">' + activeColor.name + '</div>' +
        '</div>' +
        '<button class="vcp-mp-preview-arrow' + (previewCollapsed ? ' vcp-mp-arrow-collapsed' : '') + '" aria-label="Toggle preview">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M18 15l-6-6-6 6"/></svg>' +
        '</button>' +
        '</div>';
    }

    if (zoneName) {
      html += '<div class="vcp-mp-title">' + zoneName + '</div>';
    }

    html += '<div class="vcp-mp-grid">';
    for (var i = 0; i < colors.length; i++) {
      var c = colors[i];
      var cId = c.id;
      var isActive = isStitch ? (cId === currentColorId) :
        (cId === currentColorId || (isEmb && currentColorId && currentColorId.replace('em-','').replace(/-/g,'') === cId));
      var isLight = (isEmb || isStitch) ? (c.hex === '#ffffff' || c.hex === '#FFFFFF' || c.light) : c.light;
      var lightCls = isLight ? ' vcp-mp-dot-light' : '';
      var bgStyle = c.img
        ? 'background:url(' + c.img + ') center/cover no-repeat,' + c.hex + ';'
        : 'background:' + c.hex + ';';
      html += '<button class="vcp-mp-dot' + (isActive ? ' vcp-mp-active' : '') + lightCls + '" data-color="' + cId + '" title="' + c.name + '" style="' + bgStyle + '">' +
        (isActive ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg>' : '') +
        '</button>';
    }
    html += '</div>';

    // Paint brush toggle (only in color mode)
    if (sidebarMode === 'color') {
      html += '<div class="vcp-mp-brush-wrap">' +
        '<button class="vcp-mp-brush-btn' + (state.paintBrush ? ' vcp-active' : '') + '" title="Paint brush: pick a color then click zones">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="' + (state.paintBrush ? 'currentColor' : 'none') + '" stroke="currentColor" stroke-width="2"><path d="M18.37 2.63a2.12 2.12 0 0 1 3 3L14 13l-4 1 1-4 7.37-7.37z"/><path d="M9 15.5C5.5 15.5 3 18 3 21h4c0-1.5.5-3 2-3"/></svg>' +
        '</button></div>';
    }

    mobilePickerEl.innerHTML = html;

    // Capture current mode for closure
    var curMode = sidebarMode;

    // Event delegation
    mobilePickerEl.onclick = function (e) {
      // Paint brush toggle
      var brushBtn = e.target.closest('.vcp-mp-brush-btn');
      if (brushBtn) {
        state.paintBrush = !state.paintBrush;
        if (!state.paintBrush) {
          state.paintBrushColor = null;
        } else {
          // Auto-pick currently active color so brush works immediately
          var activeDot = mobilePickerEl.querySelector('.vcp-mp-dot.vcp-mp-active');
          if (activeDot) state.paintBrushColor = activeDot.dataset.color;
        }
        brushBtn.classList.toggle('vcp-active', state.paintBrush);
        brushBtn.querySelector('svg').setAttribute('fill', state.paintBrush ? 'currentColor' : 'none');
        return;
      }
      // Preview toggle arrow
      var arrowBtn = e.target.closest('.vcp-mp-preview-arrow');
      if (arrowBtn) {
        var prev = mobilePickerEl.querySelector('.vcp-mp-preview');
        if (prev) {
          var collapsed = prev.classList.toggle('vcp-mp-preview-collapsed');
          arrowBtn.classList.toggle('vcp-mp-arrow-collapsed', collapsed);
          mobilePickerEl.dataset.previewCollapsed = collapsed ? '1' : '0';
        }
        return;
      }
      var dot = e.target.closest('.vcp-mp-dot');
      if (dot) {
        var colorId = dot.dataset.color;
        if (curMode === 'contrastStitch') {
          state.stitchColor = colorId;
          applyContrastStitchingPreview();
          saveDraft();
          renderZoneListButtons();
        } else if (curMode === 'jcStitch') {
          state.jcColor = colorId;
          applyJCStitchingPreview();
          saveDraft();
          renderZoneListButtons();
        } else if (curMode === 'embroidery') {
          applyThreadColorToSelected(colorId);
        } else {
          if (state.paintBrush) {
            state.paintBrushColor = colorId;
          }
          applyColorToSelected(colorId);
        }
        // Update active dot
        var allDots = mobilePickerEl.querySelectorAll('.vcp-mp-dot');
        for (var j = 0; j < allDots.length; j++) {
          allDots[j].classList.remove('vcp-mp-active');
          allDots[j].innerHTML = '';
        }
        dot.classList.add('vcp-mp-active');
        dot.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg>';
        // Update preview
        var newColor = (curMode === 'embroidery') ? embThreadColor(colorId) : colorById(colorId);
        var prev = mobilePickerEl.querySelector('.vcp-mp-preview');
        if (newColor) {
          var newBg = newColor.img
            ? 'url(' + newColor.img + ') center/cover no-repeat,' + newColor.hex
            : newColor.hex;
          if (prev) {
            prev.querySelector('.vcp-mp-preview-swatch').style.background = newBg;
            prev.querySelector('.vcp-mp-preview-name').textContent = newColor.name;
          } else {
            var pHtml = '<div class="vcp-mp-preview-wrap"><div class="vcp-mp-preview">' +
              '<div class="vcp-mp-preview-swatch" style="background:' + newBg + '"></div>' +
              '<div class="vcp-mp-preview-name">' + newColor.name + '</div></div>' +
              '<button class="vcp-mp-preview-arrow" aria-label="Toggle preview">' +
              '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M18 15l-6-6-6 6"/></svg></button></div>';
            var grid = mobilePickerEl.querySelector('.vcp-mp-grid');
            if (grid) grid.insertAdjacentHTML('beforebegin', pHtml);
          }
        }
      }
    };
  }

  function hideMobileColorPicker() {
    if (mobilePickerEl) mobilePickerEl.style.display = 'none';
  }

  function updateMobilePickerIfOpen() {
    if (mobilePickerEl) {
      showMobileColorPicker(sidebarMode); // Re-render preserving current mode
    }
  }

  /* ================================================================
     HELPERS
     ================================================================ */
  function el(tag, cls, attrs) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    return e;
  }

  function svgEl(tag, attrs) {
    var e = document.createElementNS('http://www.w3.org/2000/svg', tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    return e;
  }

  function defaultColorMap() {
    var m = {};
    // Cordura zones default to black
    ALL_ZONE_IDS.forEach(function (id) { m[id] = 'black'; });
    // Harness zones default to black (hw- prefix colors)
    HARNESS_ZONES.forEach(function (id) { m['harness:' + id] = 'hw-black'; });
    // Trim zones default to black (tt- prefix colors)
    TRIM_ZONES.forEach(function (id) { m['trim:' + id] = 'tt-black'; });
    return m;
  }

  // Get the state key for a zone based on current material
  function getMaterialColorKey(zoneId) {
    switch (activeMaterial) {
      case 'harness': return 'harness:' + zoneId;
      case 'trim': return 'trim:' + zoneId;
      case 'piping': return 'piping:' + zoneId;
      default: return zoneId; // cordura and embroidery use base zone IDs
    }
  }

  // Get default color for a material type
  function getDefaultColorForMaterial(material) {
    switch (material) {
      case 'harness': return 'hw-black';
      case 'trim': return 'tt-black';
      case 'piping': return 'tt-black';
      case 'embroidery': return 'em-black';
      default: return 'black';
    }
  }

  function zoneLabel(id) {
    var label = PIPING_ZONE_NAMES[id] || ZONE_LABELS[id] || id;
    var extras = PATTERN_EXTRA_ZONES[currentPattern] || [];
    if (id === 'c2' && extras.indexOf('c2b') !== -1) label = '2A';
    if (id === 'c4' && extras.indexOf('c4b') !== -1) label = '4A';
    return label;
  }

  /* ================================================================
     LOAD CONTAINER RIG SVG
     Fetches the per-pattern SVG and injects it into the diagram panel.
     Caches fetched markup so switching patterns is instant.
     ================================================================ */
  function loadRigSvg(pattern, callback) {
    pattern = pattern || 'standard';

    // Resolve URL from the per-pattern map or legacy single URL
    var urls = window.VCP_RIG_SVG_URLS || {};
    var url = urls[pattern] || window.VCP_RIG_SVG_URL;
    if (!url) {
      console.warn('VCP: No rig SVG URL for pattern "' + pattern + '"');
      callback();
      return;
    }

    function inject(markup) {
      els.rigWrap.innerHTML = markup;
      els.rigSvg = els.rigWrap.querySelector('svg');
      if (els.rigSvg) {
        els.rigSvg.removeAttribute('width');
        els.rigSvg.removeAttribute('height');
        els.rigSvg.removeAttribute('x');
        els.rigSvg.removeAttribute('y');
        els.rigSvg.style.width = '100%';
        els.rigSvg.style.height = 'auto';
        // Hide centerflap for patterns where SOLO overlays cover the flap area
        // (matches UPT original: vsplit, tricolorvsplit, triplevsplit, lightning, zigzag)
        var hideFlapPatterns = {'v-split':1,'lightning':1,'triple-lightning':1,'zigzag':1};
        if (hideFlapPatterns[pattern]) {
          var centerflapGrp = els.rigSvg.getElementById('centerflap');
          if (centerflapGrp) centerflapGrp.style.display = 'none';
        }
        attachSvgListeners();
        // Add data-zone attributes to piping sub-groups so click handler can detect them
        var pipGrp = els.rigSvg.getElementById('piping');
        if (pipGrp) {
          PIPING_ZONES.forEach(function(zId) {
            var g = pipGrp.querySelector('#' + zId);
            if (g) {
              g.setAttribute('data-zone', zId);
              // Disable hit polygon so flap panels underneath stay clickable
              var bot = g.querySelector('#' + zId + 'bot');
              if (bot) {
                bot.style.pointerEvents = 'none';
              }
              // Add wider invisible stroke copies of lines for easier clicking
              var lines = g.querySelectorAll('line, path');
              for (var li = 0; li < lines.length; li++) {
                var hitLine = lines[li].cloneNode(false);
                hitLine.removeAttribute('id');
                hitLine.setAttribute('stroke-width', '8');
                hitLine.setAttribute('stroke-opacity', '0');
                hitLine.setAttribute('data-zone', zId);
                hitLine.style.pointerEvents = 'stroke';
                hitLine.style.cursor = 'pointer';
                g.appendChild(hitLine);
              }
            }
          });
        }
        setupRigEmbroideryOverlay();
        refreshRigEmbroideryLogos();
        // Hide panel numbers + leader lines by default
        if (!state.showPanelNumbers) {
          var partnums = els.rigSvg.getElementById('partnums');
          if (partnums) partnums.style.display = 'none';
          var textEls = els.rigSvg.querySelectorAll('text[pointer-events="none"]');
          for (var ti = 0; ti < textEls.length; ti++) {
            textEls[ti].style.display = 'none';
          }
        }
      }
      callback();
      initRigCarousel();
    }

    // Use cache if available
    if (rigSvgCache[pattern]) {
      inject(rigSvgCache[pattern]);
      return;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      if (xhr.status === 200) {
        rigSvgCache[pattern] = xhr.responseText;
        inject(xhr.responseText);
      } else {
        callback();
      }
    };
    xhr.send();
  }

  // Get zones that are clickable for current material
  function getActiveZones() {
    switch (activeMaterial) {
      case 'harness': return HARNESS_ZONES;
      case 'trim': return TRIM_ZONES;
      case 'embroidery': return BASE_ZONE_IDS; // embroidery uses main container zones
      default: return ALL_ZONE_IDS; // cordura uses all main zones
    }
  }

  function attachSvgListeners() {
    if (!els.rigSvg) return;

    // Click delegation for zone selection (allows all zones, auto-switches material)
    els.rigSvg.addEventListener('click', function (e) {
      // Check the clicked element first, then traverse up
      var target = e.target;
      var zoneId = target.getAttribute('data-zone');
      if (!zoneId) {
        target = e.target.closest('[data-zone]');
        if (!target) return;
        zoneId = target.getAttribute('data-zone');
      }
      if (!zoneId) return;

      // Determine which material this zone belongs to and switch if needed
      var zoneMaterial = 'cordura';
      if (HARNESS_ZONES.indexOf(zoneId) !== -1) {
        zoneMaterial = 'harness';
      } else if (TRIM_ZONES.indexOf(zoneId) !== -1) {
        // TRIM LOCKED on split patterns — auto-follows body panels
        if (currentPattern !== 'standard' && currentPattern !== 'full-custom') return;
        zoneMaterial = 'trim';
      } else if (PIPING_ZONES.indexOf(zoneId) !== -1) {
        zoneMaterial = 'piping';
      }

      // Paint brush mode: apply stored color directly to clicked zone
      if (state.paintBrush && state.paintBrushColor && activeMode === 'color') {
        // Only paint zones of the same material — turn off brush if material differs
        if (zoneMaterial !== activeMaterial) {
          state.paintBrush = false;
          state.paintBrushColor = null;
          showMobileColorPicker('color');
        } else {
          // Resolve zone group for locked patterns
          var zonesToPaint;
          if (zoneToGroup && zoneToGroup[zoneId]) {
            zonesToPaint = zoneToGroup[zoneId].ids.slice();
          } else {
            zonesToPaint = [zoneId];
          }
          zonesToPaint.forEach(function (zId) {
            var colorKey = getMaterialColorKey(zId);
            state.colorMap[colorKey] = state.paintBrushColor;
            updateZoneFill(zId);
          });
          renderZoneListButtons();
          saveDraft();
          return;
        }
      }

      // Auto-enable piping if a piping zone is clicked while piping is off
      if (zoneMaterial === 'piping' && !state.pipingEnabled) {
        state.pipingEnabled = true;
        applyPipingColors();
        renderPipingToggle();
        renderZoneListButtons();
      }

      // Auto-switch to the appropriate material
      if (zoneMaterial !== activeMaterial) {
        switchMaterial(zoneMaterial);
      }

      handleZoneClick(zoneId, e.shiftKey);
    });

    // Hover tooltip for zones (shows tooltip for all zones regardless of material)
    els.rigSvg.addEventListener('mouseover', function (e) {
      var target = e.target.closest('[data-zone]');
      if (!target) return;
      var zoneId = target.getAttribute('data-zone');
      // Show tooltip if zone is in any known zone list
      var allKnownZones = ALL_ZONE_IDS.concat(TRIM_ZONES, HARNESS_ZONES, PIPING_ZONES);
      if (allKnownZones.indexOf(zoneId) === -1) return;
      // Auto-detect color key based on zone type (not activeMaterial)
      var colorKey;
      if (TRIM_ZONES.indexOf(zoneId) !== -1) colorKey = 'trim:' + zoneId;
      else if (HARNESS_ZONES.indexOf(zoneId) !== -1) colorKey = 'harness:' + zoneId;
      else if (PIPING_ZONES.indexOf(zoneId) !== -1) colorKey = 'piping:' + zoneId;
      else colorKey = zoneId;
      var defaultColor = (TRIM_ZONES.indexOf(zoneId) !== -1) ? 'tt-black'
        : (HARNESS_ZONES.indexOf(zoneId) !== -1) ? 'hw-black' : 'black';
      var c = colorById(state.colorMap[colorKey] || defaultColor);
      var label = zoneLabel(zoneId);
      if (zoneToGroup && zoneToGroup[zoneId]) {
        label = zoneToGroup[zoneId].name + ' \u2022 ' + label;
      }
      tooltipEl.textContent = label + ' \u2014 ' + c.name;
      tooltipEl.classList.add('vcp-tip-show');
    });
    els.rigSvg.addEventListener('mousemove', function (e) {
      if (tooltipEl.classList.contains('vcp-tip-show')) {
        positionTooltip(e);
      }
    });
    els.rigSvg.addEventListener('mouseout', function (e) {
      var target = e.target.closest('[data-zone]');
      if (target) {
        tooltipEl.classList.remove('vcp-tip-show');
      }
    });
  }

  /* ================================================================
     BUILD MODAL DOM (once, on first open)
     ================================================================ */
  var built = false;

  function buildOnce(pattern, onReady) {
    if (built) {
      // DOM already exists — just swap the SVG for the new pattern
      loadRigSvg(pattern, onReady);
      return;
    }
    built = true;

    // Overlay
    els.overlay = el('div', 'vcp-overlay');
    els.overlay.addEventListener('click', function (e) {
      if (e.target === els.overlay) showCloseWarning();
    });

    // Modal container
    els.modal = el('div', 'vcp-modal');
    els.overlay.appendChild(els.modal);

    // --- Header ---
    els.header = el('div', 'vcp-header');

    // Left group: title + pattern label
    var headerLeft = el('div', 'vcp-header-left');
    var titleH = el('h2', 'vcp-title');
    titleH.innerHTML = 'Container Color Designer <span class="vcp-title-pattern"></span>';
    els.patternLabel = titleH.querySelector('.vcp-title-pattern');
    headerLeft.appendChild(titleH);
    els.header.appendChild(headerLeft);

    // Undo / Redo buttons (between left and right groups)
    var undoRedoWrap = el('div', 'vcp-undo-redo');
    els.undoBtn = el('button', 'vcp-undo-btn');
    els.undoBtn.innerHTML = '&#8630;';  // ↶
    els.undoBtn.title = 'Undo (Ctrl+Z)';
    els.undoBtn.disabled = true;
    els.undoBtn.addEventListener('click', undoAction);
    undoRedoWrap.appendChild(els.undoBtn);
    els.redoBtn = el('button', 'vcp-redo-btn');
    els.redoBtn.innerHTML = '&#8631;';  // ↷
    els.redoBtn.title = 'Redo (Ctrl+Y)';
    els.redoBtn.disabled = true;
    els.redoBtn.addEventListener('click', redoAction);
    undoRedoWrap.appendChild(els.redoBtn);

    // Right group: undo/redo + design name + save + close
    var headerRight = el('div', 'vcp-header-right');
    headerRight.appendChild(undoRedoWrap);

    els.designNameInput = el('input', 'vcp-design-name');
    els.designNameInput.type = 'text';
    els.designNameInput.placeholder = 'Enter design name *';
    els.designNameInput.maxLength = 40;
    els.designNameInput.addEventListener('input', function() {
      state.designName = this.value;
      // Clear error state on typing
      this.classList.remove('vcp-design-name-error');
      var errEl = document.getElementById('vcp-design-name-err');
      if (errEl) errEl.style.display = 'none';
    });
    headerRight.appendChild(els.designNameInput);

    var designNameErr = el('span', 'vcp-design-name-err');
    designNameErr.id = 'vcp-design-name-err';
    designNameErr.textContent = 'Please enter a design name to save';
    designNameErr.style.display = 'none';
    headerRight.appendChild(designNameErr);

    var saveBtn = el('button', 'vcp-save-btn');
    saveBtn.textContent = 'Save & Close';
    saveBtn.addEventListener('click', handleSave);
    headerRight.appendChild(saveBtn);

    // No standalone close (X) button — user must use "Save & Close" or confirm leave

    els.header.appendChild(headerRight);
    els.modal.appendChild(els.header);

    // --- Body ---
    els.body = el('div', 'vcp-body');

    // Top: Rig section (full width)
    els.rigSection = el('div', 'vcp-rig-section');

    // Toolbar (inside rig section) - mode toggle + texture toggle
    els.toolbar = el('div', 'vcp-toolbar');

    // Mode toggle buttons (Color / Embroidery)
    els.modeToggle = el('div', 'vcp-mode-toggle');
    els.colorModeBtn = el('button', 'vcp-mode-btn vcp-mode-active');
    els.colorModeBtn.textContent = 'Color';
    els.colorModeBtn.addEventListener('click', function () {
      switchMode('color');
    });
    els.modeToggle.appendChild(els.colorModeBtn);
    els.embModeBtn = el('button', 'vcp-mode-btn');
    els.embModeBtn.textContent = 'Embroidery';
    els.embModeBtn.addEventListener('click', function () {
      switchMode('embroidery');
    });
    els.modeToggle.appendChild(els.embModeBtn);
    els.toolbar.appendChild(els.modeToggle);

    // Spacer to push right-side items
    var toolbarSpacer = el('div', 'vcp-toolbar-spacer');
    els.toolbar.appendChild(toolbarSpacer);

    // Fabric / Flat color toggle
    els.fabricToggle = el('button', 'vcp-tool-btn vcp-fabric-toggle-btn vcp-active');
    els.fabricToggle.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M3 6h18M3 12h18M3 18h18"/></svg> Fabric';
    els.fabricToggle.title = 'Toggle fabric texture / flat color view';
    els.fabricToggle.addEventListener('click', function () {
      state.showFabricTextures = !state.showFabricTextures;
      els.fabricToggle.classList.toggle('vcp-active', state.showFabricTextures);
      els.fabricToggle.innerHTML = state.showFabricTextures
        ? '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M3 6h18M3 12h18M3 18h18"/></svg> Fabric'
        : '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="3" y="3" width="18" height="18" rx="3"/></svg> Flat';
      refreshAllZoneFills();
      if (embroiderySvgDoc) renderEmbroideryPreviews();
    });
    els.toolbar.appendChild(els.fabricToggle);

    // Reset button (moved from footer)
    var resetBtn = el('button', 'vcp-tool-btn vcp-reset-tool-btn');
    resetBtn.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg> Reset';
    resetBtn.title = 'Reset all colors';
    resetBtn.addEventListener('click', function () {
      if (!confirm('Confirm, you want to fully reset all colors?')) return;
      state.colorMap = defaultColorMap();
      refreshAllZoneFills();
      state.selectedZones = [];
      refreshZoneHighlights();
      updateSelectionInfo();
    });
    els.toolbar.appendChild(resetBtn);

    els.rigSection.appendChild(els.toolbar);

    // Container rig SVG wrapper (full width)
    els.rigWrap = el('div', 'vcp-rig-wrap');
    els.rigSection.appendChild(els.rigWrap);

    // Color sidebar (always visible)
    mobilePickerEl = el('div', 'vcp-mobile-picker');
    els.body.appendChild(mobilePickerEl);

    // Body content wrapper (rig + content panel)
    els.bodyContent = el('div', 'vcp-body-content');
    els.bodyContent.appendChild(els.rigSection);

    // Bottom: Content panel (zone list + palette side by side)
    els.contentPanel = el('div', 'vcp-content-panel');

    // Left: diagram panel (zone list + embroidery previews)
    els.diagramPanel = el('div', 'vcp-diagram-panel');

    // Zone selection list
    els.zoneListSection = el('div', 'vcp-zone-list-section');
    els.zoneListGrid = el('div', 'vcp-zone-list-grid');
    els.zoneListSection.appendChild(els.zoneListGrid);
    els.diagramPanel.appendChild(els.zoneListSection);

    els.contentPanel.appendChild(els.diagramPanel);

    // Right: palette panel
    els.palettePanel = el('div', 'vcp-palette-panel');

    // Contrast Stitching section (with preview image) - shown only for Harness
    els.stitchSection = el('div', 'vcp-stitch-section');
    var stitchHeader = el('div', 'vcp-stitch-header');
    var stitchToggle = el('label', 'vcp-stitch-toggle');
    els.stitchCheckbox = el('input');
    els.stitchCheckbox.type = 'checkbox';
    els.stitchCheckbox.addEventListener('change', function () {
      state.contrastStitch = this.checked;
      els.stitchBody.style.display = this.checked ? 'block' : 'none';
      applyContrastStitchingPreview();
      saveDraft();
    });
    stitchToggle.appendChild(els.stitchCheckbox);
    var stitchLabelWrap = el('div', 'vcp-stitch-label-wrap');
    var stitchLabelText = el('span', 'vcp-stitch-label');
    stitchLabelText.textContent = 'Contrast Stitching';
    stitchLabelWrap.appendChild(stitchLabelText);
    var stitchDesc = el('span', 'vcp-stitch-desc');
    stitchDesc.textContent = 'Add a different color stitching for visual accent';
    stitchLabelWrap.appendChild(stitchDesc);
    stitchToggle.appendChild(stitchLabelWrap);
    var stitchPrice = el('span', 'vcp-option-price');
    stitchPrice.textContent = '+€85';
    stitchHeader.appendChild(stitchToggle);
    stitchHeader.appendChild(stitchPrice);
    els.stitchSection.appendChild(stitchHeader);

    // Stitch body (shown when enabled)
    els.stitchBody = el('div', 'vcp-stitch-body');
    els.stitchBody.style.display = 'none';

    // Preview image
    var stitchImgWrap = el('div', 'vcp-stitch-img-wrap');
    var stitchImg = el('img', 'vcp-stitch-img');
    stitchImg.src = 'https://cdn.shopify.com/s/files/1/0758/1191/4071/files/vcp-config-tool-Contrast-Stitching-470x705.jpg';
    stitchImg.alt = 'Contrast stitching example';
    stitchImg.loading = 'lazy';
    stitchImgWrap.appendChild(stitchImg);
    els.stitchBody.appendChild(stitchImgWrap);

    // Stitch color picker
    var stitchColorLabel = el('div', 'vcp-stitch-color-label');
    stitchColorLabel.textContent = 'Stitching Color';
    els.stitchBody.appendChild(stitchColorLabel);
    els.stitchPicker = el('div', 'vcp-stitch-picker');
    els.stitchBody.appendChild(els.stitchPicker);

    els.stitchSection.appendChild(els.stitchBody);
    // (Contrast stitching now rendered inline in zone list — not appended to palette)

    // ── JC Stitching section ──
    els.jcSection = el('div', 'vcp-stitch-section vcp-jc-section');
    var jcHeader = el('div', 'vcp-stitch-header');
    var jcToggle = el('label', 'vcp-stitch-toggle');
    els.jcCheckbox = el('input');
    els.jcCheckbox.type = 'checkbox';
    els.jcCheckbox.addEventListener('change', function () {
      state.jcStitching = this.checked;
      els.jcBody.style.display = this.checked ? 'block' : 'none';
      applyJCStitchingPreview();
      saveDraft();
    });
    jcToggle.appendChild(els.jcCheckbox);
    var jcLabelWrap = el('div', 'vcp-stitch-label-wrap');
    var jcLabelText = el('span', 'vcp-stitch-label');
    jcLabelText.textContent = 'JC Stitching';
    jcLabelWrap.appendChild(jcLabelText);
    var jcDesc = el('span', 'vcp-stitch-desc');
    jcDesc.textContent = 'Decorative JC accent stitching on the container';
    jcLabelWrap.appendChild(jcDesc);
    jcToggle.appendChild(jcLabelWrap);
    var jcPrice = el('span', 'vcp-option-price');
    jcPrice.textContent = '+€85';
    jcHeader.appendChild(jcToggle);
    jcHeader.appendChild(jcPrice);
    els.jcSection.appendChild(jcHeader);

    els.jcBody = el('div', 'vcp-stitch-body');
    els.jcBody.style.display = 'none';
    var jcImgWrap = el('div', 'vcp-stitch-img-wrap');
    var jcImg = el('img', 'vcp-stitch-img');
    jcImg.src = 'https://cdn.shopify.com/s/files/1/0758/1191/4071/files/vcp-config-tool-JC-470x705.jpg';
    jcImg.alt = 'JC stitching example';
    jcImg.loading = 'lazy';
    jcImgWrap.appendChild(jcImg);
    els.jcBody.appendChild(jcImgWrap);
    var jcColorLabel = el('div', 'vcp-stitch-color-label');
    jcColorLabel.textContent = 'JC Stitching Color';
    els.jcBody.appendChild(jcColorLabel);
    els.jcPicker = el('div', 'vcp-stitch-picker');
    els.jcBody.appendChild(els.jcPicker);
    els.jcSection.appendChild(els.jcBody);
    // (JC stitching now rendered inline in zone list — not appended to palette)

    // Piping state elements (toggle moved to left zone list, no right sidebar section)
    els.pipingCheckbox = el('input');
    els.pipingCheckbox.type = 'checkbox';
    els.pipingCheckbox.style.display = 'none';
    els.pipingZoneSwatches = {};

    els.palTitle = el('div', 'vcp-palette-title');
    els.palTitle.textContent = 'Cordura Colors';
    els.palettePanel.appendChild(els.palTitle);

    els.palSub = el('div', 'vcp-palette-subtitle');
    els.palSub.textContent = 'Click a zone on the rig, then pick a color';
    els.palettePanel.appendChild(els.palSub);

    // Search removed — not needed

    // Color grid
    els.colorGrid = el('div', 'vcp-color-grid');
    els.palettePanel.appendChild(els.colorGrid);

    // Embroidery Positions section (inside diagram panel, hidden by default)
    els.embPreviewSection = el('div', 'vcp-emb-preview-section');
    els.embPreviewSection.style.display = 'none';
    var embPreviewTitle = el('div', 'vcp-emb-preview-title');
    embPreviewTitle.textContent = 'Embroidery Positions';
    els.embPreviewSection.appendChild(embPreviewTitle);
    els.embPreviewGrid = el('div', 'vcp-emb-preview-grid');
    els.embPreviewSection.appendChild(els.embPreviewGrid);
    els.diagramPanel.appendChild(els.embPreviewSection);

    els.contentPanel.appendChild(els.palettePanel);
    // Palette panel hidden in color mode (mobile picker handles color selection)
    els.palettePanel.style.display = 'none';
    els.bodyContent.appendChild(els.contentPanel);
    els.body.appendChild(els.bodyContent);
    els.modal.appendChild(els.body);

    // (Footer removed — reset button now in toolbar, save in header)

    // Tooltip (floating)
    tooltipEl = el('div', 'vcp-swatch-name-tip');
    document.body.appendChild(tooltipEl);

    // Append overlay to body
    document.body.appendChild(els.overlay);

    // Render palette
    renderFullPalette();

    // Load the container rig SVG for the requested pattern
    loadRigSvg(pattern, onReady);
  }

  /* ================================================================
     ZONE INTERACTION
     ================================================================ */
  function handleZoneClick(zoneId, addToSelection) {
    // Zone group locking: select entire group for non-full-custom patterns
    if (zoneToGroup && zoneToGroup[zoneId]) {
      state.selectedZones = zoneToGroup[zoneId].ids.slice();
      refreshZoneHighlights();
      updateSelectionInfo();
      showMobileColorPicker();
      return;
    }
    // Full-custom or unknown: individual zone selection
    if (addToSelection) {
      var idx = state.selectedZones.indexOf(zoneId);
      if (idx === -1) {
        state.selectedZones.push(zoneId);
      } else {
        state.selectedZones.splice(idx, 1);
      }
    } else {
      state.selectedZones = [zoneId];
    }
    refreshZoneHighlights();
    updateSelectionInfo();
    showMobileColorPicker();
  }

  function refreshZoneHighlights() {
    var all = els.overlay.querySelectorAll('.vcp-zone-path');
    for (var i = 0; i < all.length; i++) {
      var id = all[i].getAttribute('data-zone');
      all[i].classList.toggle('vcp-zone-selected', state.selectedZones.indexOf(id) !== -1);
    }
    // Also update zone list button states
    renderZoneListButtons();
  }

  function updateSelectionInfo() {
    // Removed — selection info element no longer exists
  }

  function applyColorToSelected(colorId) {
    if (state.selectedZones.length === 0) return;
    state.selectedZones.forEach(function (zoneId) {
      var colorKey = getMaterialColorKey(zoneId);
      state.colorMap[colorKey] = colorId;
      updateZoneFill(zoneId);
    });
    updateSelectionInfo();
    refreshActiveSwatch();
    renderZoneListButtons(); // Update button color dots
    // Update piping on rig SVG when piping zones change
    if (activeMaterial === 'piping') {
      applyPipingColors();
      renderPipingToggle();
    }
    // Trim tape auto-follows body panel colors (split patterns only)
    if (activeMaterial === 'cordura' && currentPattern !== 'standard' && currentPattern !== 'full-custom') {
      syncTrimToParentZones();
    }
    saveDraft();
  }

  function updateZoneFill(zoneId) {
    // For cordura zones, use direct lookup; for trim/harness/piping, use prefixed lookup
    var colorKey;
    var defaultColor = 'black';
    if (PIPING_ZONES.indexOf(zoneId) !== -1) {
      colorKey = 'piping:' + zoneId;
      defaultColor = 'tt-black';
    } else if (TRIM_ZONES.indexOf(zoneId) !== -1) {
      colorKey = 'trim:' + zoneId;
      defaultColor = 'tt-black';
    } else if (HARNESS_ZONES.indexOf(zoneId) !== -1) {
      colorKey = 'harness:' + zoneId;
      defaultColor = 'hw-black';
    } else {
      colorKey = zoneId;
    }
    var c = colorById(state.colorMap[colorKey] || defaultColor);
    var paths = els.overlay.querySelectorAll('.vcp-zone-path[data-zone="' + zoneId + '"]');
    var fillValue = c.hex;
    // When textures ON and color has an image, use SVG pattern fill
    var isHarnessZone = HARNESS_ZONES.indexOf(zoneId) !== -1;
    if (state.showFabricTextures && c.img && els.rigSvg) {
      fillValue = ensureTexturePattern(c, isHarnessZone);
    }
    for (var i = 0; i < paths.length; i++) {
      paths[i].setAttribute('fill', fillValue);
    }
  }

  // Create or reuse an SVG <pattern> for a fabric texture image
  // isHarness: use smaller tile for harness webbing (small SVG path area)
  function ensureTexturePattern(color, isHarness) {
    if (!els.rigSvg) return color.hex;
    var patId = 'vcp-pat-' + color.id + (isHarness ? '-hw' : '');
    var existing = els.rigSvg.getElementById(patId);
    if (existing) return 'url(#' + patId + ')';

    // Ensure root-level <defs> exists
    var defs = getOrCreateRootDefs(els.rigSvg);

    var TILE = 140; // tile size in SVG units — matches sidebar swatch zoom level
    var TILE_HW = 50; // harness webbing tile — smaller for narrow webbing paths
    // Per-color overrides: some source photos are framed closer-up than others,
    // making their weave look oversized at the default TILE. Bigger tile = smaller
    // apparent weave. Keep additions here when we spot more offenders.
    var TILE_OVERRIDES = {
      'red': 220
    };
    var tileSize;
    if (isHarness) tileSize = TILE_HW;
    else if (TILE_OVERRIDES[color.id]) tileSize = TILE_OVERRIDES[color.id];
    else tileSize = TILE;
    var pat = document.createElementNS('http://www.w3.org/2000/svg', 'pattern');
    pat.setAttribute('id', patId);
    pat.setAttribute('patternUnits', 'userSpaceOnUse');
    pat.setAttribute('width', String(tileSize));
    pat.setAttribute('height', String(tileSize));

    var img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
    img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', color.img);
    img.setAttribute('width', String(tileSize));
    img.setAttribute('height', String(tileSize));
    img.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    pat.appendChild(img);
    defs.appendChild(pat);

    return 'url(#' + patId + ')';
  }

  function refreshAllZoneFills() {
    // Refresh cordura/main zones
    ALL_ZONE_IDS.forEach(function (id) { updateZoneFill(id); });
    // Sync trim tape to body panel colors (split patterns only; standard/full-custom = manual)
    if (currentPattern !== 'standard' && currentPattern !== 'full-custom') {
      syncTrimToParentZones();
    } else {
      TRIM_ZONES.forEach(function (id) { updateZoneFill(id); });
    }
    // Refresh harness zones
    HARNESS_ZONES.forEach(function (id) { updateZoneFill(id); });
    // Refresh piping zones & apply to rig SVG
    PIPING_ZONES.forEach(function (id) { updateZoneFill(id); });
    applyPipingColors();
    applyContrastStitchingPreview();
    applyJCStitchingPreview();
  }

  // Apply piping colors to the rig SVG
  function applyPipingColors() {
    if (!els.rigSvg) return;
    var pipingGroup = els.rigSvg.getElementById('piping');
    if (!pipingGroup) return;

    var hasPiping = false;
    PIPING_ZONES.forEach(function(zoneId) {
      var colorId = state.colorMap['piping:' + zoneId];
      if (!colorId) return;
      hasPiping = true;
      var color = colorById(colorId);
      if (!color) return;

      // Color the stroke lines (e.g., pb1, pb2) — thin 2px stitching lines
      var line1 = els.rigSvg.getElementById(zoneId + '1');
      var line2 = els.rigSvg.getElementById(zoneId + '2');
      var bot = els.rigSvg.getElementById(zoneId + 'bot');

      if (line1) { line1.setAttribute('stroke', color.hex); line1.setAttribute('stroke-width', '2'); }
      if (line2) { line2.setAttribute('stroke', color.hex); line2.setAttribute('stroke-width', '2'); }
      // Keep bot polygon transparent (no wide fill)
      if (bot) { bot.setAttribute('fill-opacity', '0'); }
    });

    // Show piping group if piping is enabled OR has colors set
    var showPiping = state.pipingEnabled || hasPiping;
    pipingGroup.setAttribute('display', showPiping ? 'inline' : 'none');
    pipingGroup.style.display = showPiping ? 'inline' : 'none';
  }

  // Apply contrast stitching dotted line preview on harness webbing paths
  function applyContrastStitchingPreview() {
    if (!els.rigSvg) return;
    // Remove existing contrast stitch preview lines
    var existing = els.rigSvg.querySelectorAll('.vcp-jc-dash');
    for (var r = 0; r < existing.length; r++) existing[r].parentNode.removeChild(existing[r]);
    if (!state.contrastStitch) return;
    var jcColorObj = colorById(state.stitchColor);
    if (!jcColorObj) return;
    // Find harness zone paths in the overlay
    var harnessPaths = els.overlay.querySelectorAll('.vcp-zone-path[data-zone="harness"]');
    for (var h = 0; h < harnessPaths.length; h++) {
      var orig = harnessPaths[h];
      var clone = orig.cloneNode(false);
      clone.removeAttribute('id');
      clone.setAttribute('class', 'vcp-jc-dash');
      clone.setAttribute('fill', 'none');
      clone.setAttribute('stroke', jcColorObj.hex);
      clone.setAttribute('stroke-width', '1.5');
      clone.setAttribute('stroke-dasharray', '4 3');
      clone.setAttribute('pointer-events', 'none');
      clone.style.pointerEvents = 'none';
      clone.style.opacity = '0.85';
      orig.parentNode.insertBefore(clone, orig.nextSibling);
    }
  }

  // Apply JC crosshatch stitching overlay on cordura panel paths
  function applyJCStitchingPreview() {
    if (!els.rigSvg) return;

    // Remove existing crosshatch overlays
    var existing = els.rigSvg.querySelectorAll('.vcp-jc-crosshatch-overlay');
    for (var r = 0; r < existing.length; r++) existing[r].parentNode.removeChild(existing[r]);

    // Remove old pattern defs
    var oldPatL = els.rigSvg.getElementById('vcp-jc-crosshatch-l');
    var oldPatR = els.rigSvg.getElementById('vcp-jc-crosshatch-r');
    if (oldPatL && oldPatL.parentNode) oldPatL.parentNode.removeChild(oldPatL);
    if (oldPatR && oldPatR.parentNode) oldPatR.parentNode.removeChild(oldPatR);

    if (!state.jcStitching) return;

    var jcColorObj = colorById(state.jcColor);
    if (!jcColorObj) return;
    var hex = jcColorObj.hex;

    // Create two crosshatch patterns: left rotated inward, right rotated inward
    var svgNS = 'http://www.w3.org/2000/svg';
    var defs = els.rigSvg.querySelector('defs');
    if (!defs) {
      defs = document.createElementNS(svgNS, 'defs');
      els.rigSvg.insertBefore(defs, els.rigSvg.firstChild);
    }

    function makeJCPattern(id, rotation) {
      var pat = document.createElementNS(svgNS, 'pattern');
      pat.setAttribute('id', id);
      pat.setAttribute('width', '65');
      pat.setAttribute('height', '75');
      pat.setAttribute('patternUnits', 'userSpaceOnUse');
      if (rotation) pat.setAttribute('patternTransform', 'rotate(' + rotation + ')');

      var l1 = document.createElementNS(svgNS, 'line');
      l1.setAttribute('x1', '0'); l1.setAttribute('y1', '0');
      l1.setAttribute('x2', '32'); l1.setAttribute('y2', '67');
      l1.setAttribute('stroke', hex); l1.setAttribute('stroke-width', '0.6');

      var l2 = document.createElementNS(svgNS, 'line');
      l2.setAttribute('x1', '65'); l2.setAttribute('y1', '0');
      l2.setAttribute('x2', '32'); l2.setAttribute('y2', '67');
      l2.setAttribute('stroke', hex); l2.setAttribute('stroke-width', '0.6');

      var l3 = document.createElementNS(svgNS, 'line');
      l3.setAttribute('x1', '32'); l3.setAttribute('y1', '0');
      l3.setAttribute('x2', '32'); l3.setAttribute('y2', '75');
      l3.setAttribute('stroke', hex); l3.setAttribute('stroke-width', '0.6');

      pat.appendChild(l1); pat.appendChild(l2); pat.appendChild(l3);
      return pat;
    }

    // Left panels: rotate clockwise (inward toward center)
    // Right panels: rotate counter-clockwise (inward toward center)
    defs.appendChild(makeJCPattern('vcp-jc-crosshatch-l', 15));
    defs.appendChild(makeJCPattern('vcp-jc-crosshatch-r', -15));

    // Left-side zones vs right-side zones
    var RIGHT_ZONES = { c1b:1, c3b:1, c6b:1, cfe:1, cff:1, cfg:1 };

    // Build full zone list: base + pattern extras
    var extras = PATTERN_EXTRA_ZONES[currentPattern] || [];
    var zones = JC_STITCH_ZONES.slice();
    for (var e = 0; e < extras.length; e++) {
      if (zones.indexOf(extras[e]) === -1) zones.push(extras[e]);
    }

    // Clone each zone path and fill with crosshatch pattern
    for (var z = 0; z < zones.length; z++) {
      var zoneId = zones[z];
      var patId = RIGHT_ZONES[zoneId] ? 'vcp-jc-crosshatch-r' : 'vcp-jc-crosshatch-l';
      var origPaths = els.rigSvg.querySelectorAll('.vcp-zone-path[data-zone="' + zoneId + '"]');
      for (var p = 0; p < origPaths.length; p++) {
        var orig = origPaths[p];
        var clone = orig.cloneNode(false);
        clone.removeAttribute('id');
        clone.removeAttribute('data-zone');
        clone.setAttribute('class', 'vcp-jc-crosshatch-overlay');
        clone.setAttribute('fill', 'url(#' + patId + ')');
        clone.setAttribute('stroke', 'none');
        clone.setAttribute('pointer-events', 'none');
        clone.style.pointerEvents = 'none';
        clone.style.opacity = '0.55';
        orig.parentNode.insertBefore(clone, orig.nextSibling);
      }
    }
  }

  /* ================================================================
     PALETTE RENDERING
     ================================================================ */

  // Get colors array for current material type
  function getColorsForMaterial() {
    switch (activeMaterial) {
      case 'harness': return HARNESS_COLORS;
      case 'trim': return TRIM_COLORS;
      case 'piping': return TRIM_COLORS; // Piping uses trim tape colors
      case 'embroidery': return EMBROIDERY_COLORS;
      default: return ALL_COLORS; // cordura
    }
  }

  // Get title for current material type
  function getMaterialTitle() {
    switch (activeMaterial) {
      case 'harness': return 'Harness Webbing Colors';
      case 'trim': return 'Trim Tape Colors';
      case 'piping': return 'Piping Colors';
      case 'embroidery': return 'Embroidery Thread Colors';
      default: return 'Cordura Colors';
    }
  }

  // Get zones for current material type
  function getZonesForMaterial() {
    switch (activeMaterial) {
      case 'harness': return HARNESS_ZONES;
      case 'trim': return TRIM_ZONES;
      default: return BASE_ZONE_IDS; // cordura and embroidery use main zones
    }
  }

  // Switch material type (auto-triggered by zone selection)
  function switchMaterial(materialId) {
    if (materialId === activeMaterial) return;
    activeMaterial = materialId;

    // Turn off paint brush — color palette changes per material
    state.paintBrush = false;
    state.paintBrushColor = null;

    // Update title and subtitle based on material
    els.palTitle.textContent = getMaterialTitle();
    var subtitles = {
      cordura: 'Click a zone on the rig, then pick a color',
      harness: 'Select harness webbing color',
      trim: 'Color binding tape and trim zones',
      piping: 'Select piping zone color (trim tape colors)'
    };
    els.palSub.textContent = subtitles[materialId] || subtitles.cordura;

    // Render new palette
    if (els.search) els.search.value = '';

    // Show contrast stitching section only for Harness
    if (els.stitchSection) {
      els.stitchSection.style.display = materialId === 'harness' ? '' : 'none';
    }
    // JC Stitching only on Harness (same as contrast stitching)
    if (els.jcSection) {
      els.jcSection.style.display = materialId === 'harness' ? '' : 'none';
    }
    if (els.pipingSection) els.pipingSection.style.display = '';

    renderFullPalette();
    renderZoneListButtons();
  }

  // Current mode: 'color' or 'embroidery'
  var activeMode = 'color';

  // Switch between Color Zone Selection and Embroidery Positions modes
  function switchMode(mode) {
    if (mode === activeMode) return;
    activeMode = mode;

    // Auto-disable paint brush when leaving color mode
    if (mode !== 'color') {
      state.paintBrush = false;
      state.paintBrushColor = null;
    }

    try {
      // Update toggle button states
      if (els.colorModeBtn) els.colorModeBtn.classList.toggle('vcp-mode-active', mode === 'color');
      if (els.embModeBtn) els.embModeBtn.classList.toggle('vcp-mode-active', mode === 'embroidery');

      // Toggle visibility of sections
      if (mode === 'color') {
        // Reset activeMaterial to cordura if it was on embroidery
        if (activeMaterial === 'embroidery') activeMaterial = 'cordura';
        if (els.zoneListSection) els.zoneListSection.style.display = '';
        if (els.embPreviewSection) els.embPreviewSection.style.display = 'none';
        // Hide palette panel in color mode — mobile picker handles all color selection
        if (els.palettePanel) els.palettePanel.style.display = 'none';
        // (selectionInfo removed)
        // Hide contrast stitching if not on harness
        if (els.stitchSection) {
          els.stitchSection.style.display = activeMaterial === 'harness' ? '' : 'none';
        }
        // JC Stitching only on Harness (same as contrast stitching)
        if (els.jcSection) {
          els.jcSection.style.display = activeMaterial === 'harness' ? '' : 'none';
        }
        if (els.pipingSection) els.pipingSection.style.display = '';
        // Show search and color grid
        if (els.search) els.search.style.display = '';
        // Reset palette titles that embroidery mode overwrites
        if (els.palTitle) els.palTitle.textContent = getMaterialTitle();
        var subtitles = {
          cordura: 'Click a zone on the rig, then pick a color',
          harness: 'Select harness webbing color',
          trim: 'Color binding tape and trim zones',
          piping: 'Select piping zone color (trim tape colors)'
        };
        if (els.palSub) els.palSub.textContent = subtitles[activeMaterial] || subtitles.cordura;
        renderFullPalette();
        showMobileColorPicker('color');
      } else {
        if (els.zoneListSection) els.zoneListSection.style.display = 'none';
        if (els.embPreviewSection) els.embPreviewSection.style.display = '';
        if (els.palettePanel) els.palettePanel.style.display = ''; // Keep palette visible for embroidery config
        // (selectionInfo removed)
        // Hide contrast stitching / JC / piping in embroidery mode
        if (els.stitchSection) els.stitchSection.style.display = 'none';
        if (els.jcSection) els.jcSection.style.display = 'none';
        if (els.pipingSection) els.pipingSection.style.display = 'none';
        // Load embroidery previews when switching to embroidery mode
        loadAllEmbroideryPreviews();
        // Render embroidery controls in the palette panel
        renderEmbroideryUI();
        showMobileColorPicker('embroidery');
      }
    } catch (err) {
      console.error('[VCP] switchMode error:', err);
    }
  }

  // Update zone clickability based on current material (no visual dimming)
  // All zones remain fully visible with their colors at all times
  function updateZoneVisibility() {
    // No longer dims zones - all colors remain visible
    // Zone clickability is handled in getActiveZones()
    // Update the zone list buttons for the current material
    renderZoneListButtons();
  }

  // Render zone selection buttons for easy navigation
  // Shows ALL zones (Cordura + Harness + Trim) regardless of active material tab
  function renderZoneListButtons() {
    if (!els.zoneListGrid) return;
    els.zoneListGrid.innerHTML = '';

    // Get all zone types for display
    var corduraZones = getCorduraZonesForPattern();
    var defaultCordura = getDefaultColorForMaterial('cordura');
    var defaultHarness = getDefaultColorForMaterial('harness');
    var defaultTrim = getDefaultColorForMaterial('trim');

    // Build Cordura groups based on pattern locking mode
    var corduraGroups;
    if (zoneToGroup) {
      // Locked pattern: use pattern-based color groups (Left/Right, etc.)
      var map = window.VCP_PATTERN_ZONE_MAP;
      var meta = window.VCP_PATTERNS;
      var patGroups = (map && map[currentPattern]) || [];
      var patNames = (meta && meta[currentPattern]) ? meta[currentPattern].zones : [];
      corduraGroups = patGroups.map(function (g, i) {
        return { name: patNames[i] || ('Group ' + (i + 1)), ids: g.ids, material: 'cordura', locked: true };
      });
    } else {
      // Full-custom: detailed anatomical breakdown
      corduraGroups = [
        { name: 'Main Panels', ids: ['c1a', 'c1b', 'c1c', 'c1d', 'c2', 'c2b', 'c3a', 'c3b', 'c4', 'c4b'], material: 'cordura' },
        { name: 'Sidewalls', ids: ['c5a', 'c5b', 'c6a', 'c6b'], material: 'cordura' },
        { name: 'Reserve', ids: ['c7a', 'c7b', 'c7c', 'c7d', 'c8a', 'c8b'], material: 'cordura' },
        { name: 'V-Split', ids: ['c9a', 'c9b', 'c9c'], material: 'cordura' },
        { name: 'Flaps', ids: ['cfa', 'cfb', 'cfc', 'cfd', 'cfdb', 'cfe', 'cff', 'cfg'], material: 'cordura' },
        { name: 'Pads', ids: ['backp', 'lpad', 'rpad'], material: 'cordura' },
        { name: 'Handles', ids: ['hcut', 'hres'], material: 'cordura' },
        { name: 'Stabilizers', ids: ['c1astab', 'c1bstab'], material: 'cordura' }
      ];
    }

    // Handles always shown as independent (unlocked) section
    // Only add for locked patterns — full-custom already has Handles in anatomical groups
    if (zoneToGroup) {
      corduraGroups.push({ name: 'Handles', ids: ['hcut', 'hres'], material: 'cordura' });
    }

    // Trim tape: standard/full-custom = manual picker, split patterns = auto-locked to body panels
    var trimDisplayGroups;
    if (currentPattern === 'standard' || currentPattern === 'full-custom') {
      trimDisplayGroups = [{ name: 'Binding / Trim Tape', ids: TRIM_ZONES, material: 'trim', locked: true }];
    } else {
      /* TRIM LOCKED for split patterns — auto-follows body panel colors.
         Re-enable trimBuckets block below to restore independent per-group trim picking.
      var trimBuckets = buildTrimGroups(currentPattern);
      if (trimBuckets) {
        var tmeta2 = window.VCP_PATTERNS;
        var zoneNames2 = (tmeta2 && tmeta2[currentPattern]) ? tmeta2[currentPattern].zones : [];
        trimDisplayGroups = Object.keys(trimBuckets).map(function(gIdx) {
          var bucket = trimBuckets[gIdx];
          var groupName = 'Trim (' + (zoneNames2[parseInt(gIdx,10)] || ('Group '+(parseInt(gIdx,10)+1))) + ')';
          return { name: groupName, ids: bucket, material: 'trim', locked: true };
        });
      }
      END TRIM LOCKED */
      trimDisplayGroups = [{ name: 'Trim Tape (auto-matched to panels)', ids: [], material: 'trim', locked: true }];
    }

    var groups = corduraGroups.concat(trimDisplayGroups).concat([
      { name: 'Harness Webbing', ids: HARNESS_ZONES, material: 'harness' },
      { name: 'Center Flap Piping', ids: PIPING_ZONES, material: 'piping' }
    ]);

    groups.forEach(function (group) {
      // Filter to only include zones that exist for this pattern
      var validZones = group.ids.filter(function (id) {
        if (group.material === 'cordura') {
          return corduraZones.indexOf(id) !== -1;
        }
        return true;
      });
      if (validZones.length === 0) return;

      var isPipingGroup = group.material === 'piping';

      // Check if any zone in this group is currently selected (auto-expand)
      var hasSelectedZone = validZones.some(function (z) { return state.selectedZones.indexOf(z) !== -1; });

      // Group header — clickable to select all zones in the group
      if (group.name) {
        var groupHeader = el('div', 'vcp-zone-group-header vcp-zone-group-clickable');

        // Expand/collapse arrow
        var groupArrow = el('span', 'vcp-zone-group-arrow' + (hasSelectedZone ? ' vcp-expanded' : ''));
        groupArrow.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M9 18l6-6-6-6"/></svg>';
        groupHeader.appendChild(groupArrow);

        var groupLabel = el('div', 'vcp-zone-group-label');
        groupLabel.textContent = group.name;
        groupHeader.appendChild(groupLabel);

        // Header click: select all zones
        (function (zones, mat, arrow) {
          groupHeader.addEventListener('click', function (e) {
            // If arrow was clicked, toggle expand/collapse only
            if (e.target.closest('.vcp-zone-group-arrow')) {
              var row = groupHeader.nextElementSibling;
              if (row && row.classList.contains('vcp-zone-btn-row')) {
                var isExpanded = arrow.classList.toggle('vcp-expanded');
                row.classList.toggle('vcp-zone-row-collapsed', !isExpanded);
              }
              return;
            }
            if (activeMaterial !== mat) switchMaterial(mat);
            state.selectedZones = zones.slice();
            refreshZoneHighlights();
            updateSelectionInfo();
            showMobileColorPicker('color');
            // Auto-expand this group
            arrow.classList.add('vcp-expanded');
            var row = groupHeader.nextElementSibling;
            if (row && row.classList.contains('vcp-zone-btn-row')) {
              row.classList.remove('vcp-zone-row-collapsed');
            }
          });
        })(validZones, group.material, groupArrow);

        // Piping toggle + price inline in piping group header
        if (isPipingGroup) {
          var pipPrice = el('span', 'vcp-option-price vcp-piping-inline-price');
          pipPrice.textContent = '+\u20AC45';
          groupHeader.appendChild(pipPrice);
          var pipTogWrap = el('div', 'vcp-switch-wrap vcp-piping-inline-toggle');
          var pipTogSwitch = el('div', 'vcp-switch' + (state.pipingEnabled ? ' vcp-switch-on' : ''));
          var pipTogKnob = el('div', 'vcp-switch-knob');
          pipTogSwitch.appendChild(pipTogKnob);
          pipTogWrap.appendChild(pipTogSwitch);
          els.pipingSwitchInline = pipTogSwitch;
          pipTogWrap.addEventListener('click', function (e) {
            e.stopPropagation();
            state.pipingEnabled = !state.pipingEnabled;
            pipTogSwitch.classList.toggle('vcp-switch-on', state.pipingEnabled);
            if (els.pipingSwitch) els.pipingSwitch.classList.toggle('vcp-switch-on', state.pipingEnabled);
            if (els.pipingCheckbox) els.pipingCheckbox.checked = state.pipingEnabled;
            if (els.pipingBody) els.pipingBody.style.display = state.pipingEnabled ? '' : 'none';
            var pipRow = els.zoneListGrid ? els.zoneListGrid.querySelector('.vcp-zone-btn-row-piping') : null;
            if (pipRow) pipRow.style.display = state.pipingEnabled ? '' : 'none';
            if (!state.pipingEnabled) {
              PIPING_ZONES.forEach(function (z) { delete state.colorMap['piping:' + z]; });
            }
            applyPipingColors();
            saveDraft();
          });
          groupHeader.appendChild(pipTogWrap);
        }

        els.zoneListGrid.appendChild(groupHeader);
      }

      // Zone buttons row (collapsed by default unless a zone is selected)
      // Piping rows use their own toggle — never add collapsed class to them
      var collapsed = !isPipingGroup && !hasSelectedZone;
      var row = el('div', 'vcp-zone-btn-row' + (isPipingGroup ? ' vcp-zone-btn-row-piping' : '') + (collapsed ? ' vcp-zone-row-collapsed' : ''));
      if (isPipingGroup) row.style.display = state.pipingEnabled ? '' : 'none';
      validZones.forEach(function (zoneId) {
        var zoneMaterial = group.material;
        var colorKey;
        var defaultColor;
        if (zoneMaterial === 'harness') {
          colorKey = 'harness:' + zoneId;
          defaultColor = defaultHarness;
        } else if (zoneMaterial === 'trim') {
          colorKey = 'trim:' + zoneId;
          defaultColor = defaultTrim;
        } else if (zoneMaterial === 'piping') {
          colorKey = 'piping:' + zoneId;
          defaultColor = defaultTrim;
        } else {
          colorKey = zoneId;
          defaultColor = defaultCordura;
        }
        var c = colorById(state.colorMap[colorKey] || defaultColor);
        var isSelected = state.selectedZones.indexOf(zoneId) !== -1;

        var btn = el('button', 'vcp-zone-btn' + (isSelected ? ' vcp-selected' : ''));
        btn.setAttribute('data-zone-id', zoneId);
        btn.setAttribute('data-zone-material', zoneMaterial);

        var dot = el('span', 'vcp-zone-btn-dot');
        dot.style.background = c.hex;
        btn.appendChild(dot);

        var label = el('span', 'vcp-zone-btn-label');
        label.textContent = zoneLabel(zoneId);
        btn.appendChild(label);

        btn.addEventListener('click', function (e) {
          if (zoneMaterial !== activeMaterial && zoneMaterial !== 'embroidery') {
            switchMaterial(zoneMaterial);
          }
          handleZoneClick(zoneId, e.shiftKey);
          renderZoneListButtons();
        });

        row.appendChild(btn);
      });
      els.zoneListGrid.appendChild(row);

      // Piping image body below zone buttons (shown when enabled)
      if (isPipingGroup) {
        var pipImgBody = el('div', 'vcp-zone-option-body vcp-zone-option-body-piping');
        pipImgBody.style.display = state.pipingEnabled ? '' : 'none';
        els.pipingBody = pipImgBody;
        var pipImgWrap = el('div', 'vcp-zone-option-img-wrap');
        pipImgWrap.style.marginTop = '6px';
        var pipImg = el('img', 'vcp-zone-option-img');
        pipImg.src = 'https://cdn.shopify.com/s/files/1/0758/1191/4071/files/Piping-470x705.jpg';
        pipImg.alt = 'Center flap piping example';
        pipImg.loading = 'lazy';
        pipImgWrap.appendChild(pipImg);
        pipImgBody.appendChild(pipImgWrap);
        els.zoneListGrid.appendChild(pipImgBody);
      }
    });

    // ── Inline: Contrast Stitching ──
    (function () {
      var csHeader = el('div', 'vcp-zone-group-header vcp-zone-group-clickable');
      var csLabel = el('div', 'vcp-zone-group-label');
      csLabel.textContent = 'Contrast Stitching';
      csHeader.appendChild(csLabel);
      var csPrice = el('span', 'vcp-option-price vcp-piping-inline-price');
      csPrice.textContent = '+\u20AC85';
      csHeader.appendChild(csPrice);
      var csTogWrap = el('div', 'vcp-switch-wrap vcp-piping-inline-toggle');
      var csTogSwitch = el('div', 'vcp-switch' + (state.contrastStitch ? ' vcp-switch-on' : ''));
      var csTogKnob = el('div', 'vcp-switch-knob');
      csTogSwitch.appendChild(csTogKnob);
      csTogWrap.appendChild(csTogSwitch);
      csTogWrap.addEventListener('click', function (e) {
        e.stopPropagation();
        state.contrastStitch = !state.contrastStitch;
        csTogSwitch.classList.toggle('vcp-switch-on', state.contrastStitch);
        if (els.stitchCheckbox) els.stitchCheckbox.checked = state.contrastStitch;
        if (els.stitchBody) els.stitchBody.style.display = state.contrastStitch ? 'block' : 'none';
        applyContrastStitchingPreview();
        saveDraft();
        renderZoneListButtons();
      });
      csHeader.addEventListener('click', function () {
        // header click does nothing extra for options — toggle handles it
      });
      csHeader.appendChild(csTogWrap);
      els.zoneListGrid.appendChild(csHeader);

      if (state.contrastStitch) {
        var csBody = el('div', 'vcp-zone-option-body');
        // Zone-btn styled color button → opens sidebar
        var csRow = el('div', 'vcp-zone-btn-row');
        var csBtn = el('button', 'vcp-zone-btn' + (sidebarMode === 'contrastStitch' ? ' vcp-zone-btn-selected' : ''));
        var csBtnDot = el('span', 'vcp-zone-btn-dot');
        var csColor = colorById(state.stitchColor);
        if (csColor) csBtnDot.style.background = csColor.hex;
        csBtn.appendChild(csBtnDot);
        var csBtnLabel = el('span', 'vcp-zone-btn-label');
        csBtnLabel.textContent = csColor ? csColor.name : 'Select Color';
        csBtn.appendChild(csBtnLabel);
        csBtn.addEventListener('click', function () {
          showMobileColorPicker('contrastStitch');
        });
        csRow.appendChild(csBtn);
        csBody.appendChild(csRow);
        // Image below color button
        var csImgWrap = el('div', 'vcp-zone-option-img-wrap');
        csImgWrap.style.marginTop = '6px';
        var csImg = el('img', 'vcp-zone-option-img');
        csImg.src = 'https://cdn.shopify.com/s/files/1/0758/1191/4071/files/vcp-config-tool-Contrast-Stitching-470x705.jpg';
        csImg.alt = 'Contrast stitching example';
        csImg.loading = 'lazy';
        csImgWrap.appendChild(csImg);
        csBody.appendChild(csImgWrap);
        els.zoneListGrid.appendChild(csBody);
      }
    })();

    // ── Inline: JC Stitching ──
    (function () {
      var jcHeader = el('div', 'vcp-zone-group-header vcp-zone-group-clickable');
      var jcLabel = el('div', 'vcp-zone-group-label');
      jcLabel.textContent = 'JC Stitching';
      jcHeader.appendChild(jcLabel);
      var jcPrice = el('span', 'vcp-option-price vcp-piping-inline-price');
      jcPrice.textContent = '+\u20AC85';
      jcHeader.appendChild(jcPrice);
      var jcTogWrap = el('div', 'vcp-switch-wrap vcp-piping-inline-toggle');
      var jcTogSwitch = el('div', 'vcp-switch' + (state.jcStitching ? ' vcp-switch-on' : ''));
      var jcTogKnob = el('div', 'vcp-switch-knob');
      jcTogSwitch.appendChild(jcTogKnob);
      jcTogWrap.appendChild(jcTogSwitch);
      jcTogWrap.addEventListener('click', function (e) {
        e.stopPropagation();
        state.jcStitching = !state.jcStitching;
        jcTogSwitch.classList.toggle('vcp-switch-on', state.jcStitching);
        if (els.jcCheckbox) els.jcCheckbox.checked = state.jcStitching;
        if (els.jcBody) els.jcBody.style.display = state.jcStitching ? 'block' : 'none';
        applyJCStitchingPreview();
        saveDraft();
        renderZoneListButtons();
      });
      jcHeader.addEventListener('click', function () {});
      jcHeader.appendChild(jcTogWrap);
      els.zoneListGrid.appendChild(jcHeader);

      if (state.jcStitching) {
        var jcBody = el('div', 'vcp-zone-option-body');
        // Color button first
        var jcRow = el('div', 'vcp-zone-btn-row');
        var jcBtn = el('button', 'vcp-zone-btn' + (sidebarMode === 'jcStitch' ? ' vcp-zone-btn-selected' : ''));
        var jcBtnDot = el('span', 'vcp-zone-btn-dot');
        var jcColor = colorById(state.jcColor);
        if (jcColor) jcBtnDot.style.background = jcColor.hex;
        jcBtn.appendChild(jcBtnDot);
        var jcBtnLabel = el('span', 'vcp-zone-btn-label');
        jcBtnLabel.textContent = jcColor ? jcColor.name : 'Select Color';
        jcBtn.appendChild(jcBtnLabel);
        jcBtn.addEventListener('click', function () {
          showMobileColorPicker('jcStitch');
        });
        jcRow.appendChild(jcBtn);
        jcBody.appendChild(jcRow);
        // Note above images
        var jcNote = el('div', 'vcp-zone-option-note');
        jcNote.style.fontSize = '11px';
        jcNote.style.color = '#888';
        jcNote.style.padding = '4px 0 6px';
        jcNote.style.lineHeight = '1.4';
        jcNote.textContent = 'Note: JC Stitching is the best we could represent it. See images for a real preview.';
        jcBody.appendChild(jcNote);
        // Images side by side
        var jcImgWrap = el('div', 'vcp-zone-option-img-wrap');
        jcImgWrap.style.display = 'flex';
        jcImgWrap.style.gap = '6px';
        jcImgWrap.style.marginTop = '4px';
        var jcImg = el('img', 'vcp-zone-option-img');
        jcImg.src = 'https://cdn.shopify.com/s/files/1/0758/1191/4071/files/vcp-config-tool-JC-470x705.jpg';
        jcImg.alt = 'JC stitching example';
        jcImg.loading = 'lazy';
        jcImg.style.width = '50%';
        jcImg.style.borderRadius = '6px';
        jcImgWrap.appendChild(jcImg);
        var jcImg2 = el('img', 'vcp-zone-option-img');
        jcImg2.src = 'https://cdn.shopify.com/s/files/1/0758/1191/4071/files/2026-02-20_18-23.png';
        jcImg2.alt = 'JC stitching real preview';
        jcImg2.loading = 'lazy';
        jcImg2.style.width = '50%';
        jcImg2.style.borderRadius = '6px';
        jcImgWrap.appendChild(jcImg2);
        jcBody.appendChild(jcImgWrap);
        els.zoneListGrid.appendChild(jcBody);
      }
    })();
  }

  // Get Cordura zones for the current pattern
  function getCorduraZonesForPattern() {
    var extra = PATTERN_EXTRA_ZONES[currentPattern] || [];
    return CORDURA_ZONES.concat(FLAP_ZONES).concat(extra);
  }

  function renderFullPalette() {
    if (!els.colorGrid) return;
    var colors = getColorsForMaterial();
    renderPaletteInto(els.colorGrid, '', colors);
  }

  function renderFilteredPalette() {
    var colors = getColorsForMaterial();
    renderPaletteInto(els.colorGrid, '', colors);
  }

  function renderPaletteInto(container, query, colors) {
    container.innerHTML = '';

    // For cordura, separate standard and specialty; for others, just show all
    if (activeMaterial === 'cordura') {
      var standards = [];
      var specials = [];
      colors.forEach(function (c) {
        var isSp = false;
        for (var s = 0; s < SPECIALTY.length; s++) {
          if (SPECIALTY[s].id === c.id) { isSp = true; break; }
        }
        if (isSp) specials.push(c); else standards.push(c);
      });

      standards.forEach(function (c) { container.appendChild(createSwatch(c)); });

      if (specials.length > 0) {
        var divLabel = el('div', 'vcp-divider-label');
        divLabel.textContent = 'Specialty / Camo';
        container.appendChild(divLabel);
        specials.forEach(function (c) { container.appendChild(createSwatch(c)); });
      }
    } else {
      // Harness, Trim - just show all colors
      colors.forEach(function (c) { container.appendChild(createSwatch(c)); });
    }

    refreshActiveSwatch();
  }

  /* ================================================================
     EMBROIDERY UI (Phase 5)
     Position-based embroidery configuration
     Previews shown BELOW the main rig (all at once, not selectable)
     ================================================================ */

  // Cache for the embroidery SVG markup
  var embroiderySvgMarkup = null;

  // Cache for embroidery symbols SVG markup and parsed symbol DOM nodes
  var embroiderySymbolsMarkup = null;
  var symbolsLoaded = false;

  // Load embroidery symbols SVG
  function loadEmbroiderySymbols(callback) {
    if (symbolsLoaded) {
      if (callback) callback();
      return;
    }

    var symbolsUrl = window.VCP_EMBROIDERY_SYMBOLS_URL;
    if (!symbolsUrl) {
      var embUrl = window.VCP_EMBROIDERY_SVG_URL || EMBROIDERY_SVG_URL;
      if (embUrl) {
        symbolsUrl = embUrl.replace('vc-embroidery-preview.svg', 'vc-embroidery-symbols.svg');
      }
    }

    if (!symbolsUrl) {
      console.log('VCP: No symbols SVG URL available');
      if (callback) callback();
      return;
    }

    console.log('VCP: Loading symbols from', symbolsUrl);

    var xhr = new XMLHttpRequest();
    xhr.open('GET', symbolsUrl, true);
    xhr.timeout = 15000;
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      if (xhr.status === 200 && xhr.responseText) {
        embroiderySymbolsMarkup = xhr.responseText;
        symbolsLoaded = true;
        console.log('VCP: Loaded embroidery symbols (' + embroiderySymbolsMarkup.length + ' bytes)');
      } else {
        console.warn('VCP: Failed to load embroidery symbols');
      }
      if (callback) callback();
    };
    xhr.onerror = function () {
      console.warn('VCP: Network error loading symbols SVG');
      if (callback) callback();
    };
    xhr.ontimeout = function () {
      console.warn('VCP: Timeout loading symbols SVG');
      if (callback) callback();
    };
    xhr.send();
  }

  // Find or create a root-level <defs> (direct child of <svg>) for patterns/clipPaths.
  // Avoids using nested <defs> inside position groups which can cause reference
  // resolution issues when those position groups are hidden with display:none.
  function getOrCreateRootDefs(svg) {
    var children = svg.children || svg.childNodes;
    for (var c = 0; c < children.length; c++) {
      if (children[c].nodeType === 1 && children[c].tagName.toLowerCase() === 'defs') {
        return children[c];
      }
    }
    var defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
    svg.insertBefore(defs, svg.firstChild);
    return defs;
  }

  // Inject symbol definitions from the symbols SVG markup into the SVG.
  // Symbols are added as direct children of <svg> (like the existing backlog/backlogrc
  // symbols in the original SVG) so they remain accessible regardless of which
  // position group is visible/hidden.
  // Uses a data attribute to prevent double injection. Returns true if symbols are present.
  function injectSymbolsIntoSvg(svg) {
    if (!svg) return false;
    // Guard against double injection
    if (svg.getAttribute('data-symbols-injected') === 'true') return true;
    if (!embroiderySymbolsMarkup) return false;

    // Parse symbols from the markup using DOMParser (reliable SVG namespace handling)
    var parser = new DOMParser();
    var symbolDoc = parser.parseFromString(embroiderySymbolsMarkup, 'image/svg+xml');
    var symbols = symbolDoc.querySelectorAll('symbol');

    if (symbols.length === 0) {
      console.warn('VCP: No symbols found in symbols SVG markup');
      return false;
    }

    // Find the first <g> child to insert symbols before it (keeps them at root level,
    // matching the pattern of existing backlog/backlogrc symbols in the SVG)
    var firstG = svg.querySelector(':scope > g');

    for (var i = 0; i < symbols.length; i++) {
      // importNode brings the node from the parsed document into the current document
      var imported = document.importNode(symbols[i], true);
      if (firstG) {
        svg.insertBefore(imported, firstG);
      } else {
        svg.appendChild(imported);
      }
    }

    svg.setAttribute('data-symbols-injected', 'true');
    console.log('VCP: Injected ' + symbols.length + ' symbols into embroidery SVG root');
    return true;
  }

  // Load ALL embroidery position previews below the main rig SVG
  function loadAllEmbroideryPreviews() {
    if (!els.embPreviewGrid) return;

    // Load symbols and logo transforms (if not already loaded)
    loadEmbroiderySymbols(function() {
      // Re-render previews to inject symbols into each SVG's defs
      if (embroiderySvgMarkup && els.embPreviewGrid && els.embPreviewGrid.children.length > 0) {
        renderEmbroideryPreviews();
      }
      // Also inject symbols into rig SVG and refresh embroidery overlay
      refreshRigEmbroideryLogos();
    });
    loadLogoTransforms(function() {
      // Re-render if previews already displayed
      if (embroiderySvgMarkup && els.embPreviewGrid && els.embPreviewGrid.children.length > 0) {
        renderEmbroideryPreviews();
      }
      // Also refresh rig embroidery overlay with new transform data
      refreshRigEmbroideryLogos();
    });

    // If previews already rendered and we have the SVG, just re-render (for updates)
    if (embroiderySvgMarkup) {
      renderEmbroideryPreviews();
      return;
    }

    // Try to load SVG
    var svgUrl = window.VCP_EMBROIDERY_SVG_URL || EMBROIDERY_SVG_URL;
    if (!svgUrl) {
      // No SVG URL - render with fallback icons
      console.log('VCP: No embroidery SVG URL, using fallback icons');
      renderEmbroideryPreviews();
      return;
    }

    // Show loading state
    els.embPreviewGrid.innerHTML = '<div class="vcp-emb-loading">Loading embroidery positions...</div>';

    // Fetch SVG as text so we can inline it (avoids cross-origin issues)
    var xhr = new XMLHttpRequest();
    xhr.open('GET', svgUrl, true);
    xhr.timeout = 10000; // 10 second timeout
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      if (xhr.status === 200 && xhr.responseText) {
        embroiderySvgMarkup = xhr.responseText;
        console.log('VCP: Loaded embroidery SVG (' + embroiderySvgMarkup.length + ' bytes)');
        renderEmbroideryPreviews();
      } else {
        // Failed to load SVG - render with fallback icons
        console.warn('VCP: Failed to load embroidery SVG, using fallback icons');
        renderEmbroideryPreviews();
      }
    };
    xhr.onerror = function () {
      console.warn('VCP: Network error loading embroidery SVG, using fallback icons');
      renderEmbroideryPreviews();
    };
    xhr.ontimeout = function () {
      console.warn('VCP: Timeout loading embroidery SVG, using fallback icons');
      renderEmbroideryPreviews();
    };
    xhr.send();
  }

  // Render embroidery preview: ONE SVG, switch positions via buttons
  // Matches test-embroidery-v2.html architecture
  var EMB_POSITION_IDS = ['yoke', 'rcovers', 'swalls', 'handles', 'backpad', 'reserveflap'];

  function renderEmbroideryPreviews() {
    if (!els.embPreviewGrid) return;

    if (!embroiderySvgMarkup) {
      els.embPreviewGrid.innerHTML = '<div class="vcp-emb-loading">Loading embroidery previews...</div>';
      return;
    }

    // Only create the SVG once — after that just update it in place
    if (embroiderySvgDoc) {
      // Apply pattern-specific variant visibility before coloring
      applyPatternVariantsToEmbroiderySvg(embroiderySvgDoc, currentPattern);
      // Re-apply container colors (may have changed in Zone Selection mode)
      EMB_POSITION_IDS.forEach(function(posId) {
        applyContainerColorsToEmbroiderySvg(embroiderySvgDoc, posId);
        applyFabricTexturesToEmbroiderySvg(embroiderySvgDoc, posId);
      });
      // Inject symbols if they've loaded since SVG was created (race condition fix)
      // injectSymbolsIntoSvg guards against double injection via data attribute
      injectSymbolsIntoSvg(embroiderySvgDoc);
      // Refresh logos for all sides
      refreshAllEmbroideryLogos();
      return;
    }

    els.embPreviewGrid.innerHTML = '';

    // Create single SVG wrapper (white background like test file)
    var wrapper = el('div', 'vcp-emb-svg-wrapper');

    // Parse the SVG markup into a real DOM element
    var tempDiv = el('div');
    tempDiv.innerHTML = embroiderySvgMarkup;
    var svg = tempDiv.querySelector('svg');

    if (!svg) {
      els.embPreviewGrid.innerHTML = '<div class="vcp-emb-loading">Error loading SVG</div>';
      return;
    }

    // Make SVG responsive
    svg.removeAttribute('width');
    svg.removeAttribute('height');
    svg.style.width = '100%';
    svg.style.height = 'auto';
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');

    // Inject symbol definitions into this SVG's <defs>
    injectSymbolsIntoSvg(svg);

    // Setup side wall clipping
    setupSideWallClipping(svg);

    // Hide navigation arrows and placeholder texts
    hideNavArrows(svg);
    hideNoneTextsAndBots(svg);

    // Enable cftrad group (flap elements hidden by default in SVG)
    var cftrad = svg.getElementById('cftrad');
    if (cftrad) {
      cftrad.style.display = 'inline';
      cftrad.setAttribute('display', 'inline');
    }

    // Apply pattern-specific variant visibility before coloring
    applyPatternVariantsToEmbroiderySvg(svg, currentPattern);

    // Apply container colors and fabric textures to ALL positions
    EMB_POSITION_IDS.forEach(function(posId) {
      applyContainerColorsToEmbroiderySvg(svg, posId);
      applyFabricTexturesToEmbroiderySvg(svg, posId);
    });

    // Store reference to the single SVG
    embroiderySvgDoc = svg;

    // Apply logos for ALL sides
    refreshAllEmbroideryLogos();

    // Show only the selected position
    showEmbroideryPosition(selectedEmbroideryPosition);

    // Append to DOM
    wrapper.appendChild(svg);
    els.embPreviewGrid.appendChild(wrapper);
  }

  // Show a specific position in the single embroidery SVG
  function showEmbroideryPosition(posId) {
    if (!embroiderySvgDoc) return;

    EMB_POSITION_IDS.forEach(function(id) {
      var group = embroiderySvgDoc.getElementById(id);
      if (group) {
        if (id === posId) {
          group.style.display = 'inline';
          group.setAttribute('display', 'inline');
        } else {
          group.style.display = 'none';
          group.setAttribute('display', 'none');
        }
      }
    });
  }

  // Refresh logos for ALL sides on the single SVG (called after state changes)
  function refreshAllEmbroideryLogos() {
    if (!embroiderySvgDoc) return;
    EMB_POSITION_IDS.forEach(function(posId) {
      applyLogoToSvg(embroiderySvgDoc, posId, null);
    });
    refreshRigEmbroideryLogos();
  }

  // Update a single side's logo on the SVG (for live preview without full refresh)
  function updateSideLogo(side) {
    if (!embroiderySvgDoc) return;
    var panelMap = { yk: 'yoke', sw: 'swalls', swr: 'swalls', rc: 'rcovers', rcr: 'rcovers',
                    hcut: 'handles', hres: 'handles', bp: 'backpad', rf: 'reserveflap' };
    var posId = panelMap[side];
    if (posId) applyLogoToSvg(embroiderySvgDoc, posId, null);
    applyLogoToRig(side);
    // Also update virtual side duplicates
    if (side === 'sw') applyLogoToRig('sw_back');
    if (side === 'swr') applyLogoToRig('swr_back');
    if (side === 'hres') applyLogoToRig('hres_left');
    if (side === 'hcut') applyLogoToRig('hcut_right');
  }

  /* ================================================================
     Rig Embroidery Overlay — renders embroidery logos on the main rig SVG
     so the full container preview shows configured logos.
     ================================================================ */

  // Set up the overlay structure on the rig SVG (called once after rig SVG loads)
  function setupRigEmbroideryOverlay() {
    var rigSvg = els.rigSvg;
    if (!rigSvg) return;
    var NS = 'http://www.w3.org/2000/svg';

    injectSymbolsIntoSvg(rigSvg);

    var existing = rigSvg.getElementById('rig_emb_overlay');
    if (existing) existing.parentNode.removeChild(existing);

    // Remove old clip defs if they exist (cleanup from previous setup)
    var oldClipDefs = rigSvg.getElementById('rig_emb_clip_defs');
    if (oldClipDefs) oldClipDefs.parentNode.removeChild(oldClipDefs);

    // Add clip path definitions at SVG root level (not inside <g>) for browser compatibility
    var clipDefs = document.createElementNS(NS, 'defs');
    clipDefs.setAttribute('id', 'rig_emb_clip_defs');
    // Rectangular clips for non-sidewall positions
    var clips = {
      'rig_clip_bp':         { x: 325, y: 90,  w: 80,  h: 145 }, // FRONT view backpad (shifted up 10px to avoid harness)
      'rig_clip_rc':         { x: 375, y: 80,  w: 70,  h: 90  }, // FRONT ring cover left
      'rig_clip_rcr':        { x: 280, y: 80,  w: 65,  h: 90  }, // FRONT ring cover right
      'rig_clip_hres':       { x: 385, y: 170, w: 50,  h: 65  }, // FRONT reserve handle
      'rig_clip_hcut':       { x: 305, y: 170, w: 50,  h: 65  }, // FRONT cutaway handle
      'rig_clip_hres_left':  { x: 770, y: 170, w: 45,  h: 65  }, // LEFT view reserve handle
      'rig_clip_hcut_right': { x: 650, y: 170, w: 50,  h: 65  }, // RIGHT view cutaway handle
      'rig_clip_yk':         { x: 70,  y: 25,  w: 100, h: 50  }  // BACK/FRONT yoke area
    };
    Object.keys(clips).forEach(function(id) {
      var cp = document.createElementNS(NS, 'clipPath');
      cp.setAttribute('id', id);
      var r = document.createElementNS(NS, 'rect');
      r.setAttribute('x', clips[id].x); r.setAttribute('y', clips[id].y);
      r.setAttribute('width', clips[id].w); r.setAttribute('height', clips[id].h);
      cp.appendChild(r);
      clipDefs.appendChild(cp);
    });
    // Panel-shaped clips for sidewalls — use actual c1a/c1b SVG paths (covers BACK+LEFT / BACK+RIGHT views)
    var c1aPath = rigSvg.getElementById('c1a');
    if (c1aPath) {
      var cpSW = document.createElementNS(NS, 'clipPath');
      cpSW.setAttribute('id', 'rig_clip_sw_panel');
      var useSW = document.createElementNS(NS, 'use');
      useSW.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#c1a');
      useSW.setAttribute('href', '#c1a');
      cpSW.appendChild(useSW);
      clipDefs.appendChild(cpSW);
    }
    var c1bPath = rigSvg.getElementById('c1b');
    if (c1bPath) {
      var cpSWR = document.createElementNS(NS, 'clipPath');
      cpSWR.setAttribute('id', 'rig_clip_swr_panel');
      var useSWR = document.createElementNS(NS, 'use');
      useSWR.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#c1b');
      useSWR.setAttribute('href', '#c1b');
      cpSWR.appendChild(useSWR);
      clipDefs.appendChild(cpSWR);
    }
    rigSvg.insertBefore(clipDefs, rigSvg.firstChild);

    var overlay = document.createElementNS(NS, 'g');
    overlay.setAttribute('id', 'rig_emb_overlay');
    overlay.setAttribute('pointer-events', 'none');
    rigSvg.appendChild(overlay);

    // Regular embroidery sides
    var sides = ['yk', 'sw', 'swr', 'rc', 'rcr', 'hcut', 'hres', 'bp', 'rf'];
    sides.forEach(function(side) {
      var g = document.createElementNS(NS, 'g');
      g.setAttribute('id', 'rig_emb_' + side);
      g.style.display = 'none';
      for (var i = 1; i <= 15; i++) {
        var use = document.createElementNS(NS, 'use');
        use.setAttribute('id', 'rig_col' + i + '_' + side);
        use.style.display = 'none';
        g.appendChild(use);
      }
      overlay.appendChild(g);
    });

    // Handle side view duplicates (reserve on LEFT, cutaway on RIGHT)
    ['hres_left', 'hcut_right'].forEach(function(side) {
      var g = document.createElementNS(NS, 'g');
      g.setAttribute('id', 'rig_emb_' + side);
      g.style.display = 'none';
      for (var i = 1; i <= 15; i++) {
        var use = document.createElementNS(NS, 'use');
        use.setAttribute('id', 'rig_col' + i + '_' + side);
        use.style.display = 'none';
        g.appendChild(use);
      }
      overlay.appendChild(g);
    });

    // BACK view sidewall duplicates (shifted from LEFT/RIGHT views, clipped to BACK view panels)
    ['sw_back', 'swr_back'].forEach(function(side) {
      var g = document.createElementNS(NS, 'g');
      g.setAttribute('id', 'rig_emb_' + side);
      g.setAttribute('clip-path', 'url(#rig_clip_' + side + ')');
      g.style.display = 'none';
      for (var i = 1; i <= 15; i++) {
        var use = document.createElementNS(NS, 'use');
        use.setAttribute('id', 'rig_col' + i + '_' + side);
        use.style.display = 'none';
        g.appendChild(use);
      }
      overlay.appendChild(g);
    });
  }

  // Clip map for all rig embroidery positions
  var RIG_CLIP_MAP = {
    'sw': 'rig_clip_sw_panel', 'swr': 'rig_clip_swr_panel',
    'rf': 'maskRF_1_', 'bp': 'rig_clip_bp',
    'rc': 'rig_clip_rc', 'rcr': 'rig_clip_rcr',
    'hcut': 'rig_clip_hcut', 'hres': 'rig_clip_hres',
    'hres_left': 'rig_clip_hres_left', 'hcut_right': 'rig_clip_hcut_right',
    'yk': 'rig_clip_yk',
    'sw_back': 'rig_clip_sw_panel', 'swr_back': 'rig_clip_swr_panel'
  };

  // Clear any dynamically-added custom elements from a rig embroidery group
  function clearRigCustomElements(g) {
    var customs = g.querySelectorAll('.rig-custom-el');
    for (var i = 0; i < customs.length; i++) customs[i].parentNode.removeChild(customs[i]);
  }

  // Hide all pre-allocated <use> elements in a rig embroidery group
  function hideRigUseElements(rigSvg, side) {
    for (var i = 1; i <= 15; i++) {
      var el = rigSvg.getElementById('rig_col' + i + '_' + side);
      if (el) { el.style.display = 'none'; el.setAttribute('display', 'none'); }
    }
  }

  // Render custom text on rig SVG for a given side
  // transformKey overrides the lookup key for RIG_CUSTOM_TRANSFORMS (used for back view)
  function renderRigCustomText(g, baseSide, transformKey) {
    var trKey = transformKey || baseSide;
    var tr = RIG_CUSTOM_TRANSFORMS.custom_name[trKey];
    if (!tr) return;

    var fontStyle = state.embCustomFontStyle[baseSide] || 'script';
    var colorId = state.embLogoColors[baseSide] ? state.embLogoColors[baseSide][1] : 'black';
    var color = embThreadColor(colorId);
    var fillColor = color ? color.hex : '#000';
    var is45 = state.embAngle45[baseSide] && tr.angle45 !== undefined;
    var posX = (is45 && tr.x45 !== undefined) ? tr.x45 : tr.x;
    var posY = (is45 && tr.y45 !== undefined) ? tr.y45 : tr.y;
    var angle = is45 ? tr.angle45 : (tr.angle || 0);
    var fSize = (is45 && tr.fontSize45) ? tr.fontSize45 : (tr.fontSize || 10);
    var NS = 'http://www.w3.org/2000/svg';

    if (tr.lines === 3) {
      var names = state.embCustomNames[baseSide];
      if (typeof names !== 'object') names = { line1: '', line2: '', line3: '' };
      var lineH = tr.lineHeight || 9;
      var positions = [posY - lineH, posY, posY + lineH];
      for (var li = 0; li < 3; li++) {
        var txt = names['line' + (li + 1)] || '';
        if (!txt) continue;
        var tel = document.createElementNS(NS, 'text');
        tel.setAttribute('class', 'rig-custom-el');
        tel.textContent = txt;
        tel.setAttribute('x', posX);
        tel.setAttribute('y', positions[li]);
        tel.setAttribute('font-size', fSize);
        tel.setAttribute('text-anchor', 'middle');
        tel.setAttribute('fill', fillColor);
        if (fontStyle === 'script') {
          tel.setAttribute('font-family', 'Georgia, Times, serif');
          tel.setAttribute('font-style', 'italic');
        } else {
          tel.setAttribute('font-family', 'Arial, Helvetica, sans-serif');
          tel.setAttribute('font-weight', 'bold');
        }
        if (angle !== 0) tel.setAttribute('transform', 'rotate(' + angle + ' ' + posX + ' ' + posY + ')');
        g.appendChild(tel);
      }
    } else {
      var text = state.embCustomNames[baseSide] || '';
      if (typeof text === 'object') text = text.line2 || text.line1 || '';
      if (!text) return;
      var textEl = document.createElementNS(NS, 'text');
      textEl.setAttribute('class', 'rig-custom-el');
      textEl.textContent = text;
      textEl.setAttribute('x', posX);
      textEl.setAttribute('y', posY);
      textEl.setAttribute('font-size', fSize);
      textEl.setAttribute('text-anchor', 'middle');
      textEl.setAttribute('fill', fillColor);
      if (fontStyle === 'script') {
        textEl.setAttribute('font-family', 'Georgia, Times, serif');
        textEl.setAttribute('font-style', 'italic');
      } else {
        textEl.setAttribute('font-family', 'Arial, Helvetica, sans-serif');
        textEl.setAttribute('font-weight', 'bold');
      }
      if (angle !== 0) textEl.setAttribute('transform', 'rotate(' + angle + ' ' + posX + ' ' + posY + ')');
      g.appendChild(textEl);
    }
  }

  // Render custom logo image on rig SVG for a given side
  // transformKey overrides the lookup key for RIG_CUSTOM_TRANSFORMS (used for back view)
  function renderRigCustomImage(g, baseSide, transformKey) {
    var trKey = transformKey || baseSide;
    var tr = RIG_CUSTOM_TRANSFORMS.custom_logo[trKey];
    var logoData = state.embCustomLogos[baseSide];
    if (!tr || !logoData || !logoData.dataUrl) return;

    var posX = tr.x;
    var posY = tr.y;
    var baseAngle = (state.embAngle45[baseSide] && tr.angle45 !== undefined) ? tr.angle45 : (tr.angle || 0);
    var angle = baseAngle + (logoData.rotation || 0);
    var cx = posX + tr.w / 2;
    var cy = posY + tr.h / 2;
    var NS = 'http://www.w3.org/2000/svg';

    var img = document.createElementNS(NS, 'image');
    img.setAttribute('class', 'rig-custom-el');
    img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', logoData.dataUrl);
    img.setAttribute('width', tr.w);
    img.setAttribute('height', tr.h);
    img.setAttribute('x', posX);
    img.setAttribute('y', posY);
    if (angle !== 0) img.setAttribute('transform', 'rotate(' + angle + ' ' + cx + ' ' + cy + ')');
    g.appendChild(img);
  }

  // Apply a single side's embroidery logo onto the rig SVG overlay
  function applyLogoToRig(side) {
    var rigSvg = els.rigSvg;
    if (!rigSvg) return;

    injectSymbolsIntoSvg(rigSvg);

    var g = rigSvg.getElementById('rig_emb_' + side);
    if (!g) return;

    // Virtual sides read logo/color state from their base side
    var baseSide = side;
    var isBackDup = false;
    var isHandleSideView = false;
    if (side === 'sw_back') { baseSide = 'sw'; isBackDup = true; }
    if (side === 'swr_back') { baseSide = 'swr'; isBackDup = true; }
    if (side === 'hres_left') { baseSide = 'hres'; isHandleSideView = true; }
    if (side === 'hcut_right') { baseSide = 'hcut'; isHandleSideView = true; }

    // Always clear custom elements and remove group transform
    clearRigCustomElements(g);
    g.removeAttribute('transform');

    var logos = EMB_LOGOS[baseSide];
    if (!logos) { g.style.display = 'none'; return; }

    var idx = state.embCurrentLogoIndex[baseSide] || 0;
    var logo = logos[idx];
    if (!logo || logo.name === 'none') {
      hideRigUseElements(rigSvg, side);
      g.style.display = 'none';
      return;
    }

    // Back view sidewalls only show when 45° angle is enabled (transforms are 45° specific)
    if (isBackDup && !state.embAngle45[baseSide]) {
      hideRigUseElements(rigSvg, side);
      g.style.display = 'none';
      return;
    }

    // Apply clip-path
    if (RIG_CLIP_MAP[side]) {
      g.setAttribute('clip-path', 'url(#' + RIG_CLIP_MAP[side] + ')');
    }

    // For back/side view custom elements, use view-specific transform key (e.g. 'sw_back', 'hres_left')
    var customTransformKey = (isBackDup || isHandleSideView) ? side : null;

    // --- Custom text rendering ---
    if (logo.isCustomName) {
      hideRigUseElements(rigSvg, side);
      renderRigCustomText(g, baseSide, customTransformKey);
      g.style.display = 'inline';
      return;
    }

    // --- Custom image rendering ---
    if (logo.isCustomLogo) {
      hideRigUseElements(rigSvg, side);
      renderRigCustomImage(g, baseSide, customTransformKey);
      g.style.display = 'inline';
      return;
    }

    // --- Standard logo via VArray ---
    var varrayKey;
    if (isBackDup) {
      // Back view uses dedicated transforms (sw_back / swr_back)
      varrayKey = side;
    } else if (isHandleSideView) {
      varrayKey = side;
    } else {
      varrayKey = baseSide;
      if ((baseSide === 'sw' || baseSide === 'swr') && state.embAngle45[baseSide]) {
        varrayKey = baseSide + '45';
      }
    }
    var varrayList = RIG_VARRAY_TRANSFORMS[varrayKey] || RIG_VARRAY_TRANSFORMS[baseSide];
    if (!varrayList) { hideRigUseElements(rigSvg, side); g.style.display = 'none'; return; }
    var vdata = null;
    for (var v = 0; v < varrayList.length; v++) {
      if (varrayList[v].name === logo.name) { vdata = varrayList[v]; break; }
    }
    if (!vdata || !vdata.layers || vdata.layers.length === 0) { hideRigUseElements(rigSvg, side); g.style.display = 'none'; return; }

    g.style.display = 'inline';

    // Backpad logos shifted up 10px on rig
    var bpDy = (baseSide === 'bp') ? -10 : 0;

    var numColors = logo.colors;
    for (var i = 1; i <= 15; i++) {
      var colEl = rigSvg.getElementById('rig_col' + i + '_' + side);
      if (!colEl) continue;

      if (i <= numColors) {
        var symbolId;
        if (logo.specialSymbols && logo.specialSymbols[i - 1]) {
          symbolId = logo.specialSymbols[i - 1];
        } else {
          symbolId = (vdata.sym || logo.symbol) + '_c' + i;
        }
        colEl.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + symbolId);
        colEl.setAttribute('href', '#' + symbolId);

        var layer = vdata.layers[i - 1];
        if (layer) {
          colEl.setAttribute('width', layer.w);
          colEl.setAttribute('height', layer.h);
          colEl.setAttribute('x', layer.x);
          colEl.setAttribute('y', layer.y);
          var matStr = layer.t;
          if (bpDy !== 0) {
            var parts = matStr.split(/[\s,]+/);
            parts[5] = String(parseFloat(parts[5]) + bpDy);
            matStr = parts.join(',');
          }
          colEl.setAttribute('transform', 'matrix(' + matStr + ')');
        }

        colEl.style.display = 'inline';
        colEl.removeAttribute('display');

        var colorId = state.embLogoColors[baseSide] ? state.embLogoColors[baseSide][i] : null;
        var color = colorId ? embThreadColor(colorId) : null;
        if (color) colEl.setAttribute('fill', color.hex);
      } else {
        colEl.style.display = 'none';
        colEl.setAttribute('display', 'none');
      }
    }
  }

  // Refresh all embroidery logos on the rig SVG
  function refreshRigEmbroideryLogos() {
    if (!els.rigSvg || !els.rigSvg.getElementById('rig_emb_overlay')) return;
    var sides = ['yk', 'sw', 'swr', 'rc', 'rcr', 'hcut', 'hres', 'bp', 'rf', 'sw_back', 'swr_back', 'hres_left', 'hcut_right'];
    sides.forEach(function(side) {
      applyLogoToRig(side);
    });
  }

  // Hide navigation arrows (« ») from UPT VOS embroidery SVG
  // These are the vertical arrow strips on the left and right sides
  function hideNavArrows(svg) {
    // Hide all navigation/backlog elements by ID patterns
    var selectors = [
      // Direct backlog elements
      '[id="back1"]', '[id="back2"]', '[id="f1"]', '[id="f2"]',
      '[id^="brf"]', '[id^="frf"]',
      '[id^="fbp"]', '[id^="frc"]', '[id^="bcr"]',
      '[id^="brcR"]', '[id^="frcR"]', '[id^="bcrL"]', '[id^="frcL"]',
      // Bots groups (contain the navigation arrows)
      '[id$="bots"]', '[id*="bots_"]', '[id="bots"]',
      '[id="ykbots"]', '[id="rfbots"]', '[id="rcbots"]', '[id="swbots"]',
      // Use elements referencing backlog symbols
      'use[href="#backlog"]', 'use[href="#backlogrc"]',
      'use[xlink\\:href="#backlog"]', 'use[xlink\\:href="#backlogrc"]'
    ];

    selectors.forEach(function (selector) {
      try {
        var elements = svg.querySelectorAll(selector);
        for (var i = 0; i < elements.length; i++) {
          elements[i].style.display = 'none';
          elements[i].style.visibility = 'hidden';
          elements[i].setAttribute('display', 'none');
        }
      } catch (e) { /* ignore selector errors */ }
    });

    // Hide symbol definitions
    var symbols = svg.querySelectorAll('symbol#backlog, symbol#backlogrc');
    for (var i = 0; i < symbols.length; i++) {
      symbols[i].style.display = 'none';
      symbols[i].setAttribute('display', 'none');
    }

    // Hide any use elements that reference backlog symbols (fallback for namespace issues)
    var useElements = svg.querySelectorAll('use');
    for (var i = 0; i < useElements.length; i++) {
      var href = useElements[i].getAttribute('href') || useElements[i].getAttributeNS('http://www.w3.org/1999/xlink', 'href') || '';
      if (href.indexOf('backlog') !== -1) {
        useElements[i].style.display = 'none';
        useElements[i].style.visibility = 'hidden';
        useElements[i].setAttribute('display', 'none');
      }
    }

    // Find and hide all groups containing "bots" in their ID (various positions)
    var allGroups = svg.querySelectorAll('g[id]');
    for (var i = 0; i < allGroups.length; i++) {
      var gid = allGroups[i].id || '';
      if (gid.toLowerCase().indexOf('bots') !== -1) {
        allGroups[i].style.display = 'none';
        allGroups[i].setAttribute('display', 'none');
      }
    }
  }

  // Apply logo to embroidery SVG based on V2 embroidery state.
  // Standard logos are rendered by cloning symbol content directly into nested <svg>
  // elements (bypasses <use>+<symbol> which fails when symbols are loaded async).
  // Custom text/logo still use their own rendering paths.
  function applyLogoToSvg(svg, posId, opt) {
    var sides = POSITION_SIDES[posId] || [];

    sides.forEach(function(side) {
      var logos = EMB_LOGOS[side];
      if (!logos) return;

      var idx = state.embCurrentLogoIndex[side] || 0;
      var logo = logos[idx];
      if (!logo) return;

      var suffix = '_' + side;
      var numColors = logo.colors;
      var directClass = 'vcp-logo-dr-' + side;

      // Map side to transforms key
      var transformPos = side;
      if (side === 'hcut') transformPos = 'hnr';
      if (side === 'hres') transformPos = 'hn';

      // Get transform data for this logo
      var transformData = null;
      if (LOGO_TRANSFORMS && LOGO_TRANSFORMS[transformPos]) {
        transformData = LOGO_TRANSFORMS[transformPos].find(function(l) {
          return l.name === logo.name;
        });
      }

      // Check 45° angle for side walls
      var isSideWall = (side === 'sw' || side === 'swr');
      var applyAngle = isSideWall && state.embAngle45[side] && logo.name !== 'none';
      var angleValue = side === 'sw' ? -35 : 35;
      var config = ANGLE45_CONFIG[side];
      var commonCenter = config ? config.center : null;
      var currentOffset = config ? config.offset : { dx: 0, dy: 0 };

      // 1. Hide ALL original <use> col elements (we render directly instead)
      for (var i = 1; i <= 15; i++) {
        var colEl = svg.getElementById('col' + i + suffix);
        if (colEl) {
          colEl.style.display = 'none';
          colEl.setAttribute('display', 'none');
        }
      }

      // 2. Remove any previous direct-render elements for this side
      var oldDirect = svg.querySelectorAll('.' + directClass);
      for (var r = 0; r < oldDirect.length; r++) {
        oldDirect[r].parentNode.removeChild(oldDirect[r]);
      }

      // 3. For standard logos with symbol: clone symbol content into nested <svg>
      if (logo.symbol && numColors > 0) {
        // Find the logo group to append to
        var logoGroupMap = {
          yk: 'logoyk', sw: 'logosw_clipped', swr: 'logoswr_clipped',
          rc: 'logorc', rcr: 'logorc',
          hcut: 'logoHandles', hres: 'logoHandles',
          bp: 'bplogos', rf: 'logorf'
        };
        var appendTarget = svg.getElementById(logoGroupMap[side]);
        // For reserve flap, append inside the clipped child <g>, not logorf itself
        if (side === 'rf' && appendTarget && appendTarget.id === 'logorf') {
          var clippedChild = appendTarget.querySelector('g[clip-path]');
          if (clippedChild) appendTarget = clippedChild;
        }
        // Fallback for sidewalls if clipped groups don't exist yet
        if (!appendTarget && (side === 'sw' || side === 'swr')) {
          appendTarget = svg.getElementById('logosw');
        }
        if (!appendTarget) {
          // Last resort: find the position group itself
          var posMap = { yk: 'yoke', sw: 'swalls', swr: 'swalls', rc: 'rcovers', rcr: 'rcovers',
                        hcut: 'handles', hres: 'handles', bp: 'backpad', rf: 'reserveflap' };
          appendTarget = svg.getElementById(posMap[side]);
        }
        if (appendTarget) {
          for (var c = 1; c <= numColors; c++) {
            var symbolId;
            if (logo.specialSymbols && logo.specialSymbols[c - 1]) {
              symbolId = logo.specialSymbols[c - 1];
            } else {
              symbolId = logo.symbol + '_c' + c;
            }

            // Find the symbol definition (injected at SVG root)
            var symbolEl = svg.getElementById(symbolId);
            if (!symbolEl) continue;

            // Get positioning from LOGO_TRANSFORMS or fallback to original <use> defaults
            var refCol = svg.getElementById('col' + c + suffix);
            var w, h, x, y, tStr;

            if (transformData && transformData.colorLayers && transformData.colorLayers[c - 1]) {
              var layer = transformData.colorLayers[c - 1];
              w = layer.width || (refCol ? refCol.getAttribute('width') : 200);
              h = layer.height || (refCol ? refCol.getAttribute('height') : 80);
              x = layer.x != null ? layer.x : (refCol ? refCol.getAttribute('x') : 0);
              y = layer.y != null ? layer.y : (refCol ? refCol.getAttribute('y') : 0);
              tStr = '';
              if (layer.transform) {
                tStr = 'matrix(' + layer.transform + ')';
                if (applyAngle && commonCenter) {
                  tStr = 'translate(' + currentOffset.dx + ',' + currentOffset.dy + ') rotate(' + angleValue + ' ' + commonCenter.x + ' ' + commonCenter.y + ') ' + tStr;
                }
              }
            } else if (refCol) {
              w = refCol.getAttribute('width') || 200;
              h = refCol.getAttribute('height') || 80;
              x = refCol.getAttribute('x') || 0;
              y = refCol.getAttribute('y') || 0;
              tStr = refCol.getAttribute('transform') || '';
            } else {
              continue; // No positioning data available
            }

            // Get thread color
            var colorId = state.embLogoColors[side] ? state.embLogoColors[side][c] : null;
            var color = colorId ? embThreadColor(colorId) : null;
            var fillHex = color ? color.hex : '#000000';

            // Create a nested <svg> that acts as viewport (handles viewBox scaling)
            var nested = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            nested.setAttribute('class', directClass);
            nested.setAttribute('width', String(w));
            nested.setAttribute('height', String(h));
            nested.setAttribute('x', String(x));
            nested.setAttribute('y', String(y));
            nested.setAttribute('overflow', 'hidden');
            var vb = symbolEl.getAttribute('viewBox');
            if (vb) nested.setAttribute('viewBox', vb);
            if (tStr) nested.setAttribute('transform', tStr);

            // Clone symbol content into the nested svg
            var cloned = symbolEl.cloneNode(true);
            while (cloned.firstChild) {
              nested.appendChild(cloned.firstChild);
            }

            // Set fill color on all path/shape elements inside
            var shapes = nested.querySelectorAll('path, polygon, rect, circle, ellipse');
            for (var s = 0; s < shapes.length; s++) {
              shapes[s].setAttribute('fill', fillHex);
              shapes[s].style.fill = fillHex;
            }

            appendTarget.appendChild(nested);
          }
        }
      }

      // Handle custom name text
      if (logo.isCustomName) {
        applyCustomTextToSvg(svg, side, posId);
      } else {
        removeCustomTextFromSvg(svg, side);
      }

      // Handle custom logo image
      if (logo.isCustomLogo) {
        applyCustomLogoImageToSvg(svg, side, posId);
      } else {
        removeCustomLogoFromSvg(svg, side);
      }
    });
  }

  /* Apply custom name text to embroidery SVG using CUSTOM_TRANSFORMS and auto-sizing */
  function applyCustomTextToSvg(svg, side, posId) {
    var transforms = EMB_CUSTOM_TRANSFORMS.custom_name[side];
    if (!transforms) return;

    var customTextId = 'customtext_' + side;

    // Remove existing text elements
    for (var i = 1; i <= 3; i++) {
      var lineEl = svg.getElementById(customTextId + '_line' + i);
      if (lineEl) lineEl.parentNode.removeChild(lineEl);
    }
    var existingText = svg.getElementById(customTextId);
    if (existingText) existingText.parentNode.removeChild(existingText);

    // Find parent group for this position
    var panelMap = { yk: 'yoke', sw: 'swalls', swr: 'swalls', rc: 'rcovers', rcr: 'rcovers',
                    hcut: 'handles', hres: 'handles', bp: 'backpad', rf: 'reserveflap' };
    var panelGroup = svg.getElementById(panelMap[side]);
    if (!panelGroup) return;

    // For sidewalls, append to clipped wrapper group so 45° logos don't overflow
    var appendTarget = panelGroup;
    if (side === 'sw') {
      var clipped = svg.getElementById('logosw_clipped');
      if (clipped) appendTarget = clipped;
    } else if (side === 'swr') {
      var clipped2 = svg.getElementById('logoswr_clipped');
      if (clipped2) appendTarget = clipped2;
    }

    var fontStyle = state.embCustomFontStyle[side] || 'script';
    var colorId = state.embLogoColors[side] ? state.embLogoColors[side][1] : 'black';
    var color = embThreadColor(colorId);
    var fillColor = color ? color.hex : '#000';

    // Determine position and angle
    var hasAngleOption = transforms.hasAngleOption;
    var angle = 0;
    var posX = transforms.x;
    var posY = transforms.y;

    if (hasAngleOption) {
      if (state.embAngle45[side]) {
        angle = transforms.angle;
        if (transforms.x45 !== undefined) posX = transforms.x45;
        if (transforms.y45 !== undefined) posY = transforms.y45;
      }
    } else if (transforms.angle) {
      angle = transforms.angle;
    }

    // Multi-line (ring covers, backpad, reserve flap)
    if (transforms.lines === 3) {
      var names = state.embCustomNames[side];
      if (typeof names !== 'object') names = { line1: '', line2: '', line3: '' };

      var baseSize = EMB_FONT_SIZES[side] || 40;
      var maxChars = EMB_MAX_CHARS[side] || 8;

      var longestText = '';
      for (var li = 1; li <= 3; li++) {
        var t = names['line' + li] || '';
        if (t.length > longestText.length) longestText = t;
      }
      var fontSize = calculateEmbFontSize(longestText || 'X', maxChars, baseSize, baseSize * 0.5);
      var lineOffset = fontSize * 1.2;
      var linePositions = {
        1: posY - lineOffset,
        2: posY,
        3: posY + lineOffset
      };

      for (var lineNum = 1; lineNum <= 3; lineNum++) {
        var lineText = names['line' + lineNum] || '';
        if (!lineText) continue;

        var textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        textEl.id = customTextId + '_line' + lineNum;
        textEl.textContent = lineText;
        textEl.setAttribute('x', posX);
        textEl.setAttribute('y', linePositions[lineNum]);
        textEl.setAttribute('font-size', fontSize);
        textEl.setAttribute('text-anchor', 'middle');
        textEl.setAttribute('fill', fillColor);

        if (fontStyle === 'script') {
          textEl.setAttribute('font-family', 'Georgia, Times, serif');
          textEl.setAttribute('font-style', 'italic');
        } else {
          textEl.setAttribute('font-family', 'Arial, Helvetica, sans-serif');
          textEl.setAttribute('font-weight', 'bold');
        }

        appendTarget.appendChild(textEl);
      }
    } else {
      // Single line
      var text = state.embCustomNames[side] || '';
      if (typeof text === 'object') text = text.line2 || '';

      var textEl2 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      textEl2.id = customTextId;
      textEl2.textContent = text;
      textEl2.setAttribute('x', posX);
      textEl2.setAttribute('y', posY);

      var baseSize2 = EMB_FONT_SIZES[side] || 38;
      var maxChars2 = EMB_MAX_CHARS[side] || 10;
      var fontSize2 = calculateEmbFontSize(text, maxChars2, baseSize2, baseSize2 * 0.5);
      textEl2.setAttribute('font-size', fontSize2);
      textEl2.setAttribute('text-anchor', 'middle');
      textEl2.setAttribute('fill', fillColor);

      if (fontStyle === 'script') {
        textEl2.setAttribute('font-family', 'Georgia, Times, serif');
        textEl2.setAttribute('font-style', 'italic');
      } else {
        textEl2.setAttribute('font-family', 'Arial, Helvetica, sans-serif');
        textEl2.setAttribute('font-weight', 'bold');
      }

      if (angle !== 0) {
        textEl2.setAttribute('transform', 'rotate(' + angle + ' ' + posX + ' ' + posY + ')');
      }

      appendTarget.appendChild(textEl2);
    }
  }

  /* Remove custom text elements from SVG */
  function removeCustomTextFromSvg(svg, side) {
    var customTextId = 'customtext_' + side;
    var el0 = svg.getElementById(customTextId);
    if (el0) el0.parentNode.removeChild(el0);
    for (var i = 1; i <= 3; i++) {
      var lineEl = svg.getElementById(customTextId + '_line' + i);
      if (lineEl) lineEl.parentNode.removeChild(lineEl);
    }
  }

  /* Apply custom logo image to embroidery SVG */
  function applyCustomLogoImageToSvg(svg, side, posId) {
    var logoData = state.embCustomLogos[side];
    var transforms = EMB_CUSTOM_TRANSFORMS.custom_logo[side];
    if (!transforms) return;

    var panelMap = { yk: 'yoke', sw: 'swalls', swr: 'swalls', rc: 'rcovers', rcr: 'rcovers',
                    hcut: 'handles', hres: 'handles', bp: 'backpad', rf: 'reserveflap' };
    var panelGroup = svg.getElementById(panelMap[side]);
    if (!panelGroup) return;

    // For sidewalls, append to clipped wrapper group so 45° logos don't overflow
    var appendTarget = panelGroup;
    if (side === 'sw') {
      var clipped = svg.getElementById('logosw_clipped');
      if (clipped) appendTarget = clipped;
    } else if (side === 'swr') {
      var clipped2 = svg.getElementById('logoswr_clipped');
      if (clipped2) appendTarget = clipped2;
    }

    var customImgId = 'customimg_' + side;
    var placeholderId = 'customlogo-placeholder_' + side;
    var existingImg = svg.getElementById(customImgId);
    var placeholder = svg.getElementById(placeholderId);

    var hasAngleOption = transforms.hasAngleOption;
    var angle = 0;
    var posX = transforms.x;
    var posY = transforms.y;

    if (hasAngleOption) {
      if (state.embAngle45[side]) {
        angle = transforms.angle;
        if (transforms.x45 !== undefined) posX = transforms.x45;
        if (transforms.y45 !== undefined) posY = transforms.y45;
      }
    } else if (transforms.angle) {
      angle = transforms.angle;
    }

    var cx = posX + transforms.width / 2;
    var cy = posY + transforms.height / 2;

    // Create/update placeholder border frame
    if (!placeholder) {
      placeholder = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      placeholder.id = placeholderId;
      placeholder.setAttribute('fill', 'none');
      placeholder.setAttribute('stroke', '#666');
      placeholder.setAttribute('stroke-width', '2');
      placeholder.setAttribute('stroke-dasharray', '8,4');
      appendTarget.appendChild(placeholder);
    }
    placeholder.setAttribute('width', transforms.width);
    placeholder.setAttribute('height', transforms.height);
    placeholder.setAttribute('x', posX);
    placeholder.setAttribute('y', posY);

    var totalRotation = angle + ((logoData && logoData.rotation) || 0);
    if (totalRotation !== 0) {
      placeholder.setAttribute('transform', 'rotate(' + totalRotation + ' ' + cx + ' ' + cy + ')');
    } else {
      placeholder.removeAttribute('transform');
    }

    if (!logoData || !logoData.dataUrl) {
      placeholder.style.display = 'inline';
      if (existingImg) existingImg.style.display = 'none';
      return;
    } else {
      placeholder.style.display = 'none';
    }

    if (!existingImg) {
      existingImg = document.createElementNS('http://www.w3.org/2000/svg', 'image');
      existingImg.id = customImgId;
      appendTarget.appendChild(existingImg);
    }

    existingImg.setAttributeNS('http://www.w3.org/1999/xlink', 'href', logoData.dataUrl);
    existingImg.setAttribute('width', transforms.width);
    existingImg.setAttribute('height', transforms.height);
    existingImg.setAttribute('x', posX);
    existingImg.setAttribute('y', posY);

    if (totalRotation !== 0) {
      existingImg.setAttribute('transform', 'rotate(' + totalRotation + ' ' + cx + ' ' + cy + ')');
    } else {
      existingImg.removeAttribute('transform');
    }
    existingImg.style.display = 'inline';
  }

  /* Remove custom logo image from SVG */
  function removeCustomLogoFromSvg(svg, side) {
    var customImgId = 'customimg_' + side;
    var placeholderId = 'customlogo-placeholder_' + side;
    var img = svg.getElementById(customImgId);
    if (img) img.parentNode.removeChild(img);
    var ph = svg.getElementById(placeholderId);
    if (ph) ph.parentNode.removeChild(ph);
  }

  /* Setup side wall clipping paths in SVG */
  function setupSideWallClipping(svg) {
    if (!svg) return;

    var defs = getOrCreateRootDefs(svg);

    // Create clip path for sw (left side wall → sw1a)
    var sw1aPath = svg.getElementById('sw1a');
    if (sw1aPath && !svg.getElementById('clip_sw')) {
      var clipSw = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
      clipSw.setAttribute('id', 'clip_sw');
      var useSw = document.createElementNS('http://www.w3.org/2000/svg', 'use');
      useSw.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#sw1a');
      clipSw.appendChild(useSw);
      defs.appendChild(clipSw);
    }

    // Create clip path for swr (right side wall → sw1b)
    var sw1bPath = svg.getElementById('sw1b');
    if (sw1bPath && !svg.getElementById('clip_swr')) {
      var clipSwr = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
      clipSwr.setAttribute('id', 'clip_swr');
      var useSwr = document.createElementNS('http://www.w3.org/2000/svg', 'use');
      useSwr.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#sw1b');
      clipSwr.appendChild(useSwr);
      defs.appendChild(clipSwr);
    }

    // Create clipped wrapper groups for logo elements
    var logosw = svg.getElementById('logosw');
    if (logosw && !svg.getElementById('logosw_clipped')) {
      var swGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      swGroup.setAttribute('id', 'logosw_clipped');
      swGroup.setAttribute('clip-path', 'url(#clip_sw)');

      var swrGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      swrGroup.setAttribute('id', 'logoswr_clipped');
      swrGroup.setAttribute('clip-path', 'url(#clip_swr)');

      for (var i = 1; i <= 15; i++) {
        var colSw = svg.getElementById('col' + i + '_sw');
        if (colSw) swGroup.appendChild(colSw);
      }
      for (var j = 1; j <= 15; j++) {
        var colSwr = svg.getElementById('col' + j + '_swr');
        if (colSwr) swrGroup.appendChild(colSwr);
      }

      logosw.appendChild(swGroup);
      logosw.appendChild(swrGroup);
    }
  }

  /* Hide placeholder texts and bot elements from embroidery SVG */
  function hideNoneTextsAndBots(svg) {
    if (!svg) return;
    var noneTextIds = ['rftxt', 'bptxt', 'htxtres', 'htxtcut', 'rctextl', 'rctextr', 'swtxtr', 'swtxtl'];
    noneTextIds.forEach(function(id) {
      var el0 = svg.getElementById(id);
      if (el0) el0.style.display = 'none';
    });
    var botsIds = ['bots', 'bots_Backpad', 'bots_5_e', 'bots_6_e', 'ykbots', 'rfbots'];
    botsIds.forEach(function(id) {
      var el0 = svg.getElementById(id);
      if (el0) el0.style.display = 'none';
    });
  }

  // Apply container colors from state.colorMap to embroidery SVG
  // This function maps container zones (c1a, c2, etc.) to embroidery SVG zones
  function applyContainerColorsToEmbroiderySvg(svg, positionId) {
    if (!state.colorMap) {
      console.log('VCP: No colorMap to apply');
      return;
    }

    // Use pattern-aware mappings (handles c2 variants, c9 v-split zones, c7d etc.)
    var mapping = getPositionZoneMappings(positionId);

    // Apply colors based on the mapping
    Object.keys(state.colorMap).forEach(function (containerZoneId) {
      var colorId = state.colorMap[containerZoneId];
      var color = colorById(colorId);
      if (!color) return;

      var embZoneIds = mapping[containerZoneId];
      if (!embZoneIds) return;

      embZoneIds.forEach(function (embZoneId) {
        colorEmbroideryElement(svg, embZoneId, color.hex);
      });
    });

  }

  // Create a tiling <pattern> inside an embroidery SVG (like ensureTexturePattern but for emb SVGs)
  function ensureEmbTexturePattern(svg, color) {
    var patId = 'vcp-embpat-' + color.id;
    if (svg.getElementById(patId)) return 'url(#' + patId + ')';
    var defs = getOrCreateRootDefs(svg);
    var TILE = 200; // tile size — one texture per panel at embroidery SVG scale (725×400)
    var pat = document.createElementNS('http://www.w3.org/2000/svg', 'pattern');
    pat.setAttribute('id', patId);
    pat.setAttribute('patternUnits', 'userSpaceOnUse');
    pat.setAttribute('width', String(TILE));
    pat.setAttribute('height', String(TILE));
    var img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
    img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', color.img);
    img.setAttribute('width', String(TILE));
    img.setAttribute('height', String(TILE));
    img.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    pat.appendChild(img);
    defs.appendChild(pat);
    return 'url(#' + patId + ')';
  }

  // Apply fabric textures to embroidery SVG panels using tiling patterns
  // Uses <pattern> fills on path elements (same approach as main rig) for proper grain size
  // Falls back to flat hex color when textures OFF
  function applyFabricTexturesToEmbroiderySvg(svg, positionId) {
    if (!state.colorMap) return;

    // Use pattern-aware mappings (handles c2 variants, c9 v-split zones, c7d etc.)
    var mapping = getPositionZoneMappings(positionId);
    var texturesOn = state.showFabricTextures;

    Object.keys(mapping).forEach(function(containerZoneId) {
      var embZoneIds = mapping[containerZoneId];
      var colorId = state.colorMap[containerZoneId];
      var color = colorId ? colorById(colorId) : null;

      embZoneIds.forEach(function(embZoneId) {
        // Clear the old _fab image approach (we use pattern fills now)
        var fabImg = svg.getElementById(embZoneId + '_fab');
        if (fabImg) {
          fabImg.removeAttributeNS('http://www.w3.org/1999/xlink', 'href');
          fabImg.removeAttribute('href');
        }

        // Apply tiling pattern fill to the path element
        var pathEl = svg.getElementById(embZoneId);
        if (!pathEl) return;

        if (texturesOn && color && color.img) {
          var patFill = ensureEmbTexturePattern(svg, color);
          pathEl.setAttribute('fill', patFill);
          pathEl.style.fill = patFill;
        } else if (color) {
          // Textures OFF — restore flat color
          pathEl.setAttribute('fill', color.hex);
          pathEl.style.fill = color.hex;
        }
      });
    });
  }

  // Helper to color an element by ID in the embroidery SVG
  function colorEmbroideryElement(svg, embZoneId, hexColor) {
    var element = svg.getElementById(embZoneId);
    if (!element) return;

    var tag = element.tagName.toLowerCase();
    if (tag === 'path' || tag === 'rect' || tag === 'polygon') {
      element.setAttribute('fill', hexColor);
      element.style.fill = hexColor;
    } else if (tag === 'g') {
      // For group elements (e.g. rfwht, ykwht), color direct child shapes
      var children = element.children;
      for (var i = 0; i < children.length; i++) {
        var childTag = children[i].tagName.toLowerCase();
        if (childTag === 'path' || childTag === 'rect' || childTag === 'polygon') {
          children[i].setAttribute('fill', hexColor);
          children[i].style.fill = hexColor;
        }
      }
    }
  }

  function renderEmbroideryUI() {
    if (!els.colorGrid) return;
    els.colorGrid.innerHTML = '';

    // Hide search for embroidery (not applicable)
    if (els.search) els.search.style.display = 'none';

    // Update palette titles for embroidery mode
    if (els.palTitle) els.palTitle.textContent = 'Embroidery Configuration';
    if (els.palSub) els.palSub.textContent = 'Select a position, then configure logos and colors';

    // Position tab buttons (matches test-embroidery-v2 layout)
    var positionBar = el('div', 'vcp-emb-position-bar');
    EMBROIDERY_POSITIONS.forEach(function (pos) {
      var isSelected = selectedEmbroideryPosition === pos.id;
      var hasConfig = hasEmbroideryConfig(pos.id);

      var btn = el('button', 'vcp-emb-pos-btn' + (isSelected ? ' vcp-active' : '') + (hasConfig ? ' vcp-configured' : ''));
      btn.setAttribute('data-pos-id', pos.id);
      btn.textContent = pos.shortLabel;
      btn.addEventListener('click', function () {
        selectedEmbroideryPosition = pos.id;
        // Clear color selection from previous position
        state.embSelectedSide = null;
        state.embSelectedColorSlot = 1;
        // Switch SVG position view
        showEmbroideryPosition(pos.id);
        // Refresh controls panel
        renderEmbroideryUI();
      });
      positionBar.appendChild(btn);
    });
    els.colorGrid.appendChild(positionBar);

    // V2 Configuration panel for selected position (per-side controls)
    var configPanel = el('div', 'vcp-emb-config-panel');
    configPanel.setAttribute('id', 'vcp-emb-config');
    var currentPos = EMBROIDERY_POSITIONS.find(function (p) { return p.id === selectedEmbroideryPosition; });
    if (currentPos) {
      var section = createEmbroideryV2Section(currentPos);
      configPanel.appendChild(section);
    }
    els.colorGrid.appendChild(configPanel);

    // Thread color selection now handled by the sidebar picker

    // Disclaimer banner (shown only in embroidery mode)
    var disclaimer = el('div', 'vcp-disclaimer');
    var disclaimerIcon = el('span', 'vcp-disclaimer-icon');
    disclaimerIcon.textContent = '\u24D8';
    disclaimer.appendChild(disclaimerIcon);
    var disclaimerText = el('span', 'vcp-disclaimer-text');
    disclaimerText.innerHTML = 'We created this tool in-house to give you the best experience possible, but <strong>logos and text illustrations can be mislocated in preview</strong>. ' +
      'Please add on by Custom Logo and/or Text what your intent is, and we will review and/or contact you about this after purchase before forwarding it to UPT Vector. ' +
      'So we avoid unhappy disasters <span style="font-size:13px">:)</span> &mdash; don\'t hesitate to contact us, we are one click away to assist you personally. ' +
      'Custom logos usually are a <strong>~\u20AC400 to ~\u20AC600 extra</strong> (cost defined by UPT).';
    disclaimer.appendChild(disclaimerText);
    var disclaimerClose = el('button', 'vcp-disclaimer-close');
    disclaimerClose.innerHTML = '&times;';
    disclaimerClose.title = 'Dismiss';
    disclaimerClose.addEventListener('click', function() {
      disclaimer.style.display = 'none';
    });
    disclaimer.appendChild(disclaimerClose);
    els.colorGrid.appendChild(disclaimer);

  }

  /* Check if any side in a position has embroidery configured */
  function hasEmbroideryConfig(posId) {
    var sides = POSITION_SIDES[posId] || [];
    for (var i = 0; i < sides.length; i++) {
      var side = sides[i];
      var logos = EMB_LOGOS[side];
      if (!logos) continue;
      var idx = state.embCurrentLogoIndex[side] || 0;
      var logo = logos[idx];
      if (logo && logo.name !== 'none') return true;
    }
    return false;
  }

  /* Apply thread color to the currently selected color slot */
  function applyThreadColorToSelected(colorId) {
    var side = state.embSelectedSide;
    var slot = state.embSelectedColorSlot;
    if (!side) return;

    if (!state.embLogoColors[side]) state.embLogoColors[side] = {};
    state.embLogoColors[side][slot] = colorId;

    // Update color box display
    updateEmbColorBoxes(side);

    // Update thread swatch selection
    updateThreadSwatchSelection();

    // Update SVG preview directly
    updateSideLogo(side);
    saveDraft();
  }

  /* Update thread swatch selection highlight */
  function updateThreadSwatchSelection() {
    var side = state.embSelectedSide;
    var slot = state.embSelectedColorSlot;
    if (!side) return;

    var currentColorId = state.embLogoColors[side] ? state.embLogoColors[side][slot] : null;
    var swatches = document.querySelectorAll('.vcp-emb-thread-swatch');
    for (var i = 0; i < swatches.length; i++) {
      swatches[i].classList.toggle('vcp-active', swatches[i].getAttribute('data-thread-id') === currentColorId);
    }
  }

  /* Update color boxes for a side (the C1, C2, etc. buttons) */
  function updateEmbColorBoxes(side) {
    var container = document.getElementById('vcp-emb-colors-' + side);
    if (!container) return;

    var logos = EMB_LOGOS[side];
    if (!logos) return;
    var idx = state.embCurrentLogoIndex[side] || 0;
    var logo = logos[idx];
    if (!logo) return;

    container.innerHTML = '';
    var numColors = logo.colors;
    if (logo.isCustomName) numColors = 1;

    for (var i = 1; i <= numColors; i++) {
      var colorId = state.embLogoColors[side] ? state.embLogoColors[side][i] : 'black';
      var color = embThreadColor(colorId);
      var hex = color ? color.hex : '#888';

      var div = el('div', 'vcp-emb-active-color');
      var isSelected = (state.embSelectedSide === side && state.embSelectedColorSlot === i);
      var box = el('div', 'vcp-emb-active-color-box' + (isSelected ? ' vcp-emb-color-selected' : ''));
      box.style.backgroundColor = hex;
      box.setAttribute('data-side', side);
      box.setAttribute('data-slot', i);
      box.addEventListener('click', function() {
        var s = this.getAttribute('data-side');
        var sl = parseInt(this.getAttribute('data-slot'));
        state.embSelectedSide = s;
        state.embSelectedColorSlot = sl;
        // Refresh all color box highlights
        document.querySelectorAll('.vcp-emb-active-color-box').forEach(function(b) {
          b.classList.remove('vcp-emb-color-selected');
        });
        this.classList.add('vcp-emb-color-selected');
        updateThreadSwatchSelection();
        // Open mobile picker with thread colors
        showMobileColorPicker(true);
      });
      div.appendChild(box);

      var label = el('span', 'vcp-emb-active-color-label');
      label.textContent = 'C' + i;
      div.appendChild(label);

      container.appendChild(div);
    }
  }

  // Highlight the selected embroidery position in the preview grid
  // Update embroidery controls without full re-render (for smoother UX)
  function updateEmbroideryControls() {
    // Update button states
    var buttons = document.querySelectorAll('.vcp-emb-pos-btn');
    buttons.forEach(function (btn) {
      var posId = btn.getAttribute('data-pos-id');
      btn.classList.toggle('vcp-active', posId === selectedEmbroideryPosition);
      btn.classList.toggle('vcp-configured', hasEmbroideryConfig(posId));
    });

    // Update config panel
    var configPanel = document.getElementById('vcp-emb-config');
    if (configPanel) {
      configPanel.innerHTML = '';
      var currentPos = EMBROIDERY_POSITIONS.find(function (p) { return p.id === selectedEmbroideryPosition; });
      if (currentPos) {
        var section = createEmbroideryV2Section(currentPos);
        configPanel.appendChild(section);
      }
    }

    // Switch SVG position
    showEmbroideryPosition(selectedEmbroideryPosition);
  }

  /* V2: Create per-side embroidery controls for a position */
  function createEmbroideryV2Section(pos) {
    var section = el('div', 'vcp-emb-section');
    section.setAttribute('data-emb-pos', pos.id);

    var sides = POSITION_SIDES[pos.id] || [];

    // Per-side subsections
    sides.forEach(function(side) {
      var sideSection = el('div', 'vcp-emb-side-section');
      sideSection.setAttribute('data-side', side);

      // Side header with label and price (hidden when logo is "none")
      var sideHeader = el('div', 'vcp-emb-side-header');
      var sideTitle = el('h4', 'vcp-emb-side-title');
      sideTitle.textContent = SIDE_LABELS[side] || side;
      if (SIDE_PRICES[side]) {
        var priceSpan = el('span', 'vcp-emb-side-price');
        priceSpan.id = 'vcp-emb-price-' + side;
        priceSpan.textContent = ' (' + SIDE_PRICES[side] + ')';
        // Hide price when current logo is "none"
        var currentIdx = state.embCurrentLogoIndex[side] || 0;
        var currentLg = (EMB_LOGOS[side] || [])[currentIdx];
        if (!currentLg || currentLg.name === 'none') priceSpan.style.display = 'none';
        sideTitle.appendChild(priceSpan);
      }
      sideHeader.appendChild(sideTitle);
      sideSection.appendChild(sideHeader);

      // Logo selector: ← [dropdown] →
      var logoNav = el('div', 'vcp-emb-logo-nav');
      var prevBtn = el('button', 'vcp-emb-nav-btn');
      prevBtn.innerHTML = '&larr;';
      prevBtn.setAttribute('data-side', side);
      prevBtn.addEventListener('click', function() { embPrevLogo(side); });
      logoNav.appendChild(prevBtn);

      var logoSelect = el('select', 'vcp-emb-logo-dropdown');
      logoSelect.id = 'vcp-emb-select-' + side;
      var logos = EMB_LOGOS[side] || [];
      logos.forEach(function(logo, idx) {
        var option = document.createElement('option');
        option.value = idx;
        option.textContent = logo.name;
        logoSelect.appendChild(option);
      });
      logoSelect.value = state.embCurrentLogoIndex[side] || 0;
      logoSelect.addEventListener('change', function() {
        embSelectLogo(side, parseInt(this.value));
      });
      logoNav.appendChild(logoSelect);

      var nextBtn = el('button', 'vcp-emb-nav-btn');
      nextBtn.innerHTML = '&rarr;';
      nextBtn.setAttribute('data-side', side);
      nextBtn.addEventListener('click', function() { embNextLogo(side); });
      logoNav.appendChild(nextBtn);

      sideSection.appendChild(logoNav);

      // 45° angle option (for side walls only, when not 'none')
      var isSideWall = (side === 'sw' || side === 'swr');
      var currentLogo = logos[state.embCurrentLogoIndex[side] || 0];
      if (isSideWall && currentLogo && currentLogo.name !== 'none') {
        var angleRow = el('div', 'vcp-emb-angle-option');
        var angleLabel = el('label', 'vcp-emb-angle-label');
        var angleCheck = el('input');
        angleCheck.type = 'checkbox';
        angleCheck.id = 'vcp-emb-angle45-' + side;
        angleCheck.checked = state.embAngle45[side] || false;
        angleCheck.addEventListener('change', function() {
          state.embAngle45[side] = this.checked;
          updateSideLogo(side);
          saveDraft();
        });
        angleLabel.appendChild(angleCheck);
        angleLabel.appendChild(document.createTextNode(' 45\u00B0 Angle Placement'));
        angleRow.appendChild(angleLabel);
        sideSection.appendChild(angleRow);
      }

      // Custom name section (shown when custom_name logo selected)
      if (currentLogo && currentLogo.isCustomName) {
        var nameSection = createCustomNameSection(side);
        sideSection.appendChild(nameSection);
      }

      // Custom logo upload section (shown when custom_logo selected)
      if (currentLogo && currentLogo.isCustomLogo) {
        var logoUploadSection = createCustomLogoSection(side);
        sideSection.appendChild(logoUploadSection);
      }

      // Active color boxes
      var colorsContainer = el('div', 'vcp-emb-active-colors');
      colorsContainer.id = 'vcp-emb-colors-' + side;
      sideSection.appendChild(colorsContainer);

      // Render color boxes
      setTimeout(function() { updateEmbColorBoxes(side); }, 0);

      section.appendChild(sideSection);
    });

    return section;
  }

  /* Create custom name input section for a side */
  function createCustomNameSection(side) {
    var section = el('div', 'vcp-emb-custom-name-section');

    var transforms = EMB_CUSTOM_TRANSFORMS.custom_name[side];
    var isMultiLine = transforms && transforms.lines === 3;
    var currentStyle = state.embCustomFontStyle[side] || 'script';

    // Font options
    var fontRow = el('div', 'vcp-emb-font-options');
    ['block', 'script'].forEach(function(fontType) {
      var label = el('label', 'vcp-emb-font-option' + (fontType === 'block' ? ' vcp-emb-block-font' : ' vcp-emb-script-font'));
      var radio = el('input');
      radio.type = 'radio';
      radio.name = 'vcp-emb-font-' + side;
      radio.value = fontType;
      radio.checked = currentStyle === fontType;
      radio.addEventListener('change', function() {
        state.embCustomFontStyle[side] = fontType;
        updateSideLogo(side);
        saveDraft();
      });
      label.appendChild(radio);
      label.appendChild(document.createTextNode(' ' + (fontType === 'block' ? 'Block' : 'Script')));
      fontRow.appendChild(label);
    });
    section.appendChild(fontRow);

    // Text inputs
    if (isMultiLine) {
      var names = state.embCustomNames[side];
      if (typeof names !== 'object') names = { line1: '', line2: '', line3: '' };

      for (var lineNum = 1; lineNum <= 3; lineNum++) {
        (function(ln) {
          var row = el('div', 'vcp-emb-name-row');
          var lbl = el('span', 'vcp-emb-name-label');
          lbl.textContent = 'Line ' + ln + ':';
          row.appendChild(lbl);
          var input = el('input', 'vcp-emb-name-input');
          input.type = 'text';
          input.maxLength = 24;
          input.value = names['line' + ln] || '';
          input.id = 'vcp-emb-name-' + side + '-' + ln;
          input.addEventListener('input', function() {
            if (typeof state.embCustomNames[side] !== 'object') {
              state.embCustomNames[side] = { line1: '', line2: '', line3: '' };
            }
            state.embCustomNames[side]['line' + ln] = this.value;
            updateSideLogo(side);
            saveDraft();
          });
          row.appendChild(input);
          section.appendChild(row);
        })(lineNum);
      }
    } else {
      var row = el('div', 'vcp-emb-name-row');
      var lbl = el('span', 'vcp-emb-name-label');
      lbl.textContent = 'Text:';
      row.appendChild(lbl);
      var input = el('input', 'vcp-emb-name-input');
      input.type = 'text';
      input.maxLength = 30;
      input.value = (typeof state.embCustomNames[side] === 'string' ? state.embCustomNames[side] : '') || '';
      input.id = 'vcp-emb-name-' + side;
      input.addEventListener('input', function() {
        state.embCustomNames[side] = this.value;
        updateSideLogo(side);
        saveDraft();
      });
      row.appendChild(input);
      section.appendChild(row);
    }

    return section;
  }

  /* Create custom logo upload section for a side */
  function createCustomLogoSection(side) {
    var section = el('div', 'vcp-emb-custom-logo-section');
    var logoData = state.embCustomLogos[side] || { dataUrl: null, rotation: 0 };

    var uploadLabel = el('label', 'vcp-emb-upload-label');
    uploadLabel.textContent = 'Upload Custom Logo:';
    section.appendChild(uploadLabel);

    var uploadBtn = el('button', 'vcp-emb-upload-btn');
    uploadBtn.textContent = 'Choose File';
    var fileInput = el('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.style.display = 'none';
    fileInput.id = 'vcp-emb-upload-' + side;
    fileInput.addEventListener('change', function(e) {
      if (e.target.files && e.target.files[0]) {
        var reader = new FileReader();
        reader.onload = function(ev) {
          state.embCustomLogos[side] = { dataUrl: ev.target.result, rotation: 0 };
          updateSideLogo(side);
          renderEmbroideryUI();
          saveDraft();

          // Analytics: custom logo uploaded
          if (window.vcTrackEvent) window.vcTrackEvent('vc_custom_logo_upload', {
            side: side,
            file_size: e.target.files[0].size,
            file_type: e.target.files[0].type
          });
        };
        reader.readAsDataURL(e.target.files[0]);
      }
    });
    uploadBtn.addEventListener('click', function() { fileInput.click(); });
    section.appendChild(fileInput);
    section.appendChild(uploadBtn);

    if (logoData.dataUrl) {
      var removeBtn = el('button', 'vcp-emb-upload-btn');
      removeBtn.textContent = 'Remove';
      removeBtn.addEventListener('click', function() {
        state.embCustomLogos[side] = { dataUrl: null, rotation: 0 };
        updateSideLogo(side);
        renderEmbroideryUI();
        saveDraft();
      });
      section.appendChild(removeBtn);

      // Rotation buttons
      var rotRow = el('div', 'vcp-emb-rotation-btns');
      [0, 90, 180, 270].forEach(function(r) {
        var rbtn = el('button', 'vcp-emb-rotation-btn' + (logoData.rotation === r ? ' vcp-active' : ''));
        rbtn.textContent = r + '\u00B0';
        rbtn.addEventListener('click', function() {
          state.embCustomLogos[side].rotation = r;
          updateSideLogo(side);
          renderEmbroideryUI();
          saveDraft();
        });
        rotRow.appendChild(rbtn);
      });
      section.appendChild(rotRow);

      // Preview
      var preview = el('img', 'vcp-emb-logo-preview');
      preview.src = logoData.dataUrl;
      preview.style.transform = 'rotate(' + logoData.rotation + 'deg)';
      section.appendChild(preview);
    }

    // DST file input
    var dstRow = el('div', 'vcp-emb-dst-input');
    var dstLabel = el('span');
    dstLabel.textContent = 'Custom Logo .dst file:';
    dstRow.appendChild(dstLabel);
    var dstInput = el('input', 'vcp-emb-name-input');
    dstInput.type = 'text';
    dstInput.placeholder = 'filename.dst';
    dstInput.id = 'vcp-emb-dst-' + side;
    if (state.embDstFilenames && state.embDstFilenames[side]) {
      dstInput.value = state.embDstFilenames[side];
    }
    dstInput.addEventListener('input', function() {
      if (!state.embDstFilenames) state.embDstFilenames = {};
      state.embDstFilenames[side] = dstInput.value;
    });
    dstRow.appendChild(dstInput);
    section.appendChild(dstRow);

    // Custom logo notes
    var notesSection = el('div', 'vcp-emb-notes-section');
    var notesLabel = el('label', 'vcp-emb-notes-label');
    notesLabel.textContent = 'Custom Logo Notes';
    notesLabel.setAttribute('for', 'vcp-emb-notes');
    notesSection.appendChild(notesLabel);
    var notesHint = el('div', 'vcp-emb-notes-hint');
    notesHint.textContent = 'Describe your intent for custom logo placement, or any special requests.';
    notesSection.appendChild(notesHint);
    var notesTextarea = el('textarea', 'vcp-emb-notes');
    notesTextarea.id = 'vcp-emb-notes';
    notesTextarea.setAttribute('rows', '3');
    notesTextarea.setAttribute('placeholder', 'e.g. "Place logo on left riser cover, centered..."');
    notesTextarea.value = state.embNotes || '';
    notesTextarea.addEventListener('input', function() {
      state.embNotes = this.value;
      saveDraft();
    });
    notesSection.appendChild(notesTextarea);
    section.appendChild(notesSection);

    return section;
  }

  /* Logo navigation functions */
  function embPrevLogo(side) {
    var logos = EMB_LOGOS[side];
    if (!logos) return;
    var idx = (state.embCurrentLogoIndex[side] || 0) - 1;
    if (idx < 0) idx = logos.length - 1;
    embSelectLogo(side, idx);
  }

  function embNextLogo(side) {
    var logos = EMB_LOGOS[side];
    if (!logos) return;
    var idx = (state.embCurrentLogoIndex[side] || 0) + 1;
    if (idx >= logos.length) idx = 0;
    embSelectLogo(side, idx);
  }

  function embSelectLogo(side, idx) {
    state.embCurrentLogoIndex[side] = idx;
    var select = document.getElementById('vcp-emb-select-' + side);
    if (select) select.value = idx;

    // Update SVG logo directly (single SVG, no full re-render)
    updateSideLogo(side);
    // Re-render UI controls (to show/hide custom name, custom logo, angle option)
    renderEmbroideryUI();
    saveDraft();
  }

  /* V2 status text for a position (summarizes all sides) */
  function getEmbroideryV2StatusText(posId) {
    var sides = POSITION_SIDES[posId] || [];
    var parts = [];
    sides.forEach(function(side) {
      var logos = EMB_LOGOS[side];
      if (!logos) return;
      var idx = state.embCurrentLogoIndex[side] || 0;
      var logo = logos[idx];
      if (!logo || logo.name === 'none') return;
      var label = SIDE_LABELS[side] || side;
      if (logo.isCustomName) {
        var name = state.embCustomNames[side];
        var txt = typeof name === 'object' ? (name.line1 || name.line2 || name.line3 || '') : (name || '');
        parts.push(label + ': "' + (txt || 'Custom') + '"');
      } else if (logo.isCustomLogo) {
        parts.push(label + ': Custom Logo');
      } else {
        parts.push(label + ': ' + logo.name);
      }
    });
    return parts.length > 0 ? parts.join(' | ') : 'No embroidery';
  }


  function createSwatch(color) {
    var btn = el('button', 'vcp-swatch' + (color.light ? ' vcp-swatch-light' : ''));
    btn.setAttribute('data-color-id', color.id);
    btn.title = color.name;

    if (color.img) {
      var img = el('img');
      img.src = color.img;
      img.alt = color.name;
      img.loading = 'lazy';
      btn.appendChild(img);
    } else {
      var hex = el('span', 'vcp-swatch-hex');
      hex.style.background = color.hex;
      btn.appendChild(hex);
    }

    btn.addEventListener('click', function () {
      applyColorToSelected(color.id);
    });

    btn.addEventListener('mouseenter', function (e) {
      tooltipEl.textContent = color.name;
      tooltipEl.classList.add('vcp-tip-show');
      positionTooltip(e);
    });
    btn.addEventListener('mousemove', positionTooltip);
    btn.addEventListener('mouseleave', function () {
      tooltipEl.classList.remove('vcp-tip-show');
    });

    return btn;
  }

  function positionTooltip(e) {
    var x = e.clientX + 12;
    var y = e.clientY - 30;
    var tipW = tooltipEl.offsetWidth || 100;
    // Clamp right edge
    if (x + tipW > window.innerWidth - 8) x = window.innerWidth - tipW - 8;
    // Clamp left edge
    if (x < 8) x = 8;
    // Clamp top edge
    if (y < 8) y = e.clientY + 16;
    tooltipEl.style.left = x + 'px';
    tooltipEl.style.top = y + 'px';
  }

  function refreshActiveSwatch() {
    var activeColor = '';
    if (state.selectedZones.length === 1) {
      activeColor = state.colorMap[state.selectedZones[0]] || '';
    }
    var swatches = els.colorGrid.querySelectorAll('.vcp-swatch');
    for (var i = 0; i < swatches.length; i++) {
      swatches[i].classList.toggle('vcp-swatch-active', swatches[i].getAttribute('data-color-id') === activeColor);
    }
  }

  /* ================================================================
     CONTRAST STITCHING
     ================================================================ */
  function renderStitchPicker() {
    if (!els.stitchPicker) return;

    els.stitchPicker.innerHTML = '';
    EMBROIDERY_COLORS.forEach(function (c) {
      var btn = el('button', 'vcp-stitch-swatch' + (c.id === state.stitchColor ? ' vcp-active' : '') + (c.light ? ' vcp-light' : ''));
      btn.style.background = c.hex;
      btn.title = c.name;
      btn.setAttribute('data-color-id', c.id);
      btn.addEventListener('click', function () {
        state.stitchColor = c.id;
        // Update selection
        var siblings = els.stitchPicker.querySelectorAll('.vcp-stitch-swatch');
        for (var i = 0; i < siblings.length; i++) {
          siblings[i].classList.toggle('vcp-active', siblings[i].getAttribute('data-color-id') === c.id);
        }
        applyContrastStitchingPreview();
        saveDraft();
      });
      els.stitchPicker.appendChild(btn);
    });

    // Set checkbox state
    els.stitchCheckbox.checked = state.contrastStitch;
    els.stitchBody.style.display = state.contrastStitch ? 'block' : 'none';
  }

  function renderJCPicker() {
    if (!els.jcPicker) return;

    els.jcPicker.innerHTML = '';
    EMBROIDERY_COLORS.forEach(function (c) {
      var btn = el('button', 'vcp-stitch-swatch' + (c.id === state.jcColor ? ' vcp-active' : '') + (c.light ? ' vcp-light' : ''));
      btn.style.background = c.hex;
      btn.title = c.name;
      btn.setAttribute('data-color-id', c.id);
      btn.addEventListener('click', function () {
        state.jcColor = c.id;
        var siblings = els.jcPicker.querySelectorAll('.vcp-stitch-swatch');
        for (var i = 0; i < siblings.length; i++) {
          siblings[i].classList.toggle('vcp-active', siblings[i].getAttribute('data-color-id') === c.id);
        }
        applyJCStitchingPreview();
        saveDraft();
      });
      els.jcPicker.appendChild(btn);
    });

    els.jcCheckbox.checked = state.jcStitching;
    els.jcBody.style.display = state.jcStitching ? 'block' : 'none';
  }

  function renderPipingToggle() {
    if (!els.pipingCheckbox) return;
    els.pipingCheckbox.checked = state.pipingEnabled;
    if (els.pipingSwitch) els.pipingSwitch.classList.toggle('vcp-switch-on', state.pipingEnabled);
    if (els.pipingBody) els.pipingBody.style.display = state.pipingEnabled ? '' : 'none';
    if (els.pipingSwitchInline) els.pipingSwitchInline.classList.toggle('vcp-switch-on', state.pipingEnabled);
    // Update zone swatches
    if (els.pipingZoneSwatches) {
      PIPING_ZONES.forEach(function (zoneId) {
        var sw = els.pipingZoneSwatches[zoneId];
        if (!sw) return;
        var cId = state.colorMap['piping:' + zoneId];
        var c = cId ? colorById(cId) : null;
        sw.style.background = c ? c.hex : '#e5e7eb';
        sw.title = c ? c.name : 'Not set – click to pick';
      });
    }
  }

  /* ================================================================
     DRAFT PERSISTENCE
     ================================================================ */
  var DRAFT_KEY_PREFIX = 'vcp-draft-v4-';

  function draftKey() {
    return DRAFT_KEY_PREFIX + currentPattern;
  }

  function saveDraft() {
    try {
      var currentSnap = getStateSnapshot();
      // Push previous state to undo stack (only if state actually changed)
      if (!_applyingUndoRedo && _lastSnapshot &&
          JSON.stringify(_lastSnapshot) !== JSON.stringify(currentSnap)) {
        undoStack.push(_lastSnapshot);
        if (undoStack.length > MAX_UNDO) undoStack.shift();
        redoStack.length = 0;
        updateUndoRedoBtns();
      }
      _lastSnapshot = currentSnap;
      localStorage.setItem(draftKey(), JSON.stringify(currentSnap));
    } catch (e) { /* quota */ }
  }

  function loadDraft() {
    try {
      var raw = localStorage.getItem(draftKey());
      // Also try legacy key as fallback
      if (!raw) raw = localStorage.getItem('vcp-draft-v3');
      if (raw) {
        var data = JSON.parse(raw);
        if (data.colorMap) {
          Object.keys(data.colorMap).forEach(function (key) {
            if (data.colorMap[key]) state.colorMap[key] = data.colorMap[key];
          });
        }
        if (data.recentColors) state.recentColors = data.recentColors;
        // Load contrast stitching
        if (typeof data.contrastStitch === 'boolean') state.contrastStitch = data.contrastStitch;
        if (data.stitchColor) state.stitchColor = data.stitchColor;
        // Load JC stitching
        if (typeof data.jcStitching === 'boolean') state.jcStitching = data.jcStitching;
        if (data.jcColor) state.jcColor = data.jcColor;
        // Load piping
        if (typeof data.pipingEnabled === 'boolean') state.pipingEnabled = data.pipingEnabled;
        // Load V2 embroidery state
        if (data.embCurrentLogoIndex) state.embCurrentLogoIndex = data.embCurrentLogoIndex;
        if (data.embLogoColors) state.embLogoColors = data.embLogoColors;
        if (data.embCustomNames) state.embCustomNames = data.embCustomNames;
        if (data.embCustomFontStyle) state.embCustomFontStyle = data.embCustomFontStyle;
        if (data.embAngle45) state.embAngle45 = data.embAngle45;
        if (data.embNotes) state.embNotes = data.embNotes;
      }
    } catch (e) { /* parse error */ }
  }

  /* ================================================================
     OPEN / CLOSE / SAVE
     ================================================================ */
  function open(existingColorMap, onSaveCallback, pattern, existingEmbroidery, existingQuickOptions, designName) {
    pattern = pattern || 'standard';
    currentPattern = pattern;
    rebuildZoneIds(pattern);

    buildOnce(pattern, function () {
      // Update header with pattern name
      if (els.patternLabel) {
        var pNames = {
          'standard':'Standard','half-and-half':'Half & Half','diagonal':'Diagonal',
          'v-split':'V-Split','tri-v-split':'Tri-color V-Split','triple-v-split':'Triple V-Split',
          'lightning':'Lightning Split','triple-lightning':'Triple Lightning','zigzag':'Zig-zag',
          'full-custom':'Full Custom'
        };
        els.patternLabel.textContent = pNames[pattern] || pattern;
      }

      // Initialize colorMap
      state.colorMap = defaultColorMap();
      if (existingColorMap && Object.keys(existingColorMap).length > 0) {
        // Copy all existing color mappings
        Object.keys(existingColorMap).forEach(function (key) {
          state.colorMap[key] = existingColorMap[key];
        });
      } else {
        loadDraft();
      }

      // Initialize embroidery (legacy)
      state.embroidery = {};
      if (existingEmbroidery && Object.keys(existingEmbroidery).length > 0) {
        Object.keys(existingEmbroidery).forEach(function (posId) {
          state.embroidery[posId] = Object.assign({}, existingEmbroidery[posId]);
        });
      }

      // Initialize V2 embroidery state
      initEmbroideryV2State();
      // Restore V2 embroidery from existing data if available
      if (existingEmbroidery && existingEmbroidery._v2) {
        var v2 = existingEmbroidery._v2;
        if (v2.currentLogoIndex) state.embCurrentLogoIndex = v2.currentLogoIndex;
        if (v2.logoColors) state.embLogoColors = v2.logoColors;
        if (v2.customNames) state.embCustomNames = v2.customNames;
        if (v2.customFontStyle) state.embCustomFontStyle = v2.customFontStyle;
        if (v2.angle45) state.embAngle45 = v2.angle45;
        if (v2.notes) state.embNotes = v2.notes;
        if (v2.customLogos) state.embCustomLogos = v2.customLogos;
      }

      // Initialize contrast stitching options
      state.contrastStitch = false;
      state.stitchColor = 'em-black';
      state.jcStitching = false;
      state.jcColor = 'em-black';
      state.pipingEnabled = false;
      if (existingQuickOptions) {
        if (typeof existingQuickOptions.contrastStitch === 'boolean') state.contrastStitch = existingQuickOptions.contrastStitch;
        if (existingQuickOptions.stitchColor) state.stitchColor = existingQuickOptions.stitchColor;
        if (typeof existingQuickOptions.jcStitching === 'boolean') state.jcStitching = existingQuickOptions.jcStitching;
        if (existingQuickOptions.jcColor) state.jcColor = existingQuickOptions.jcColor;
        if (typeof existingQuickOptions.pipingEnabled === 'boolean') state.pipingEnabled = existingQuickOptions.pipingEnabled;
      }
      // Auto-detect piping from existing colorMap keys
      if (!state.pipingEnabled && state.colorMap) {
        var hasPiping = Object.keys(state.colorMap).some(function (k) { return k.indexOf('piping:') === 0; });
        if (hasPiping) state.pipingEnabled = true;
      }

      state.onSave = onSaveCallback || null;
      state.designName = designName || '';
      if (els.designNameInput) els.designNameInput.value = state.designName;
      state.selectedZones = [];
      // Fabric texture toggle defaults ON
      if (typeof state.showFabricTextures === 'undefined') state.showFabricTextures = true;
      // Sync fabric toggle button state
      if (els.fabricToggle) {
        els.fabricToggle.classList.toggle('vcp-active', state.showFabricTextures);
        els.fabricToggle.innerHTML = state.showFabricTextures
          ? '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M3 6h18M3 12h18M3 18h18"/></svg> Fabric'
          : '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="3" y="3" width="18" height="18" rx="3"/></svg> Flat';
      }

      // Reset mode to color when opening
      activeMode = 'color';
      els.colorModeBtn.classList.add('vcp-mode-active');
      els.embModeBtn.classList.remove('vcp-mode-active');
      els.zoneListSection.style.display = '';
      els.embPreviewSection.style.display = 'none';
      // Palette hidden in color mode — mobile picker handles color selection
      els.palettePanel.style.display = 'none';
      // (selectionInfo removed)

      // Reset to cordura when opening
      activeMaterial = 'cordura';
      els.palTitle.textContent = 'Cordura Colors';
      els.palSub.textContent = 'Click a zone on the rig, then pick a color';
      if (els.stitchSection) els.stitchSection.style.display = 'none';
      // JC only visible on harness (hidden at start — cordura default)
      if (els.jcSection) els.jcSection.style.display = 'none';
      if (els.pipingSection) els.pipingSection.style.display = '';

      // Clear embroidery preview so it reloads fresh
      embroiderySvgDoc = null;
      if (els.embPreviewGrid) {
        els.embPreviewGrid.innerHTML = '';
      }
      selectedEmbroideryPosition = 'yoke';

      // Initialize undo/redo for this session
      undoStack.length = 0;
      redoStack.length = 0;
      _lastSnapshot = getStateSnapshot();
      _applyingUndoRedo = false;
      updateUndoRedoBtns();

      // Render
      refreshAllZoneFills();
      refreshZoneHighlights();
      updateSelectionInfo();
      updateZoneVisibility();
      renderStitchPicker();
      renderJCPicker();
      renderPipingToggle();
      if (els.search) { els.search.value = ''; els.search.style.display = ''; }
      renderFullPalette();
      showMobileColorPicker();

      // Pre-load embroidery symbols + logo transforms so yoke renders on rig immediately
      loadEmbroiderySymbols(function() {
        refreshRigEmbroideryLogos();
      });
      loadLogoTransforms(function() {
        refreshRigEmbroideryLogos();
      });

      // Show
      els.overlay.classList.add('vcp-open');
      state.isOpen = true;
      document.body.style.overflow = 'hidden';

      // ESC to close
      document.addEventListener('keydown', onKeyDown);

      // Mobile carousel: re-evaluate on resize/orientation
      window.addEventListener('resize', onResizeCarousel);

      // Analytics: color designer opened
      if (window.vcTrackEvent) window.vcTrackEvent('vc_color_designer_open', { pattern: pattern });
    });
  }

  function onResizeCarousel() {
    initRigCarousel();
  }

  function close() {
    els.overlay.classList.remove('vcp-open');
    state.isOpen = false;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeyDown);
    tooltipEl.classList.remove('vcp-tip-show');
    hideMobileColorPicker();
    window.removeEventListener('resize', onResizeCarousel);
    // Remove warning dialog if present
    var existingWarning = document.querySelector('.vcp-confirm-overlay');
    if (existingWarning) existingWarning.remove();

    // Analytics: color designer closed
    if (window.vcTrackEvent) window.vcTrackEvent('vc_color_designer_close', { pattern: currentPattern });
  }

  function showCloseWarning() {
    // If warning is already showing, do nothing
    if (document.querySelector('.vcp-confirm-overlay')) return;

    var overlay = el('div', 'vcp-confirm-overlay');
    var dialog = el('div', 'vcp-confirm-dialog');
    dialog.innerHTML =
      '<h3>Leave without saving?</h3>' +
      '<p>Your changes have not been saved. Do you want to save this design before leaving?</p>' +
      '<div class="vcp-confirm-actions">' +
        '<button class="vcp-confirm-discard">Leave without saving</button>' +
        '<button class="vcp-confirm-save">Save &amp; Close</button>' +
      '</div>';
    overlay.appendChild(dialog);
    els.overlay.appendChild(overlay);

    // Prevent clicks on the dialog from closing
    dialog.addEventListener('click', function (e) { e.stopPropagation(); });
    // Click on dark overlay dismisses warning (goes back to editing)
    overlay.addEventListener('click', function () { overlay.remove(); });

    dialog.querySelector('.vcp-confirm-discard').addEventListener('click', function () {
      overlay.remove();
      close();
    });
    dialog.querySelector('.vcp-confirm-save').addEventListener('click', function () {
      overlay.remove();
      handleSave();
    });
  }

  // Build legacy state.embroidery from V2 state so both formats are always current
  function syncEmbroideryLegacy() {
    if (!state.embCurrentLogoIndex) return;
    state.embroidery = {};
    Object.keys(EMB_LOGOS).forEach(function (side) {
      var logoIdx = state.embCurrentLogoIndex[side];
      if (logoIdx === undefined || logoIdx === null) return;
      var logos = EMB_LOGOS[side];
      if (!logos || !logos[logoIdx]) return;
      var logo = logos[logoIdx];
      if (logo.name === 'none') return; // skip "none" positions
      var entry = {
        type: logo.isCustomName ? 'custom_name' : logo.isCustomLogo ? 'custom_logo' : 'logo',
        logo: logo.name,
        symbol: logo.symbol || '',
        colors: {}
      };
      // Thread colors
      var sideColors = state.embLogoColors[side] || {};
      for (var slot = 1; slot <= (logo.colors || 0); slot++) {
        entry.colors[slot] = sideColors[slot] || 'black';
      }
      // Custom name text
      if (logo.isCustomName && state.embCustomNames[side]) {
        entry.customName = state.embCustomNames[side];
        entry.fontStyle = (state.embCustomFontStyle && state.embCustomFontStyle[side]) || 'script';
      }
      // Custom logo data
      if (logo.isCustomLogo && state.embCustomLogos && state.embCustomLogos[side]) {
        entry.customLogo = state.embCustomLogos[side];
      }
      // Angle
      if (state.embAngle45 && state.embAngle45[side]) {
        entry.angle45 = true;
      }
      state.embroidery[side] = entry;
    });
  }

  /**
   * Capture the rig SVG back-view as a PNG data URL (with flat colors + embroidery).
   * Replaces fabric texture patterns with flat hex to avoid tainted canvas.
   */
  /**
   * Capture all 4 rig views (back, front, right, left) as JPEG data URLs.
   * Returns an object: { back: dataUrl, front: dataUrl, right: dataUrl, left: dataUrl }
   * Also returns a legacy single back-view as previewPng for backward compat.
   */
  function captureRigPreviewPng(callback) {
    if (!els.rigSvg) { callback(null); return; }

    var VIEWS = [
      { key: 'back',  vb: '0 0 240 400' },
      { key: 'front', vb: '240 0 240 400' },
      { key: 'right', vb: '480 0 240 400' },
      { key: 'left',  vb: '720 0 240 400' }
    ];

    // Prepare a clean clone with flat colors (no texture patterns)
    function prepareClone(viewBox) {
      var clone = els.rigSvg.cloneNode(true);
      clone.setAttribute('viewBox', viewBox);
      clone.setAttribute('width', '240');
      clone.setAttribute('height', '400');
      clone.removeAttribute('style');

      var allZones = clone.querySelectorAll('[data-zone]');
      for (var i = 0; i < allZones.length; i++) {
        var fill = allZones[i].getAttribute('fill') || '';
        if (fill.indexOf('url(') === 0) {
          var zoneId = allZones[i].getAttribute('data-zone');
          var cId = state.colorMap[zoneId] || state.colorMap['trim:' + zoneId] || state.colorMap['harness:' + zoneId];
          var c = cId ? colorById(cId) : null;
          allZones[i].setAttribute('fill', c ? c.hex : '#888');
        }
      }

      var patterns = clone.querySelectorAll('pattern');
      for (var p = 0; p < patterns.length; p++) {
        // Keep JC crosshatch pattern for screenshot capture
        if (patterns[p].id === 'vcp-jc-crosshatch-l' || patterns[p].id === 'vcp-jc-crosshatch-r') continue;
        if (patterns[p].parentNode) patterns[p].parentNode.removeChild(patterns[p]);
      }
      return clone;
    }

    var results = {};
    var done = 0;

    function captureView(view) {
      var clone = prepareClone(view.vb);
      var svgStr = new XMLSerializer().serializeToString(clone);
      var blob = new Blob([svgStr], { type: 'image/svg+xml;charset=utf-8' });
      var blobUrl = URL.createObjectURL(blob);

      var img = new Image();
      img.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = 480;
        canvas.height = 800;
        var ctx = canvas.getContext('2d');
        ctx.fillStyle = '#f7f8fa';
        ctx.fillRect(0, 0, 480, 800);
        ctx.drawImage(img, 0, 0, 480, 800);
        URL.revokeObjectURL(blobUrl);
        try {
          results[view.key] = canvas.toDataURL('image/png');
        } catch (e) {
          console.warn('[VCP] Screenshot capture failed for', view.key, e);
          results[view.key] = null;
        }
        done++;
        if (done === VIEWS.length) finish();
      };
      img.onerror = function () {
        URL.revokeObjectURL(blobUrl);
        console.warn('[VCP] Screenshot image load failed for', view.key);
        results[view.key] = null;
        done++;
        if (done === VIEWS.length) finish();
      };
      img.src = blobUrl;
    }

    function finish() {
      // Return back-view as legacy previewPng for backward compat, plus all views
      var legacy = results.back || null;
      callback(legacy, results);
    }

    for (var v = 0; v < VIEWS.length; v++) {
      captureView(VIEWS[v]);
    }
  }

  function handleSave() {
    // Validate design name is not empty
    var name = (state.designName || '').trim();
    if (name.length < 2) {
      if (els.designNameInput) {
        els.designNameInput.classList.add('vcp-design-name-error');
        els.designNameInput.focus();
      }
      var errEl = document.getElementById('vcp-design-name-err');
      if (errEl) errEl.style.display = '';
      return;
    }
    state.designName = name;

    // Sync V2 embroidery state into legacy format before saving
    syncEmbroideryLegacy();
    saveDraft();

    // Build save data
    var embData = JSON.parse(JSON.stringify(state.embroidery));
    embData._v2 = {
      currentLogoIndex: JSON.parse(JSON.stringify(state.embCurrentLogoIndex)),
      logoColors: JSON.parse(JSON.stringify(state.embLogoColors)),
      customNames: JSON.parse(JSON.stringify(state.embCustomNames)),
      customFontStyle: JSON.parse(JSON.stringify(state.embCustomFontStyle)),
      angle45: JSON.parse(JSON.stringify(state.embAngle45)),
      notes: state.embNotes || '',
      customLogos: state.embCustomLogos ? JSON.parse(JSON.stringify(state.embCustomLogos)) : {}
    };
    var colorMapCopy = JSON.parse(JSON.stringify(state.colorMap));
    var quickOptions = {
      contrastStitch: state.contrastStitch,
      stitchColor: state.stitchColor,
      jcStitching: state.jcStitching,
      jcColor: state.jcColor,
      pipingEnabled: state.pipingEnabled
    };
    var designName = state.designName;

    // Capture rig preview screenshots (async — all 4 views), then fire callback and close
    captureRigPreviewPng(function (previewPng, previewPngs) {
      if (state.onSave) {
        state.onSave(colorMapCopy, embData, quickOptions, designName, previewPng, previewPngs);
      }

      // Phase 3: Forward design save + custom logos to backend
      notifyBackendDesignSave();

      // Analytics: design saved
      if (window.vcTrackEvent) window.vcTrackEvent('vc_design_save', {
        design_name: designName,
        pattern: currentPattern,
        has_embroidery: Object.keys(state.embroidery || {}).length > 0
      });

      close();
    });
  }

  function notifyBackendDesignSave() {
    var container = document.getElementById('vc-container');
    var backendUrl = container ? (container.dataset.backendUrl || '') : '';
    if (!backendUrl) return;

    // Collect custom logos
    var hasCustomLogos = false;
    var logoMeta = [];
    Object.keys(POSITION_SIDES).forEach(function(posKey) {
      POSITION_SIDES[posKey].forEach(function(side) {
        if (state.embCustomLogos && state.embCustomLogos[side] && state.embCustomLogos[side].dataUrl) {
          hasCustomLogos = true;
          logoMeta.push({
            side: side,
            rotation: state.embCustomLogos[side].rotation || 0,
            dstFilename: (state.embDstFilenames && state.embDstFilenames[side]) || '',
            notes: (state.embNotes && typeof state.embNotes === 'object' && state.embNotes[side]) || (typeof state.embNotes === 'string' ? state.embNotes : '')
          });
        }
      });
    });

    // Read contact info from localStorage
    var contact = {};
    try {
      var raw = localStorage.getItem('vc-user-contact');
      if (raw) contact = JSON.parse(raw);
    } catch (e) { /* silent */ }

    // Send design metadata (logos as base64 via JSON for simplicity)
    var payload = {
      sessionId: contact.sessionId || '',
      email: contact.email || '',
      phone: contact.phone || '',
      designName: state.designName,
      hasCustomLogos: hasCustomLogos,
      logoMeta: logoMeta,
      timestamp: new Date().toISOString()
    };

    // If there are custom logos, include their data URLs
    if (hasCustomLogos) {
      payload.customLogos = [];
      Object.keys(POSITION_SIDES).forEach(function(posKey) {
        POSITION_SIDES[posKey].forEach(function(side) {
          if (state.embCustomLogos && state.embCustomLogos[side] && state.embCustomLogos[side].dataUrl) {
            payload.customLogos.push({
              side: side,
              dataUrl: state.embCustomLogos[side].dataUrl,
              rotation: state.embCustomLogos[side].rotation || 0
            });
          }
        });
      });
    }

    try {
      fetch(backendUrl + '/api/funnel/design-save', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function() {});
    } catch (e) { /* silent */ }
  }

  function onKeyDown(e) {
    // Undo: Ctrl+Z (not inside text inputs)
    if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) {
      var tag = (e.target.tagName || '').toLowerCase();
      if (tag !== 'input' && tag !== 'textarea') {
        e.preventDefault();
        undoAction();
        return;
      }
    }
    // Redo: Ctrl+Y or Ctrl+Shift+Z (not inside text inputs)
    if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || (e.key === 'z' && e.shiftKey))) {
      var tag2 = (e.target.tagName || '').toLowerCase();
      if (tag2 !== 'input' && tag2 !== 'textarea') {
        e.preventDefault();
        redoAction();
        return;
      }
    }
    if (e.key === 'Escape') {
      // If warning is already showing, dismiss it (go back to editing)
      var existingWarning = document.querySelector('.vcp-confirm-overlay');
      if (existingWarning) { existingWarning.remove(); return; }
      showCloseWarning();
    }
  }

  /* ================================================================
     SUMMARY RENDERER (called from main configurator after save)
     ================================================================ */
  function renderSummary(containerEl, colorMap) {
    containerEl.innerHTML = '';

    var wrap = el('div', 'vcp-summary-wrap');

    // Header
    var header = el('div', 'vcp-summary-header');
    var title = el('span', 'vcp-summary-title');
    title.textContent = 'Container Colors';
    header.appendChild(title);
    var editBtn = el('button', 'vcp-summary-edit');
    editBtn.textContent = 'Edit Colors';
    editBtn.addEventListener('click', function () {
      if (window.VectorColorPopup) window.VectorColorPopup.open(colorMap);
    });
    header.appendChild(editBtn);
    wrap.appendChild(header);

    // Body: zone list grouped by section
    var body = el('div', 'vcp-summary-body');

    var list = el('div', 'vcp-summary-list');
    var sections = [
      { name: 'Yoke',       ids: ['c7c', 'c7a', 'c7b', 'c7d'] },
      { name: 'Upper',      ids: ['c6a', 'c6b'] },
      { name: 'Sides',      ids: ['c5a', 'c5b'] },
      { name: 'Main',       ids: ['c3a', 'c2', 'c2b', 'c3b'] },
      { name: 'Lower',      ids: ['c1a', 'c4', 'c4b', 'c1b', 'c1c', 'c1d'] },
      { name: 'V-Split',    ids: ['c9a', 'c9b', 'c9c'] },
      { name: 'Reserve',    ids: ['c8a', 'c8b'] },
      { name: 'Flaps',      ids: ['cfa', 'cfb', 'cfc', 'cfd', 'cfdb', 'cfe', 'cff', 'cfg'] },
      { name: 'Handles',    ids: ['hcut', 'hres'] },
      { name: 'Pads',       ids: ['backp', 'lpad', 'rpad'] },
      { name: 'Stabilizers',ids: ['c1astab', 'c1bstab'] }
    ];
    sections.forEach(function (sec) {
      sec.ids.forEach(function (id) {
        if (!colorMap[id]) return;
        var c = colorById(colorMap[id]);
        var item = el('div', 'vcp-summary-item');
        var dot = el('span', 'vcp-summary-dot');
        dot.style.background = c.hex;
        item.appendChild(dot);
        var zone = el('span', 'vcp-summary-zone');
        zone.textContent = zoneLabel(id) + ':';
        item.appendChild(zone);
        var name = document.createTextNode(' ' + c.name);
        item.appendChild(name);
        list.appendChild(item);
      });
    });
    body.appendChild(list);
    wrap.appendChild(body);

    containerEl.appendChild(wrap);
  }

  /* ================================================================
     PUBLIC API
     ================================================================ */
  // Render embroidery logos on an external SVG (e.g. Stage 2 preview rig)
  // Uses the current embroidery state from the popup
  // Apply fabric texture patterns to any rig SVG (popup rig or external preview rig)
  // Uses the same ensureTexturePattern approach but on an arbitrary SVG element
  function applyFabricTexturesToRigSvg(svg, colorMap) {
    if (!svg || !colorMap) return;
    var allZones = ALL_ZONE_IDS.concat(TRIM_ZONES, HARNESS_ZONES, PIPING_ZONES);

    // Ensure root-level <defs> exists
    var defs = getOrCreateRootDefs(svg);

    allZones.forEach(function(zoneId) {
      var colorKey;
      var defaultColor = 'black';
      if (HARNESS_ZONES.indexOf(zoneId) !== -1) {
        colorKey = 'harness:' + zoneId;
        defaultColor = 'hw-black';
      } else if (TRIM_ZONES.indexOf(zoneId) !== -1) {
        colorKey = 'trim:' + zoneId;
        defaultColor = 'tt-black';
      } else {
        colorKey = zoneId;
      }
      var c = colorById(colorMap[colorKey] || defaultColor);
      if (!c) return;

      var paths = svg.querySelectorAll('[data-zone="' + zoneId + '"]');
      if (!paths.length) return;

      var fillValue = c.hex;
      var isHW = HARNESS_ZONES.indexOf(zoneId) !== -1;
      if (c.img) {
        var patId = 'vcp-pat-' + c.id + (isHW ? '-hw' : '');
        if (!svg.getElementById(patId)) {
          var TILE = isHW ? 80 : 260;
          var pat = document.createElementNS('http://www.w3.org/2000/svg', 'pattern');
          pat.setAttribute('id', patId);
          pat.setAttribute('patternUnits', 'userSpaceOnUse');
          pat.setAttribute('width', String(TILE));
          pat.setAttribute('height', String(TILE));
          var img = document.createElementNS('http://www.w3.org/2000/svg', 'image');
          img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', c.img);
          img.setAttribute('width', String(TILE));
          img.setAttribute('height', String(TILE));
          img.setAttribute('preserveAspectRatio', 'xMidYMid slice');
          pat.appendChild(img);
          defs.appendChild(pat);
        }
        fillValue = 'url(#' + patId + ')';
      }
      for (var i = 0; i < paths.length; i++) {
        paths[i].setAttribute('fill', fillValue);
      }
    });
  }

  function renderEmbroideryOnExternalSvg(svg) {
    if (!svg) return;
    injectSymbolsIntoSvg(svg);
    var NS = 'http://www.w3.org/2000/svg';

    var existing = svg.getElementById('rig_emb_overlay');
    if (existing) existing.parentNode.removeChild(existing);

    // Remove old clip defs if they exist
    var oldClipDefs = svg.getElementById('ext_emb_clip_defs');
    if (oldClipDefs) oldClipDefs.parentNode.removeChild(oldClipDefs);

    // Add clip path definitions at SVG root level for browser compatibility
    var clipDefs = document.createElementNS(NS, 'defs');
    clipDefs.setAttribute('id', 'ext_emb_clip_defs');
    // Rectangular clips for non-sidewall positions
    var clips = {
      'ext_clip_bp':         { x: 325, y: 90,  w: 80,  h: 145 },
      'ext_clip_rc':         { x: 375, y: 80,  w: 70,  h: 90  },
      'ext_clip_rcr':        { x: 280, y: 80,  w: 65,  h: 90  },
      'ext_clip_hres':       { x: 385, y: 170, w: 50,  h: 65  },
      'ext_clip_hcut':       { x: 305, y: 170, w: 50,  h: 65  },
      'ext_clip_hres_left':  { x: 770, y: 170, w: 45,  h: 65  },
      'ext_clip_hcut_right': { x: 650, y: 170, w: 50,  h: 65  },
      'ext_clip_yk':         { x: 70,  y: 25,  w: 100, h: 50  }
    };
    Object.keys(clips).forEach(function(id) {
      var cp = document.createElementNS(NS, 'clipPath');
      cp.setAttribute('id', id);
      var r = document.createElementNS(NS, 'rect');
      r.setAttribute('x', clips[id].x); r.setAttribute('y', clips[id].y);
      r.setAttribute('width', clips[id].w); r.setAttribute('height', clips[id].h);
      cp.appendChild(r);
      clipDefs.appendChild(cp);
    });
    // Panel-shaped clips for sidewalls — use actual c1a/c1b SVG paths
    var c1aPath = svg.getElementById('c1a');
    if (c1aPath) {
      var cpSW = document.createElementNS(NS, 'clipPath');
      cpSW.setAttribute('id', 'ext_clip_sw_panel');
      var useSW = document.createElementNS(NS, 'use');
      useSW.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#c1a');
      useSW.setAttribute('href', '#c1a');
      cpSW.appendChild(useSW);
      clipDefs.appendChild(cpSW);
    }
    var c1bPath = svg.getElementById('c1b');
    if (c1bPath) {
      var cpSWR = document.createElementNS(NS, 'clipPath');
      cpSWR.setAttribute('id', 'ext_clip_swr_panel');
      var useSWR = document.createElementNS(NS, 'use');
      useSWR.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#c1b');
      useSWR.setAttribute('href', '#c1b');
      cpSWR.appendChild(useSWR);
      clipDefs.appendChild(cpSWR);
    }
    svg.insertBefore(clipDefs, svg.firstChild);

    var overlay = document.createElementNS(NS, 'g');
    overlay.setAttribute('id', 'rig_emb_overlay');
    overlay.setAttribute('pointer-events', 'none');
    svg.appendChild(overlay);

    // Helper: render custom text into a group (mirrors renderRigCustomText)
    function renderExtCustomText(g, baseSide, transformKey) {
      var trKey = transformKey || baseSide;
      var tr = RIG_CUSTOM_TRANSFORMS.custom_name[trKey];
      if (!tr) return;
      var fontStyle = state.embCustomFontStyle[baseSide] || 'script';
      var colorId = state.embLogoColors[baseSide] ? state.embLogoColors[baseSide][1] : 'black';
      var color = embThreadColor(colorId);
      var fillColor = color ? color.hex : '#000';
      var is45 = state.embAngle45[baseSide] && tr.angle45 !== undefined;
      var posX = (is45 && tr.x45 !== undefined) ? tr.x45 : tr.x;
      var posY = (is45 && tr.y45 !== undefined) ? tr.y45 : tr.y;
      var angle = is45 ? tr.angle45 : (tr.angle || 0);
      var fSize = (is45 && tr.fontSize45) ? tr.fontSize45 : (tr.fontSize || 10);

      if (tr.lines === 3) {
        var names = state.embCustomNames[baseSide];
        if (typeof names !== 'object') names = { line1: '', line2: '', line3: '' };
        var lineH = tr.lineHeight || 9;
        var positions = [posY - lineH, posY, posY + lineH];
        for (var li = 0; li < 3; li++) {
          var txt = names['line' + (li + 1)] || '';
          if (!txt) continue;
          var tel = document.createElementNS(NS, 'text');
          tel.textContent = txt;
          tel.setAttribute('x', posX);
          tel.setAttribute('y', positions[li]);
          tel.setAttribute('font-size', fSize);
          tel.setAttribute('text-anchor', 'middle');
          tel.setAttribute('fill', fillColor);
          if (fontStyle === 'script') {
            tel.setAttribute('font-family', 'Georgia, Times, serif');
            tel.setAttribute('font-style', 'italic');
          } else {
            tel.setAttribute('font-family', 'Arial, Helvetica, sans-serif');
            tel.setAttribute('font-weight', 'bold');
          }
          if (angle !== 0) tel.setAttribute('transform', 'rotate(' + angle + ' ' + posX + ' ' + posY + ')');
          g.appendChild(tel);
        }
      } else {
        var text = state.embCustomNames[baseSide] || '';
        if (typeof text === 'object') text = text.line2 || text.line1 || '';
        if (!text) return;
        var textEl = document.createElementNS(NS, 'text');
        textEl.textContent = text;
        textEl.setAttribute('x', posX);
        textEl.setAttribute('y', posY);
        textEl.setAttribute('font-size', fSize);
        textEl.setAttribute('text-anchor', 'middle');
        textEl.setAttribute('fill', fillColor);
        if (fontStyle === 'script') {
          textEl.setAttribute('font-family', 'Georgia, Times, serif');
          textEl.setAttribute('font-style', 'italic');
        } else {
          textEl.setAttribute('font-family', 'Arial, Helvetica, sans-serif');
          textEl.setAttribute('font-weight', 'bold');
        }
        if (angle !== 0) textEl.setAttribute('transform', 'rotate(' + angle + ' ' + posX + ' ' + posY + ')');
        g.appendChild(textEl);
      }
    }

    // Helper: render custom logo image into a group (mirrors renderRigCustomImage)
    function renderExtCustomImage(g, baseSide, transformKey) {
      var trKey = transformKey || baseSide;
      var tr = RIG_CUSTOM_TRANSFORMS.custom_logo[trKey];
      var logoData = state.embCustomLogos[baseSide];
      if (!tr || !logoData || !logoData.dataUrl) return;
      var posX = tr.x;
      var posY = tr.y;
      var baseAngle = (state.embAngle45[baseSide] && tr.angle45 !== undefined) ? tr.angle45 : (tr.angle || 0);
      var angle = baseAngle + (logoData.rotation || 0);
      var cx = posX + tr.w / 2;
      var cy = posY + tr.h / 2;
      var img = document.createElementNS(NS, 'image');
      img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', logoData.dataUrl);
      img.setAttribute('width', tr.w);
      img.setAttribute('height', tr.h);
      img.setAttribute('x', posX);
      img.setAttribute('y', posY);
      if (angle !== 0) img.setAttribute('transform', 'rotate(' + angle + ' ' + cx + ' ' + cy + ')');
      g.appendChild(img);
    }

    // Helper to render one side's logo into the overlay
    // transformKey: optional override for custom text/image lookup (e.g. 'sw_back')
    function renderSideLogo(baseSide, varrayKey, transformKey, clipId) {
      var logos = EMB_LOGOS[baseSide];
      if (!logos) return;
      var idx = state.embCurrentLogoIndex[baseSide] || 0;
      var logo = logos[idx];
      if (!logo || logo.name === 'none') return;

      var g = document.createElementNS(NS, 'g');
      if (clipId) g.setAttribute('clip-path', 'url(#' + clipId + ')');
      overlay.appendChild(g);

      // Custom text
      if (logo.isCustomName) {
        renderExtCustomText(g, baseSide, transformKey);
        return;
      }
      // Custom image
      if (logo.isCustomLogo) {
        renderExtCustomImage(g, baseSide, transformKey);
        return;
      }

      // Standard logo via VArray (transforms already contain correct positions)
      var varrayList = RIG_VARRAY_TRANSFORMS[varrayKey] || RIG_VARRAY_TRANSFORMS[baseSide];
      if (!varrayList) return;
      var vdata = null;
      for (var v = 0; v < varrayList.length; v++) {
        if (varrayList[v].name === logo.name) { vdata = varrayList[v]; break; }
      }
      if (!vdata || !vdata.layers || vdata.layers.length === 0) return;

      // Backpad logos shifted up 10px on rig
      var bpDy = (baseSide === 'bp') ? -10 : 0;

      for (var i = 1; i <= logo.colors; i++) {
        var symbolId = (logo.specialSymbols && logo.specialSymbols[i - 1])
          ? logo.specialSymbols[i - 1]
          : (vdata.sym || logo.symbol) + '_c' + i;
        var use = document.createElementNS(NS, 'use');
        use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + symbolId);
        use.setAttribute('href', '#' + symbolId);
        var layer = vdata.layers[i - 1];
        if (layer) {
          use.setAttribute('width', layer.w);
          use.setAttribute('height', layer.h);
          use.setAttribute('x', layer.x);
          use.setAttribute('y', layer.y);
          var matStr = layer.t;
          if (bpDy !== 0) {
            var parts = matStr.split(/[\s,]+/);
            parts[5] = String(parseFloat(parts[5]) + bpDy);
            matStr = parts.join(',');
          }
          use.setAttribute('transform', 'matrix(' + matStr + ')');
        }
        var colorId = state.embLogoColors[baseSide] ? state.embLogoColors[baseSide][i] : null;
        var color = colorId ? embThreadColor(colorId) : null;
        if (color) use.setAttribute('fill', color.hex);
        g.appendChild(use);
      }
    }

    // Clip map for all standard sides
    var extClipMap = {
      'sw': 'ext_clip_sw_panel', 'swr': 'ext_clip_swr_panel',
      'bp': 'ext_clip_bp', 'rf': 'maskRF_1_',
      'rc': 'ext_clip_rc', 'rcr': 'ext_clip_rcr',
      'hres': 'ext_clip_hres', 'hcut': 'ext_clip_hcut',
      'yk': 'ext_clip_yk'
    };

    // Render all standard sides (with clipping for every position)
    var sides = ['yk', 'sw', 'swr', 'rc', 'rcr', 'hcut', 'hres', 'bp', 'rf'];
    sides.forEach(function(side) {
      var varrayKey = side;
      if ((side === 'sw' || side === 'swr') && state.embAngle45[side]) {
        varrayKey = side + '45';
      }
      renderSideLogo(side, varrayKey, null, extClipMap[side] || null);
    });

    // Render BACK view sidewall duplicates (only when 45° enabled, using dedicated VOS transforms)
    ['sw', 'swr'].forEach(function(baseSide) {
      if (!state.embAngle45[baseSide]) return;
      var backSide = baseSide + '_back';
      var clipId = 'ext_clip_' + baseSide + '_panel';
      renderSideLogo(baseSide, backSide, backSide, clipId);
    });

    // Render handle side view duplicates (reserve on LEFT, cutaway on RIGHT)
    renderSideLogo('hres', 'hres_left', 'hres_left', 'ext_clip_hres_left');
    renderSideLogo('hcut', 'hcut_right', 'hcut_right', 'ext_clip_hcut_right');
  }

  /** Inject a custom logo dataUrl for a specific side (e.g. 'sw','swr','yk').
   *  Call AFTER open() so state is initialized. */
  function setCustomLogo(side, dataUrl) {
    if (!state.embCustomLogos) state.embCustomLogos = {};
    state.embCustomLogos[side] = { dataUrl: dataUrl, rotation: 0 };
  }

  /** Sync VCP internal embroidery state from external _v2 data.
   *  Call this when switching design slots or applying AI designs
   *  so the rig preview shows the correct embroidery.
   *  Pass refreshRig=true to also update the main rig SVG overlay. */
  function syncEmbroideryFromV2(v2Data, refreshRig) {
    if (!v2Data) return;
    initEmbroideryV2State();
    if (v2Data.currentLogoIndex) state.embCurrentLogoIndex = v2Data.currentLogoIndex;
    if (v2Data.logoColors) state.embLogoColors = v2Data.logoColors;
    if (v2Data.customNames) state.embCustomNames = v2Data.customNames;
    if (v2Data.customFontStyle) state.embCustomFontStyle = v2Data.customFontStyle;
    if (v2Data.angle45) state.embAngle45 = v2Data.angle45;
    if (v2Data.notes) state.embNotes = v2Data.notes;
    if (v2Data.customLogos) state.embCustomLogos = v2Data.customLogos;
    if (refreshRig !== false) refreshRigEmbroideryLogos();
  }

  window.VectorColorPopup = {
    open: open,
    close: close,
    renderSummary: renderSummary,
    colorById: colorById,
    ALL_ZONE_IDS: ALL_ZONE_IDS,
    EMBROIDERY_POSITIONS: EMBROIDERY_POSITIONS,
    EMBROIDERY_COLORS: EMBROIDERY_COLORS,
    EMBROIDERY_LOGOS: EMBROIDERY_LOGOS,
    EMB_LOGOS: EMB_LOGOS,
    renderEmbroideryOnSvg: renderEmbroideryOnExternalSvg,
    loadEmbroiderySymbols: loadEmbroiderySymbols,
    applyFabricTextures: applyFabricTexturesToRigSvg,
    setCustomLogo: setCustomLogo,
    syncEmbroideryFromV2: syncEmbroideryFromV2
  };

})();
